/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 * OpenAPI spec version: 1.0.0
 */
export interface DnspForProject {
    project?: string;
    dnsps?: string[];
}

export interface AccessTagsResponse {
    /** True if this is the complete list of tags. This is the case if you are allowed to see all tags in the system (ie you are admin, or mineOnly=false) */
    isComplete?: boolean;
    projectAccessTags?: string[];
    dnspAccessTags?: string[];
    /** The mapping of projects to DNSPs (eg, REVS has ActewAgl, JemenaProject has AusNet, Evo, Jemena, TasNetworks, United). */
    dnspsForProjects?: DnspForProject[];
}

export interface ActivateTask {
    activate?: boolean;
}

export type ActiveProfileSnapshotDtoProfileType =
    (typeof ActiveProfileSnapshotDtoProfileType)[keyof typeof ActiveProfileSnapshotDtoProfileType];

export const ActiveProfileSnapshotDtoProfileType = {
    Default: "Default",
    Failsafe: "Failsafe",
    TimeOfUse: "TimeOfUse",
    Trigger: "Trigger",
    Remote: "Remote",
    Unknown: "Unknown",
} as const;

export interface ActiveProfileSnapshotDto {
    uniqueId?: string;
    targetDistributionBoardId?: string;
    profileType?: ActiveProfileSnapshotDtoProfileType;
    limitL1Amps?: number;
    limitL2Amps?: number;
    limitL3Amps?: number;
    activationDeviceIds?: string[];
}

export interface AddressDto {
    /** Street name and number. Required */
    address1?: string;
    address2?: string;
    city?: string;
    stateCode?: string;
    postCode?: string;
    /** 2 letter ISO country code. Required */
    countryCode?: string;
    latitude?: number;
    longitude?: number;
    timeZone?: string;
    /** Optional Google Place Id, can be used to link to a specific listing in Maps rather than just lat/lng. Eg https://www.google.com/maps/place/?q=place_id:{placeId} */
    googlePlaceId?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface AggregatedUptimeResponse {
    /** The aggregated uptime. Offline periods are not considered in the availability calculation. i.e., devices assumed to be continuously online. */
    uptimeOfflineIncluded?: number;
    /** The aggregated uptime. Offline periods are removed from the availability calculation. */
    uptimeOfflineExcluded?: number;
    /** The preferred uptime value based on organisation preference. Defaults to UptimeOfflineIncluded if preference not set. */
    preferredUptime?: number;
    /** Indicates which calculation method was used for PreferredUptime. true = offline included, false = offline excluded. */
    isOfflineIncluded?: boolean;
    /** Percentage change compared to the previous period of the same duration. Positive values indicate improvement. */
    percentageChange?: number;
    /** Calculation period start. */
    periodStart?: Date;
    /** Calculation period end. */
    periodEnd?: Date;
}

export interface AiChatbotRequest {
    question?: string;
}

export type AlertDtoType = (typeof AlertDtoType)[keyof typeof AlertDtoType];

export const AlertDtoType = {
    Unknown: "Unknown",
    FrequentFaults: "FrequentFaults",
    ShortDuration: "ShortDuration",
    NoActivity: "NoActivity",
    ZerokWh: "ZerokWh",
    PowerLoss: "PowerLoss",
    FrequentReconnects: "FrequentReconnects",
    EnergyPriceChargingSuspended: "EnergyPriceChargingSuspended",
    LowEnergyMidSession: "LowEnergyMidSession",
} as const;

export interface AlertDto {
    alertId?: number;
    deviceIdentity?: string;
    deviceFriendlyName?: string;
    serviceModelDeviceGroupTag?: string;
    siteDeviceGroupTag?: string;
    siteName?: string;
    organisationId?: string;
    organisationName?: string;
    alertCount?: number;
    type?: AlertDtoType;
    description?: string;
    createdAt?: Date;
    expiredAt?: Date;
    updatedAt?: Date;
}

export interface ApiFieldValidationResult {
    fieldName?: string;
    /** 1-based row reference for validation result. 0 indicates validation result for whole column */
    row?: number;
    /** 1-based column reference for validation result. 0 indicates validation result for whole row */
    column?: number;
    /** If non-zero, check Message for the error description */
    errorNo?: number;
    message?: string;
    identity?: number;
    identityStr?: string;
}

export interface ApiBulkUploadValidationResult {
    timestamp?: Date;
    validationResults?: ApiFieldValidationResult[];
    /** If non-zero, check Message for the error description */
    errorNo?: number;
    message?: string;
    identity?: number;
    identityStr?: string;
}

export interface ApiResult {
    /** If non-zero, check Message for the error description */
    errorNo?: number;
    message?: string;
    identity?: number;
    identityStr?: string;
}

export interface ApiMultipleResult {
    extras?: ApiResult[];
    /** If non-zero, check Message for the error description */
    errorNo?: number;
    message?: string;
    identity?: number;
    identityStr?: string;
}

/**
 * Connector↔meter linkage test status.
 */
export type AsatConnectorResultDtoStatus =
    (typeof AsatConnectorResultDtoStatus)[keyof typeof AsatConnectorResultDtoStatus];

export const AsatConnectorResultDtoStatus = {
    Unknown: "Unknown",
    Pending: "Pending",
    InProgress: "InProgress",
    Passed: "Passed",
    Failed: "Failed",
    Inconclusive: "Inconclusive",
} as const;

/**
 * Failure code when status is Failed; otherwise null.
 */
export type AsatConnectorResultDtoFailureCode =
    (typeof AsatConnectorResultDtoFailureCode)[keyof typeof AsatConnectorResultDtoFailureCode];

export const AsatConnectorResultDtoFailureCode = {
    Unknown: "Unknown",
    NoDrop: "NoDrop",
    DropMismatch: "DropMismatch",
} as const;

export interface AsatConnectorResultDto {
    /** Charger UniqueId (from CoreConfig). */
    chargerUniqueId?: string;
    /** 1-based connector number within the charger. */
    connectorNumber?: number;
    /** Power meter above the connector this result tests the linkage to. */
    powerMeterUniqueId?: string;
    /** Connector↔meter linkage test status. */
    status?: AsatConnectorResultDtoStatus;
    /** Number of evaluation attempts made. */
    attemptCount?: number;
    /** Failure code when status is Failed; otherwise null. */
    failureCode?: AsatConnectorResultDtoFailureCode;
    /** Human-readable detail about the result; null when cleared on run start/reset. */
    detail?: string;
    /** When the latest attempt started (UTC). */
    lastAttemptStartedAtUtc?: Date;
    /** When the latest attempt completed (UTC). */
    lastAttemptCompletedAtUtc?: Date;
}

/**
 * Run-level status. InProgress is the only live state; the rest are terminal (the run has stopped).
 */
export type AsatDtoStatus = (typeof AsatDtoStatus)[keyof typeof AsatDtoStatus];

export const AsatDtoStatus = {
    Unknown: "Unknown",
    Pending: "Pending",
    InProgress: "InProgress",
    Passed: "Passed",
    Failed: "Failed",
    Inconclusive: "Inconclusive",
} as const;

/**
 * Why the run stopped (Manual or DurationLimit); null while running.
 */
export type AsatDtoStoppedReason =
    (typeof AsatDtoStoppedReason)[keyof typeof AsatDtoStoppedReason];

export const AsatDtoStoppedReason = {
    Unknown: "Unknown",
    Manual: "Manual",
    DurationLimit: "DurationLimit",
} as const;

/**
 * Power meter phase status.
 */
export type AsatPowerMeterResultDtoStatus =
    (typeof AsatPowerMeterResultDtoStatus)[keyof typeof AsatPowerMeterResultDtoStatus];

export const AsatPowerMeterResultDtoStatus = {
    Unknown: "Unknown",
    Pending: "Pending",
    InProgress: "InProgress",
    Passed: "Passed",
    Failed: "Failed",
    Inconclusive: "Inconclusive",
} as const;

/**
 * Failure code when status is Failed; otherwise null.
 */
export type AsatPowerMeterResultDtoFailureCode =
    (typeof AsatPowerMeterResultDtoFailureCode)[keyof typeof AsatPowerMeterResultDtoFailureCode];

export const AsatPowerMeterResultDtoFailureCode = {
    Unknown: "Unknown",
    VoltageOutOfRange: "VoltageOutOfRange",
    PowerFactorOutOfRange: "PowerFactorOutOfRange",
    CurrentTransformerBackwards: "CurrentTransformerBackwards",
} as const;

export interface AsatPowerMeterResultDto {
    /** Power meter UniqueId (from CoreConfig). */
    powerMeterUniqueId?: string;
    /** 1-based electrical phase (1, 2 or 3) this result applies to. */
    phase?: number;
    /** Power meter phase status. */
    status?: AsatPowerMeterResultDtoStatus;
    /** Failure code when status is Failed; otherwise null. */
    failureCode?: AsatPowerMeterResultDtoFailureCode;
    /** Human-readable detail about the result; null when cleared on reset. */
    detail?: string;
}

export interface AsatDto {
    /** CORE device identity (e.g. "TC0004"). */
    deviceIdentity?: string;
    /** Run-level status. InProgress is the only live state; the rest are terminal (the run has stopped). */
    status?: AsatDtoStatus;
    /** Why the run stopped (Manual or DurationLimit); null while running. */
    stoppedReason?: AsatDtoStoppedReason;
    /** When the current run started (UTC). */
    startedAtUtc?: Date;
    /** When the run completed (UTC); null while running. */
    completedAtUtc?: Date;
    /** UniqueId of the CORE config frozen for this run; null if the run has never been started. */
    coreConfigurationId?: string;
    /** Per-connector test results. */
    connectorResults?: AsatConnectorResultDto[];
    /** Per-power-meter test results. */
    powerMeterResults?: AsatPowerMeterResultDto[];
}

export type BalenaDeviceDtoUpdateStatus =
    (typeof BalenaDeviceDtoUpdateStatus)[keyof typeof BalenaDeviceDtoUpdateStatus];

export const BalenaDeviceDtoUpdateStatus = {
    rejected: "rejected",
    downloading: "downloading",
    downloaded: "downloaded",
    applying_changes: "applying changes",
    aborted: "aborted",
    done: "done",
} as const;

export interface BalenaDeviceDto {
    ipAddress?: string;
    belongsToFleetId?: number;
    runningReleaseId?: number;
    targetReleaseId?: number;
    updateStatus?: BalenaDeviceDtoUpdateStatus;
}

export type BalenaDeviceNotificationMessageUpdateStatus =
    (typeof BalenaDeviceNotificationMessageUpdateStatus)[keyof typeof BalenaDeviceNotificationMessageUpdateStatus];

export const BalenaDeviceNotificationMessageUpdateStatus = {
    rejected: "rejected",
    downloading: "downloading",
    downloaded: "downloaded",
    applying_changes: "applying changes",
    aborted: "aborted",
    done: "done",
} as const;

export type BalenaDeviceNotificationMessageDeviceType =
    (typeof BalenaDeviceNotificationMessageDeviceType)[keyof typeof BalenaDeviceNotificationMessageDeviceType];

export const BalenaDeviceNotificationMessageDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

/**
 * Objects of type BalenaDeviceNotificationMessage are sent to hub method named balenaDeviceNotificationMessage in the device group device_<deviceId>. Listen to it via `signalRHub.on('balenaDeviceNotificationMessage', (message: BalenaDeviceNotificationMessage) => {}`
 */
export interface BalenaDeviceNotificationMessage {
    deviceId?: string;
    deviceUUID?: string;
    runningReleaseId?: number;
    targetReleaseId?: number;
    updateStatus?: BalenaDeviceNotificationMessageUpdateStatus;
    deviceType?: BalenaDeviceNotificationMessageDeviceType;
}

export interface BalenaReleaseDto {
    id?: number;
    semVersion?: string;
    createdAt?: Date;
    isValid?: boolean;
}

export interface BaseReportRequest {
    /** Date from, inclusive. Date only, eg '2023-10-04'. Reports are run using AEST only (UTC+10, no daylight savings) */
    dateFrom?: string;
    /** Date to, inclusive. Date only, eg '2023-10-04'. Reports are run using AEST only (UTC+10, no daylight savings) */
    dateTo?: string;
    /** Report is run for all operational devices in this group. Prefer using DeviceGroupTags instead. */
    deviceGroupTag?: string;
    /** Report is run for all operational devices in the intersection of all of these groups. Clients must provide at least one group they are directly assigned to, eg their org or a site. They may also provide groups they are not directly assigned to, eg ServiceModels */
    deviceGroupTags?: string[];
}

export interface BulkImportRowError {
    rowIndex?: number;
    make?: string;
    model?: string;
    reason?: string;
}

export interface BulkImportResult {
    insertedCount?: number;
    errors?: BulkImportRowError[];
    succeeded?: boolean;
}

export type CreateUpdateVehicleModelReferenceRequestVehicleType =
    (typeof CreateUpdateVehicleModelReferenceRequestVehicleType)[keyof typeof CreateUpdateVehicleModelReferenceRequestVehicleType];

export const CreateUpdateVehicleModelReferenceRequestVehicleType = {
    Unknown: "Unknown",
    BEV: "BEV",
    PHEV: "PHEV",
    FCEV: "FCEV",
} as const;

export interface CreateUpdateVehicleModelReferenceRequest {
    make?: string;
    model?: string;
    vehicleType?: CreateUpdateVehicleModelReferenceRequestVehicleType;
    batteryCapacityKwh?: number;
}

export interface BulkImportVehicleModelReferencesRequest {
    entries?: CreateUpdateVehicleModelReferenceRequest[];
}

export interface BulkSetOperationalStatusRequest {
    /** List of device identities to set operational date on. */
    deviceIdentities?: string[];
    /** Date to mark the device as operational from. Omit to set device as non-operational. */
    operationalAt?: Date;
}

export type CarbonEmissionIntensityDtoScopeFactor =
    (typeof CarbonEmissionIntensityDtoScopeFactor)[keyof typeof CarbonEmissionIntensityDtoScopeFactor];

export const CarbonEmissionIntensityDtoScopeFactor = {
    Scope1: "Scope1",
    Scope2: "Scope2",
    Scope3: "Scope3",
} as const;

export interface CarbonEmissionIntensityDto {
    carbonEmissionIntensityId?: number;
    stateCode?: string;
    /** 2 letter ISO country code. Required */
    countryCode?: string;
    cO2PerWh?: number;
    scopeFactor?: CarbonEmissionIntensityDtoScopeFactor;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface CentralSystemResponse {
    centralSystemId?: string;
    fullName?: string;
    rowSequence?: number;
}

export interface CentralSystemsResponse {
    centralSystems?: CentralSystemResponse[];
}

export interface ChangeConfigurationTask {
    key?: string;
    value?: string;
}

export interface ChangeExtendedConfigurationTask {
    componentName?: string;
    componentInstance?: string;
    connectorId?: number;
    physicalPlugId?: number;
    variableName?: string;
    variableInstance?: string;
    attribute?: string;
    value?: string;
}

export type ChargePointMetadataDtoChargerType =
    (typeof ChargePointMetadataDtoChargerType)[keyof typeof ChargePointMetadataDtoChargerType];

export const ChargePointMetadataDtoChargerType = {
    OcppUnknown: "OcppUnknown",
    ChargeMate: "ChargeMate",
    Tesla: "Tesla",
    Quasar: "Quasar",
} as const;

export type ChargePointMetadataDtoManagedBy =
    (typeof ChargePointMetadataDtoManagedBy)[keyof typeof ChargePointMetadataDtoManagedBy];

export const ChargePointMetadataDtoManagedBy = {
    ChargefoxDev: "ChargefoxDev",
    ChargefoxStaging: "ChargefoxStaging",
    ChargefoxProd: "ChargefoxProd",
    Illuminate: "Illuminate",
    Exploren: "Exploren",
    Fortum: "Fortum",
    ChargeHq: "ChargeHq",
    DynamicPassthroughParent: "DynamicPassthroughParent",
    DynamicPassthroughChild: "DynamicPassthroughChild",
    GatewayDynamicPassthroughChild: "GatewayDynamicPassthroughChild",
    ServerlessFunctionApp: "ServerlessFunctionApp",
} as const;

export interface ChargePointMetadataDto {
    chargerType?: ChargePointMetadataDtoChargerType;
    managedBy?: ChargePointMetadataDtoManagedBy;
    metadata?: string;
    thirdPartyDeviceIdentity?: string;
}

export interface ChargerMeterValue {
    chargerMeterValueId?: number;
    transactionId?: number;
    stateOfCharge?: number;
    currentOfferedA?: number;
    powerOfferedW?: number;
    gridActivePowerExportW?: number;
    gridActivePowerImportW?: number;
    solarActivePowerImportW?: number;
    gridActiveEnergyExportWh?: number;
    gridActiveEnergyImportWh?: number;
    solarEnergyImportWh?: number;
    totalCost?: number;
    pricingScheduleId?: number;
    timestamp?: Date;
    frequencyHz?: number;
    l1VoltageRmsV?: number;
    l2VoltageRmsV?: number;
    l3VoltageRmsV?: number;
    l1CurrentRmsA?: number;
    l2CurrentRmsA?: number;
    l3CurrentRmsA?: number;
    l1ActivePowerRmsW?: number;
    l2ActivePowerRmsW?: number;
    l3ActivePowerRmsW?: number;
    l1ReactivePowerRmsVar?: number;
    l2ReactivePowerRmsVar?: number;
    l3ReactivePowerRmsVar?: number;
    totalActiveEnergyImportWh?: number;
    totalReactiveEnergyImportWh?: number;
    totalActiveEnergyExportWh?: number;
    totalReactiveEnergyExportWh?: number;
}

export interface ChargerMeterValueDto {
    chargerMeterValueId?: number;
    transactionId?: number;
    stateOfCharge?: number;
    currentOfferedA?: number;
    powerOfferedW?: number;
    gridActivePowerExportW?: number;
    gridActivePowerImportW?: number;
    solarActivePowerImportW?: number;
    gridActiveEnergyExportWh?: number;
    gridActiveEnergyImportWh?: number;
    solarEnergyImportWh?: number;
    totalCost?: number;
    timestamp?: Date;
    frequencyHz?: number;
    l1VoltageRmsV?: number;
    l2VoltageRmsV?: number;
    l3VoltageRmsV?: number;
    l1CurrentRmsA?: number;
    l2CurrentRmsA?: number;
    l3CurrentRmsA?: number;
    l1ActivePowerRmsW?: number;
    l2ActivePowerRmsW?: number;
    l3ActivePowerRmsW?: number;
    l1ReactivePowerRmsVar?: number;
    l2ReactivePowerRmsVar?: number;
    l3ReactivePowerRmsVar?: number;
    totalActiveEnergyImportWh?: number;
    totalReactiveEnergyImportWh?: number;
    totalActiveEnergyExportWh?: number;
    totalReactiveEnergyExportWh?: number;
}

export interface ConnectorSnapshot {
    connectorNumber?: number;
    ocppStatus?: string;
    assignedAmps?: number;
    feedbackL1Amps?: number;
    feedbackL2Amps?: number;
    feedbackL3Amps?: number;
    feedbackTimestamp?: Date;
}

export interface ChargerSnapshot {
    uniqueId?: string;
    coreConnectionStatus?: string;
    passthroughConnectionStatus?: string;
    connectorSnapshots?: ConnectorSnapshot[];
}

export interface ChargingSuccessRateResponse {
    /** The charging success rate as a percentage (0-100) for the specified period */
    chargingSuccessRate?: number;
    /** Number of successful charging sessions in the period */
    successfulSessions?: number;
    /** Number of failed charging sessions in the period */
    failedSessions?: number;
    /** Total number of charging sessions (successful + failed) in the period */
    totalSessions?: number;
    /** Percentage change compared to the previous period of the same duration. Positive values indicate improvement. */
    percentageChange?: number;
    /** Start of the calculation period */
    periodStart?: Date;
    /** End of the calculation period */
    periodEnd?: Date;
}

export interface DailyChargingSuccessRateDto {
    /** The date for this data point */
    date?: Date;
    /** The charging success rate as a percentage (0-100) */
    chargingSuccessRate?: number;
    /** Number of successful charging sessions */
    successfulSessions?: number;
    /** Number of failed charging sessions */
    failedSessions?: number;
    /** Total number of charging sessions (successful + failed) */
    totalSessions?: number;
}

export interface ChargingSuccessRateTrendResponse {
    /** Array of daily charging success rate data points for the specified period */
    dailyTrends?: DailyChargingSuccessRateDto[];
}

export interface ClearChargingProfileTask {
    profileId?: string;
    connectorIndex?: number;
    chargingProfilePurpose?: string;
    stackLevel?: string;
}

export type ConnectivityStatusDtoStatus =
    (typeof ConnectivityStatusDtoStatus)[keyof typeof ConnectivityStatusDtoStatus];

export const ConnectivityStatusDtoStatus = {
    Online: "Online",
    Offline: "Offline",
} as const;

export interface ConnectivityStatusDto {
    date?: Date;
    status?: ConnectivityStatusDtoStatus;
}

/**
 * Connector status mapped to an enum
 */
export type ConnectorAndActiveTransactionInfoConnectorState =
    (typeof ConnectorAndActiveTransactionInfoConnectorState)[keyof typeof ConnectorAndActiveTransactionInfoConnectorState];

export const ConnectorAndActiveTransactionInfoConnectorState = {
    Unknown: "Unknown",
    Available: "Available",
    Preparing: "Preparing",
    Charging: "Charging",
    Discharging: "Discharging",
    Suspended: "Suspended",
    Finishing: "Finishing",
    FullyCharged: "FullyCharged",
    Reserved: "Reserved",
    Unavailable: "Unavailable",
    Faulted: "Faulted",
} as const;

export type TransactionDtoDeviceType =
    (typeof TransactionDtoDeviceType)[keyof typeof TransactionDtoDeviceType];

export const TransactionDtoDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

export type TransactionDtoBillingStatus =
    (typeof TransactionDtoBillingStatus)[keyof typeof TransactionDtoBillingStatus];

export const TransactionDtoBillingStatus = {
    Unknown: "Unknown",
    NotRequired: "NotRequired",
    Pending: "Pending",
    Raised: "Raised",
    Paid: "Paid",
    Failed: "Failed",
} as const;

export interface TransactionDto {
    transactionId?: number;
    transactionLocalId?: string;
    deviceIdentity?: string;
    deviceType?: TransactionDtoDeviceType;
    connectorIndex?: number;
    connectorIdentity?: string;
    managedBy?: string;
    centralSystemTransactionId?: string;
    meterStart?: number;
    meterStop?: number;
    soCStart?: number;
    soCEnd?: number;
    idTagStart?: string;
    idTagStop?: string;
    reservationId?: number;
    odometer?: string;
    vehicleId?: number;
    vehicleRegistrationPlate?: string;
    start?: Date;
    end?: Date;
    stopTransactionReason?: string;
    createdAt?: Date;
    updatedAt?: Date;
    totalCost?: number;
    currencyCode?: string;
    billingStatus?: TransactionDtoBillingStatus;
    chargerMeterValues?: ChargerMeterValueDto[];
}

export interface ConnectorAndActiveTransactionInfo {
    connectorIndex?: number;
    /** Connector status mapped to an enum */
    connectorState?: ConnectorAndActiveTransactionInfoConnectorState;
    /** Raw connector status as reported from the device. Eg Available,SuspendedEV,Unknown */
    connectorStatus?: string;
    /** Time the connector changed to this status */
    statusTimestamp?: Date;
    /** The in-progress active energy consumption (null if no transaction, 0 if still waiting for first MeterValue) */
    consumptionWh?: number;
    /** The in-progress active power for all phases (null if no transaction, 0 if still waiting for first MeterValue) */
    powerRmsW?: number;
    /** The in-progress total cost (if a price is defined) */
    totalCost?: number;
    /** The in-progress state of charge (DC chargers only) */
    stateOfCharge?: number;
    transaction?: TransactionDto;
}

export type ConnectorDtoConnectorType =
    (typeof ConnectorDtoConnectorType)[keyof typeof ConnectorDtoConnectorType];

export const ConnectorDtoConnectorType = {
    Unknown: "Unknown",
    CHAdeMO: "CHAdeMO",
    CCS: "CCS",
    CCS2: "CCS2",
    Type1: "Type1",
    Type2: "Type2",
    MCS: "MCS",
    Pantograph: "Pantograph",
    Domestic: "Domestic",
} as const;

/**
 * Connector status mapped to an enum
 */
export type ConnectorDtoConnectorState =
    (typeof ConnectorDtoConnectorState)[keyof typeof ConnectorDtoConnectorState];

export const ConnectorDtoConnectorState = {
    Unknown: "Unknown",
    Available: "Available",
    Preparing: "Preparing",
    Charging: "Charging",
    Discharging: "Discharging",
    Suspended: "Suspended",
    Finishing: "Finishing",
    FullyCharged: "FullyCharged",
    Reserved: "Reserved",
    Unavailable: "Unavailable",
    Faulted: "Faulted",
} as const;

export interface ConnectorDto {
    /** Unique label combines device id and connector index/label */
    connectorUniqueLabel?: string;
    createdAt?: Date;
    connectorType?: ConnectorDtoConnectorType;
    /** 1-based connector index */
    connectorIndex?: number;
    /** Customer-facing label, eg 'Port A' */
    connectorLabel?: string;
    /** Connector status mapped to an enum */
    connectorState?: ConnectorDtoConnectorState;
    /** Raw connector status as reported from the device. Eg Available,SuspendedEV,Unknown */
    connectorStatus?: string;
}

export interface DeviceConnector {
    deviceIdentity?: string;
    /** Optional list of connector indices to apply the pricing schedule to. If null, then apply
  pricing schedule to all connectors of device */
    connectorIndices?: number[];
}

export interface ConnectorPricingAssignmentRequest {
    pricingScheduleGroupId?: number;
    deviceConnectors?: DeviceConnector[];
}

export interface PricingScheduleItemDto {
    startCronExpression?: string;
    endCronExpression?: string;
    /** Optional description. */
    description?: string;
    priceKWh?: number;
}

export interface PricingScheduleDto {
    pricingScheduleId?: number;
    /** Optional. Set this to add new schedule to existing schedule group.Omit to create a new schedule and assign to new group */
    pricingScheduleGroupId?: number;
    /** The time zone the template is for, eg 'Australia/Melbourne', 'UTC+10' (NEM time).
  Certain retailers still define peak/off-peak rates in the NEM timezone, which is UTC+10 everywhere. In this case, explicitly set the timezone on the template.
   Default timezone is UTC. */
    timeZone?: string;
    /** Optional user facing name, eg 'MyRetailer SimplePlan Off-Peak' */
    description?: string;
    /** Schedules are ordered by Organisation.RowSequence, PricingSchedule.RowSequence asc. */
    rowSequence?: number;
    /** Optional. Sys admins can set this if required. For all other users, their organisation will be used */
    organisationId?: string;
    /** Read-only org name */
    organisationName?: string;
    /** ISO 4217 currency code */
    currencyCode?: string;
    isDeleted?: boolean;
    /** List of connector pricing schedules */
    scheduleItems?: PricingScheduleItemDto[];
    /** Optional. Will be effective immediately if omitted */
    effectiveFrom?: Date;
    /** If true, delete all future dated schedules in assignation. No effect if PricingScheduleAssignmentId is null. */
    removeFuturePricingSchedules?: boolean;
}

export interface ConnectorToPricingScheduleGroupDto {
    deviceIdentity?: string;
    connectorIndex?: number;
    pricingSchedule?: PricingScheduleDto;
}

export interface ConnectorPricingScheduleListResponse {
    connectorSchedules?: ConnectorToPricingScheduleGroupDto[];
}

export interface ConnectorStatusCount {
    /** JETCharge: for all device connectors in the system.
  JemenaProject: For all device connectors in the Jemena project.
  Else one of DnspAccessTags enums */
    group?: string;
    /** one of SimpleConnectorState enums */
    status?: string;
    /** The count of connectors in this group, with this status */
    count?: number;
}

export interface ConnectorStatusByDnspResponse {
    items?: ConnectorStatusCount[];
}

export interface ConnectorUptimeSummary {
    /** Device identity */
    deviceIdentity?: string;
    /** Device friendly name */
    deviceFriendlyName?: string;
    /** Connector index (1-based) */
    connectorIndex?: number;
    /** Uptime percentage (0-1). Offline periods are not considered. */
    uptimeOfflineIncluded?: number;
    /** Uptime percentage (0-1). Offline periods are removed from calculation. */
    uptimeOfflineExcluded?: number;
    /** Preferred uptime based on organisation preference. */
    preferredUptime?: number;
    /** Whether offline is included in preferred calculation. */
    isOfflineIncluded?: boolean;
    /** Parent site device group tag */
    siteGroupTag?: string;
    /** Parent site name */
    siteName?: string;
    /** Parent organisation device group tag */
    orgGroupTag?: string;
    /** Parent organisation name */
    orgName?: string;
    /** All device group tags this connector belongs to (for OData filtering) */
    deviceGroupTags?: string[];
    /** Calculation period start */
    periodStart?: Date;
    /** Calculation period end */
    periodEnd?: Date;
}

export type ContactDetailsContactType =
    (typeof ContactDetailsContactType)[keyof typeof ContactDetailsContactType];

export const ContactDetailsContactType = {
    Site: "Site",
    User: "User",
    Other: "Other",
} as const;

export interface ContactDetails {
    name?: string;
    phoneNumber?: string;
    email?: string;
    contactType?: ContactDetailsContactType;
}

export interface ContactDto {
    contactId?: number;
    name?: string;
    phoneNo?: string;
    email?: string;
    role?: string;
}

export type CoreConfigHistoryDtoType =
    (typeof CoreConfigHistoryDtoType)[keyof typeof CoreConfigHistoryDtoType];

export const CoreConfigHistoryDtoType = {
    Shadow: "Shadow",
    Draft: "Draft",
    Published: "Published",
} as const;

export interface CoreConfigHistoryDto {
    coreConfigurationId?: number;
    uniqueId?: string;
    schemaVersion?: number;
    type?: CoreConfigHistoryDtoType;
    createdAt?: Date;
    createdByUserName?: string;
    reason?: string;
}

export type CoreDeviceStatusDtoStatus =
    (typeof CoreDeviceStatusDtoStatus)[keyof typeof CoreDeviceStatusDtoStatus];

export const CoreDeviceStatusDtoStatus = {
    Operational: "Operational",
    Faulted: "Faulted",
} as const;

export interface CoreDeviceStatusDto {
    date?: Date;
    status?: CoreDeviceStatusDtoStatus;
}

export interface CoreMetadataDto {
    metadata?: string;
}

export type CoreSnapshotMessageDeviceType =
    (typeof CoreSnapshotMessageDeviceType)[keyof typeof CoreSnapshotMessageDeviceType];

export const CoreSnapshotMessageDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

export interface DistributionBoardSnapshot {
    uniqueId?: string;
    externalLoadL1Amps?: number;
    externalLoadL2Amps?: number;
    externalLoadL3Amps?: number;
    connectorsAssignedL1Amps?: number;
    connectorsAssignedL2Amps?: number;
    connectorsAssignedL3Amps?: number;
    feedbackExternalLoadL1Amps?: number;
    feedbackExternalLoadL2Amps?: number;
    feedbackExternalLoadL3Amps?: number;
    feedbackConnectorsLoadL1Amps?: number;
    feedbackConnectorsLoadL2Amps?: number;
    feedbackConnectorsLoadL3Amps?: number;
    operatingCapacityL1Amps?: number;
    operatingCapacityL2Amps?: number;
    operatingCapacityL3Amps?: number;
}

export interface MeterValuesSnapshot {
    frequencyHz?: number;
    l1VoltageRmsV?: number;
    l2VoltageRmsV?: number;
    l3VoltageRmsV?: number;
    l1CurrentRmsA?: number;
    l2CurrentRmsA?: number;
    l3CurrentRmsA?: number;
    l1ActivePowerRmsKw?: number;
    l2ActivePowerRmsKw?: number;
    l3ActivePowerRmsKw?: number;
    l1ReactivePowerRmsKVar?: number;
    l2ReactivePowerRmsKVar?: number;
    l3ReactivePowerRmsKVar?: number;
    activeEnergyImportKWh?: number;
    activeEnergyExportKWh?: number;
}

export interface PowerMeterSnapshot {
    uniqueId?: string;
    coreConnectionStatus?: string;
    meterValues?: MeterValuesSnapshot;
}

/**
 * Objects of type CoreSnapshotMessage are sent to hub method named coreSnapshotMessage in the device group device_<deviceId>. Listen to it via `signalRHub.on('coreSnapshotMessage', (message: CoreSnapshotMessage) => {}`
 */
export interface CoreSnapshotMessage {
    distributionBoardSnapshots?: DistributionBoardSnapshot[];
    powerMeterSnapshots?: PowerMeterSnapshot[];
    chargerSnapshots?: ChargerSnapshot[];
    deviceType?: CoreSnapshotMessageDeviceType;
    deviceId?: string;
}

export interface CreateCoreConfigRequest {
    isDraft?: boolean;
    schemaVersion?: number;
    coreConfigData?: string;
    reason?: string;
}

export type CreateNotificationPreferenceRequestNotificationMethodsItem =
    (typeof CreateNotificationPreferenceRequestNotificationMethodsItem)[keyof typeof CreateNotificationPreferenceRequestNotificationMethodsItem];

export const CreateNotificationPreferenceRequestNotificationMethodsItem = {
    Unknown: "Unknown",
    Email: "Email",
    SMS: "SMS",
    PushNotification: "PushNotification",
} as const;

export type CreateNotificationPreferenceRequestNotificationTypesItem =
    (typeof CreateNotificationPreferenceRequestNotificationTypesItem)[keyof typeof CreateNotificationPreferenceRequestNotificationTypesItem];

export const CreateNotificationPreferenceRequestNotificationTypesItem = {
    Unknown: "Unknown",
    FaultedStateDevice: "FaultedStateDevice",
    OfflineStateDevice: "OfflineStateDevice",
    UnknownStateDevice: "UnknownStateDevice",
    NonOperationalDevice: "NonOperationalDevice",
    EnergyPriceChargingSuspended: "EnergyPriceChargingSuspended",
    EnergyPriceChargingResumed: "EnergyPriceChargingResumed",
    Warning: "Warning",
    FrequentFaultsWarning: "FrequentFaultsWarning",
    ShortDurationWarning: "ShortDurationWarning",
    NoActivityWarning: "NoActivityWarning",
    ZerokWhWarning: "ZerokWhWarning",
    PowerLossWarning: "PowerLossWarning",
    LowEnergyMidSessionWarning: "LowEnergyMidSessionWarning",
    IdleStateDevice: "IdleStateDevice",
} as const;

export type CreateNotificationPreferenceRequestNotificationFrequency =
    (typeof CreateNotificationPreferenceRequestNotificationFrequency)[keyof typeof CreateNotificationPreferenceRequestNotificationFrequency];

export const CreateNotificationPreferenceRequestNotificationFrequency = {
    Unknown: "Unknown",
    RealTime: "RealTime",
    Scheduled: "Scheduled",
} as const;

export type CreateNotificationScheduleRequestScheduleType =
    (typeof CreateNotificationScheduleRequestScheduleType)[keyof typeof CreateNotificationScheduleRequestScheduleType];

export const CreateNotificationScheduleRequestScheduleType = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Interval: "Interval",
} as const;

export type CreateNotificationScheduleRequestIntervalUnit =
    (typeof CreateNotificationScheduleRequestIntervalUnit)[keyof typeof CreateNotificationScheduleRequestIntervalUnit];

export const CreateNotificationScheduleRequestIntervalUnit = {
    Minutes: "Minutes",
    Hours: "Hours",
    Days: "Days",
    Weeks: "Weeks",
    Months: "Months",
} as const;

export interface CreateNotificationScheduleRequest {
    scheduleType?: CreateNotificationScheduleRequestScheduleType;
    scheduledTime?: string;
    daysOfWeek?: number;
    dayOfMonth?: number;
    intervalValue?: number;
    intervalUnit?: CreateNotificationScheduleRequestIntervalUnit;
    timeZone?: string;
}

export interface CreateNotificationPreferenceRequest {
    userAccountId?: number;
    deviceGroupTags?: string[];
    deviceIdentities?: string[];
    notificationMethods?: CreateNotificationPreferenceRequestNotificationMethodsItem[];
    notificationTypes?: CreateNotificationPreferenceRequestNotificationTypesItem[];
    notificationFrequency?: CreateNotificationPreferenceRequestNotificationFrequency;
    schedule?: CreateNotificationScheduleRequest;
}

export type CreatePassthroughChildDeviceRequestAuthorizationMode =
    (typeof CreatePassthroughChildDeviceRequestAuthorizationMode)[keyof typeof CreatePassthroughChildDeviceRequestAuthorizationMode];

export const CreatePassthroughChildDeviceRequestAuthorizationMode = {
    LegacyBasicAuth: "LegacyBasicAuth",
    AutomaticBasicAuth: "AutomaticBasicAuth",
    ManualBasicAuth: "ManualBasicAuth",
    None: "None",
    Reject: "Reject",
} as const;

export interface CreatePassthroughChildDeviceRequest {
    /** The id of the passthrough config to use */
    passthroughConfigId?: number;
    /** The id of the passthrough device in the third party system. */
    thirdPartyDeviceIdentity?: string;
    authorizationMode?: CreatePassthroughChildDeviceRequestAuthorizationMode;
    /** If AuthorizationMode=ManualBasicAuth, the 20 character unique secret key that will be sent to the charger. When IsAuthKeyHexString is true, provide the key as a 40 character hex representation instead. May be null. */
    authorizationKey?: string;
    /** Set to true to force passthrough creation of unsupported device models, if a previous call returned 1002 UnsupportedDeviceType. */
    acknowledgeUnsupported?: boolean;
    /** Used when AuthorizationMode=ManualBasicAuth. Set to true if AuthorizationKey is provided as a 40 character hex representation of the secret key */
    isAuthKeyHexString?: boolean;
}

export type CreateVehicleRequestJurisdiction =
    (typeof CreateVehicleRequestJurisdiction)[keyof typeof CreateVehicleRequestJurisdiction];

export const CreateVehicleRequestJurisdiction = {
    Unknown: "Unknown",
    ACT: "ACT",
    NSW: "NSW",
    NT: "NT",
    QLD: "QLD",
    SA: "SA",
    TAS: "TAS",
    VIC: "VIC",
    WA: "WA",
    National: "National",
} as const;

export type CreateVehicleRequestVehicleType =
    (typeof CreateVehicleRequestVehicleType)[keyof typeof CreateVehicleRequestVehicleType];

export const CreateVehicleRequestVehicleType = {
    Unknown: "Unknown",
    BEV: "BEV",
    PHEV: "PHEV",
    FCEV: "FCEV",
} as const;

export type CreateVehicleRequestConnectorTypesItem =
    (typeof CreateVehicleRequestConnectorTypesItem)[keyof typeof CreateVehicleRequestConnectorTypesItem];

export const CreateVehicleRequestConnectorTypesItem = {
    Unknown: "Unknown",
    CHAdeMO: "CHAdeMO",
    CCS: "CCS",
    CCS2: "CCS2",
    Type1: "Type1",
    Type2: "Type2",
    MCS: "MCS",
    Pantograph: "Pantograph",
    Domestic: "Domestic",
} as const;

export type CreateVehicleRequestStatus =
    (typeof CreateVehicleRequestStatus)[keyof typeof CreateVehicleRequestStatus];

export const CreateVehicleRequestStatus = {
    Inactive: "Inactive",
    Active: "Active",
    Archived: "Archived",
} as const;

export interface CreateVehicleRequest {
    registrationPlate?: string;
    jurisdiction?: CreateVehicleRequestJurisdiction;
    organisationId?: string;
    friendlyName?: string;
    make?: string;
    model?: string;
    year?: number;
    colour?: string;
    vehicleType?: CreateVehicleRequestVehicleType;
    vin?: string;
    batteryCapacityKwh?: number;
    macAddress?: string;
    connectorTypes?: CreateVehicleRequestConnectorTypesItem[];
    notes?: string;
    status?: CreateVehicleRequestStatus;
}

export interface CumulativeSessionCost {
    /** for debugging. The raw db row timestamp. */
    rowValueUtc?: Date;
    /** The truncated time in UTC for the beginning of the interval (eg 'January' 2022 would be `2021-12-31T16:00:00` */
    timestamp?: Date;
    /** Date label, to avoid timezone conversions in frontend. eg:
  Hour: yyyy-MM-ddTHH:00:00
  Day: yyyy-MM-dd
  Week: 2022W01 (week-of-year, new weeks start on Sunday)
  Month: 2022M01 */
    label?: string;
    /** The cost for sessions that started in this interval */
    cost?: number;
}

export interface CumulativeSessionCostResponse {
    items?: CumulativeSessionCost[];
    /** Currently always 'Australia/NEM_Time'. NEM Time is always UTC+10, with no daylight savings */
    siteTimeZone?: string;
}

export interface DailyCarbonEmissionEstimate {
    date?: Date;
    emissionKg?: number;
    scope1EmissionKg?: number;
    scope2EmissionKg?: number;
    scope3EmissionKg?: number;
}

export interface GroupUptimeValue {
    /** Uptime percentage (0-1) with offline periods included */
    uptimeOfflineIncluded?: number;
    /** Uptime percentage (0-1) with offline periods excluded */
    uptimeOfflineExcluded?: number;
    /** The preferred uptime value based on org preference */
    preferredUptime?: number;
    /** Which calculation method was used for PreferredUptime */
    isOfflineIncluded?: boolean;
}

/**
 * Dictionary of group ID to uptime values
 */
export type DateCentricUptimeTrendItemGroups = {
    [key: string]: GroupUptimeValue;
};

export interface DateCentricUptimeTrendItem {
    /** The date for this data point */
    date?: Date;
    /** Dictionary of group ID to uptime values */
    groups?: DateCentricUptimeTrendItemGroups;
}

export interface DeviceAccessTagsSetRequest {
    deviceArchiveId?: number;
    /** True to update all child devices of a Wave at the same time */
    cascadeToChildDevices?: boolean;
    accessTags?: string[];
}

export interface DeviceActiveTransactionsResponse {
    deviceIdentity?: string;
    /** Every connector on the charger */
    connectors?: ConnectorAndActiveTransactionInfo[];
}

export type DeviceAlertMessageDeviceType =
    (typeof DeviceAlertMessageDeviceType)[keyof typeof DeviceAlertMessageDeviceType];

export const DeviceAlertMessageDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

/**
 * Objects of type DeviceAlertMessage are sent to hub method named deviceAlertMessage in the device group device_<deviceId>. Listen to it via `signalRHub.on('deviceAlertMessage', (message: DeviceAlertMessage) => {}`
Message is forwarded directly from Service Bus - it's currently the same type
 */
export interface DeviceAlertMessage {
    alertType?: string;
    startTime?: Date;
    durationSeconds?: number;
    message?: string;
    derEventId?: string;
    deviceType?: DeviceAlertMessageDeviceType;
    deviceId?: string;
    timeToLive?: string;
    scheduledTime?: Date;
}

export type DeviceAlertTaskDeviceType =
    (typeof DeviceAlertTaskDeviceType)[keyof typeof DeviceAlertTaskDeviceType];

export const DeviceAlertTaskDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

export interface DeviceAlertTask {
    alertType?: string;
    startTime?: Date;
    durationSeconds?: number;
    message?: string;
    derEventId?: string;
    deviceType?: DeviceAlertTaskDeviceType;
    deviceId?: string;
    timeToLive?: string;
    scheduledTime?: Date;
}

export interface DeviceAndConnectorStatus {
    statusItemId?: number;
    isDeviceOnlineStatus?: boolean;
    deviceIdentity?: string;
    connectorIndex?: number;
    timestamp?: Date;
    status?: string;
    reason?: string;
}

/**
 * Current mode.
 */
export type DeviceAuthorizationDtoMode =
    (typeof DeviceAuthorizationDtoMode)[keyof typeof DeviceAuthorizationDtoMode];

export const DeviceAuthorizationDtoMode = {
    LegacyBasicAuth: "LegacyBasicAuth",
    AutomaticBasicAuth: "AutomaticBasicAuth",
    ManualBasicAuth: "ManualBasicAuth",
    None: "None",
    Reject: "Reject",
} as const;

/**
 *  New mode to be applied (only used for Mode=AutomaticBasicAuth, waiting for the key to be sent to the charger)
 */
export type DeviceAuthorizationDtoModeInProgress =
    (typeof DeviceAuthorizationDtoModeInProgress)[keyof typeof DeviceAuthorizationDtoModeInProgress];

export const DeviceAuthorizationDtoModeInProgress = {
    LegacyBasicAuth: "LegacyBasicAuth",
    AutomaticBasicAuth: "AutomaticBasicAuth",
    ManualBasicAuth: "ManualBasicAuth",
    None: "None",
    Reject: "Reject",
} as const;

export interface DeviceAuthorizationDto {
    /** Current mode. */
    mode?: DeviceAuthorizationDtoMode;
    /**  New mode to be applied (only used for Mode=AutomaticBasicAuth, waiting for the key to be sent to the charger) */
    modeInProgress?: DeviceAuthorizationDtoModeInProgress;
    /** Obfuscated (first/last few chars only). If Mode=AutomaticBasicAuth or ManualBasicAuth, a hashed version of a 20 character unique secret key that has been sent to the charger. Null otherwise. */
    authorizationKeyHashedObfuscated?: string;
    /** Obfuscated (first/last few chars only). If Mode=AutomaticBasicAuth or ManualBasicAuth, the salt for AuthorizationKeyHashed. Null otherwise. */
    authorizationKeySaltObfuscated?: string;
    /** Obfuscated (first/last few chars only). If virtual passthrough device, and Mode=AutomaticBasicAuth or ManualBasicAuth, the key. Null otherwise. */
    passthroughAuthorizationKeyObfuscated?: string;
    /** Set to true if PassthroughAuthorizationKey is a 40 character hex representation of the secret key */
    passthroughAuthorizationKeyIsHexString?: boolean;
    createdAt?: Date;
    updatedAt?: Date;
    /** The time the ModeInProgress,AuthorizationKeyInProgress values were last applied to the device, and moved to Mode,AuthorizationKey. */
    appliedAt?: Date;
}

export type DeviceCatalogueDtoDeviceType =
    (typeof DeviceCatalogueDtoDeviceType)[keyof typeof DeviceCatalogueDtoDeviceType];

export const DeviceCatalogueDtoDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

/**
 * AC or DC charger. Defined by the hardware capability of the device/SKU, not by the actual installation wiring (it is common for an SKU that supports 3-phase AC to be installed in a single-phase configuration).
 */
export type DeviceCatalogueDtoPowerType =
    (typeof DeviceCatalogueDtoPowerType)[keyof typeof DeviceCatalogueDtoPowerType];

export const DeviceCatalogueDtoPowerType = {
    Unknown: "Unknown",
    AC1Phase: "AC1Phase",
    ACSplitPhase: "ACSplitPhase",
    AC3Phase: "AC3Phase",
    ACDC: "ACDC",
    DC: "DC",
} as const;

export interface DeviceCatalogueDto {
    deviceCatalogueId?: number;
    /** Unique id, required. Used in NetSuite, online store, partner store, etc. */
    jetChargeSku?: string;
    deviceType?: DeviceCatalogueDtoDeviceType;
    /** AC or DC charger. Defined by the hardware capability of the device/SKU, not by the actual installation wiring (it is common for an SKU that supports 3-phase AC to be installed in a single-phase configuration). */
    powerType?: DeviceCatalogueDtoPowerType;
    /** Simplified vendor name. */
    simpleVendor?: string;
    /** Simplified model name, to be displayed in place of Device.Model. Usually begins with the vendor name. */
    simpleModel?: string;
    /** Full product name */
    productName?: string;
    description?: string;
    /** Vendor SKU. It may be possible to have unrelated vendors using the same SKU, so this is not guaranteed to be unique. */
    vendorSku?: string;
    /** Device reported Vendor */
    reportedVendor?: string;
    /** Device reported Model, used for Model drop-down during provisioning to match DeviceConfigurationSchemas. */
    reportedModels?: string[];
    createdAt?: Date;
    updatedAt?: Date;
}

export type DeviceConfigurationItemDtoStatus =
    (typeof DeviceConfigurationItemDtoStatus)[keyof typeof DeviceConfigurationItemDtoStatus];

export const DeviceConfigurationItemDtoStatus = {
    Applying: "Applying",
    Applied: "Applied",
    IlluminateOnly: "IlluminateOnly",
} as const;

export interface DeviceConfigurationItemDto {
    createdAt?: Date;
    updatedAt?: Date;
    deviceConfigurationIndexId?: number;
    key?: string;
    status?: DeviceConfigurationItemDtoStatus;
    valueLastApplied?: string;
    valueInProgress?: string;
    /** If true, this key cannot be changed by illuminate */
    isReadOnly?: boolean;
    isPersistent?: boolean;
    isConstant?: boolean;
}

export type DeviceConfigurationSchemaDtoDeviceType =
    (typeof DeviceConfigurationSchemaDtoDeviceType)[keyof typeof DeviceConfigurationSchemaDtoDeviceType];

export const DeviceConfigurationSchemaDtoDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

export interface DeviceConfigurationSchemaDto {
    deviceConfigurationSchemaId?: number;
    deviceType?: DeviceConfigurationSchemaDtoDeviceType;
    /** Config applies to device model names starting with this text. */
    model?: string;
    key?: string;
    /** eg Int32, Decimal, Boolean, String, Enum.<EnumName> (eg 'Enum.ChargerWiringMode'), NumberOrKeepExisting (for Wave config int fields that may also be 'KEEP_EXISTING'). Ends with '?' if the number or enum is optional. */
    dataType?: string;
    /** Optional. The range of allowed values for a number, or the list of allowed enums. Prefer DisplayValuesMapping for display, if set. eg: Int32: [0,100], Decimal: [0,99.9], Boolean: null, Enum.ChargerWiringMode: ['SINGLE_PHASE_L1','SINGLE_PHASE_L2','SINGLE_PHASE_L3','THREE_PHASE'], NumberOrKeepExisting: [0,100] */
    values?: string;
    description?: string;
    /** True to show this config item in the provisioning workflow for this device type/model */
    showDuringProvisioning?: boolean;
    /** True if this is an Illuminate-only key, that is not sent to the Device */
    illuminateOnly?: boolean;
    /** user-facing label. May include units, eg 'Max Grid Supply Current (A)' */
    label?: string;
    /** List of display names to show in a drop-down in-order, with a colon separating them from their values. Eg ['Single Phase:1','Three Phase:3']. This is for display only. All validation and set apis use the true value. If null, fall back to Values field. */
    displayNamesMapping?: string;
}

export interface DeviceConfigurationAndSchema {
    config?: DeviceConfigurationItemDto;
    schema?: DeviceConfigurationSchemaDto;
}

export interface DeviceConfigurationExtendedItemDto {
    componentName?: string;
    componentInstance?: string;
    connectorId?: number;
    physicalPlugId?: number;
    variableName?: string;
    variableInstance?: string;
    unit?: string;
    dataType?: string;
    minLimit?: number;
    maxLimit?: number;
    maxElements?: number;
    valuesList?: string;
    supportsMonitoring?: boolean;
    description?: string;
    attributes?: DeviceConfigurationItemDto[];
}

export interface DeviceConfigurationExtendedDto {
    items?: DeviceConfigurationExtendedItemDto[];
}

export type ListString = string[];

/**
 * Map of Categories (eg electrical, electricalSolarOnly) to list of config keys in that category
 */
export type DeviceConfigurationResponseCategoriesToKeys = {
    [key: string]: ListString;
};

export interface DeviceConfigurationResponse {
    items?: DeviceConfigurationAndSchema[];
    /** Map of Categories (eg electrical, electricalSolarOnly) to list of config keys in that category */
    categoriesToKeys?: DeviceConfigurationResponseCategoriesToKeys;
}

export interface NetworkInterfaceInfo {
    /** Eg Ethernet, Wifi, GSM */
    networkType?: string;
    /** The adapter's MAC address, if available */
    macAddress?: string;
    /** IP address on this interface (eg local IP for Ethernet/Wifi). Not currently available */
    ipAddress?: string;
    /** If NetworkType=Wifi, the ssid. Currently only available for Autel AC. If NetworkType=GSM, the telco provider. */
    ssid?: string;
    /** True if this interface is active. For ChargeMate, only Wifi or Ethernet is active at any one time */
    isActive?: boolean;
}

export interface DeviceConnectionInfoResponse {
    deviceIdentity?: string;
    networkInterfaces?: NetworkInterfaceInfo[];
}

export type DeviceConnectionStatusDtoStatus =
    (typeof DeviceConnectionStatusDtoStatus)[keyof typeof DeviceConnectionStatusDtoStatus];

export const DeviceConnectionStatusDtoStatus = {
    Unknown: "Unknown",
    Online: "Online",
    Offline: "Offline",
} as const;

export interface DeviceConnectionStatusDto {
    /** @minLength 1 */
    deviceIdentity: string;
    pointedToIlluminate: boolean;
    status: DeviceConnectionStatusDtoStatus;
}

export interface DeviceConnectionStatusResponse {
    deviceConnectionStatuses: DeviceConnectionStatusDto[];
}

export interface DeviceConnectorTransactionsResponse {
    transactions?: TransactionDto[];
    nextCursor?: string;
}

export interface DeviceConnectorUptimeResponse {
    /** The index of the connector */
    connectorIndex?: number;
    /** The uptime of the connector. Offline periods are not considered in the availability calculation. i.e., device assumed to be continuously online. */
    uptimeOfflineIncluded?: number;
    /** The uptime of the connector. Offline periods are removed from the availability calculation. */
    uptimeOfflineExcluded?: number;
    /** The preferred uptime value based on organisation preference. Defaults to UptimeOfflineIncluded if preference not set. */
    preferredUptime?: number;
    /** Indicates which calculation method was used for PreferredUptime. true = offline included, false = offline excluded. */
    isOfflineIncluded?: boolean;
}

export type DeviceDtoDeviceType =
    (typeof DeviceDtoDeviceType)[keyof typeof DeviceDtoDeviceType];

export const DeviceDtoDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

/**
 * Status of registration on the Illuminate platform.
 */
export type DeviceDtoDeviceRegistrationStatus =
    (typeof DeviceDtoDeviceRegistrationStatus)[keyof typeof DeviceDtoDeviceRegistrationStatus];

export const DeviceDtoDeviceRegistrationStatus = {
    Unverified: "Unverified",
    Inactive: "Inactive",
    Active: "Active",
} as const;

/**
 * Boot notification state
 */
export type DeviceDtoServiceDeviceState =
    (typeof DeviceDtoServiceDeviceState)[keyof typeof DeviceDtoServiceDeviceState];

export const DeviceDtoServiceDeviceState = {
    NewDevice: "NewDevice",
    SetNewAuthKey: "SetNewAuthKey",
    ResetDevice: "ResetDevice",
    GetConfiguration: "GetConfiguration",
    WaitForActivate: "WaitForActivate",
    NewFirmware: "NewFirmware",
    Registered: "Registered",
} as const;

/**
 * Consolidated device state
 */
export type DeviceDtoSimpleDeviceState =
    (typeof DeviceDtoSimpleDeviceState)[keyof typeof DeviceDtoSimpleDeviceState];

export const DeviceDtoSimpleDeviceState = {
    Unknown: "Unknown",
    Available: "Available",
    InUse: "InUse",
    Faulted: "Faulted",
    Raised: "Raised",
    Lowered: "Lowered",
    NoCurtailment: "NoCurtailment",
    LightCurtailment: "LightCurtailment",
    HeavyCurtailment: "HeavyCurtailment",
} as const;

/**
 * Active protocol
 */
export type DeviceDtoProtocol =
    (typeof DeviceDtoProtocol)[keyof typeof DeviceDtoProtocol];

export const DeviceDtoProtocol = {
    Unknown: "Unknown",
    ocpp16: "ocpp1.6",
    jcwp18: "jcwp1.8",
    jclp11: "jclp1.1",
    jccp: "jccp",
    "jcpp-pb": "jcpp-pb",
    ocpp201: "ocpp2.0.1",
} as const;

export interface DeviceUptimeResponse {
    /** The uptime of the device. Offline periods are not considered in the availability calculation. i.e., device assumed to be continuously online. */
    uptimeOfflineIncluded?: number;
    /** The uptime of the device. Offline periods are removed from the availability calculation. */
    uptimeOfflineExcluded?: number;
    /** The preferred uptime value based on organisation preference. Defaults to UptimeOfflineIncluded if preference not set. */
    preferredUptime?: number;
    /** Indicates which calculation method was used for PreferredUptime. true = offline included, false = offline excluded. */
    isOfflineIncluded?: boolean;
    /** Calculation period start. */
    periodStart?: Date;
    /** Calculation period end. */
    periodEnd?: Date;
}

export type RelatedDeviceDtoDeviceType =
    (typeof RelatedDeviceDtoDeviceType)[keyof typeof RelatedDeviceDtoDeviceType];

export const RelatedDeviceDtoDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

export type RelatedDeviceDtoDeviceRegistrationStatus =
    (typeof RelatedDeviceDtoDeviceRegistrationStatus)[keyof typeof RelatedDeviceDtoDeviceRegistrationStatus];

export const RelatedDeviceDtoDeviceRegistrationStatus = {
    Unverified: "Unverified",
    Inactive: "Inactive",
    Active: "Active",
} as const;

export type RelatedDeviceDtoServiceDeviceState =
    (typeof RelatedDeviceDtoServiceDeviceState)[keyof typeof RelatedDeviceDtoServiceDeviceState];

export const RelatedDeviceDtoServiceDeviceState = {
    NewDevice: "NewDevice",
    SetNewAuthKey: "SetNewAuthKey",
    ResetDevice: "ResetDevice",
    GetConfiguration: "GetConfiguration",
    WaitForActivate: "WaitForActivate",
    NewFirmware: "NewFirmware",
    Registered: "Registered",
} as const;

export interface RelatedDeviceDto {
    deviceIdentity?: string;
    deviceType?: RelatedDeviceDtoDeviceType;
    deviceArchiveId?: number;
    /** Date when the device was decommissioned. Null if the device is not decommissioned. */
    decommissionedAt?: Date;
    /** If present, this is a *virtual charger*, passed through to this third party central system. The real device is the parent. */
    passthroughConfigId?: number;
    deviceRegistrationStatus?: RelatedDeviceDtoDeviceRegistrationStatus;
    serviceDeviceState?: RelatedDeviceDtoServiceDeviceState;
    online?: boolean;
    serialNumber?: string;
    status?: string;
}

export interface LinkMetadataDto {
    metadata?: string;
}

export interface PowerMeterMetadataDto {
    switchboardId?: string;
    switchboardLoadLimitA?: number;
    switchboardCapacityA?: number;
    switchboardMaxCapacityL1Amps?: number;
    switchboardMaxCapacityL2Amps?: number;
    switchboardMaxCapacityL3Amps?: number;
    switchboardBufferL1?: number;
    switchboardBufferL2?: number;
    switchboardBufferL3?: number;
    metadata?: string;
}

export interface WaveMetadataDto {
    metadata?: string;
}

export interface PayMateMetadataDto {
    metadata?: string;
}

export interface DeviceDto {
    installationId?: number;
    /** 0 for active devices. When a device is archived, this is set to the next-highest available number for the same DeviceIdentity. Eg CM001 archiveId 0 (active), CM001 archiveId 1 (older), CM001 archiveId 2 (oldest). */
    deviceArchiveId?: number;
    deviceIdentity: string;
    organisationId?: string;
    deviceType?: DeviceDtoDeviceType;
    /** Date that the device is marked as operational. Device is not accounted for in uptime calculation before this date. */
    operationalAt?: Date;
    /** Date the device was first created on the Illuminate platform. This can occur before first boot. */
    createdAt?: Date;
    /** Date device details were last updated on the Illuminate platform, eg due to connector or status change */
    updatedAt?: Date;
    /** Date of last online status update. */
    onlineStatusUpdatedAt?: Date;
    /** Date of last status update. */
    statusUpdatedAt?: Date;
    /** Date when the device was decommissioned. Null if the device is not decommissioned. */
    decommissionedAt?: Date;
    /** Date and time when temporary reprovisioning access expires. Null if device is not in reprovisioning state. */
    reprovisioningExpiresAt?: Date;
    /** Status of registration on the Illuminate platform. */
    deviceRegistrationStatus?: DeviceDtoDeviceRegistrationStatus;
    /** Boot notification state */
    serviceDeviceState?: DeviceDtoServiceDeviceState;
    /** True if the device is online and connected to Illuminate. */
    online?: boolean;
    serialNumber?: string;
    /** Device reported manufacturer, eg 'Jetcharge', 'Tritium' */
    vendor?: string;
    fwVersion?: string;
    /** Device reported model, eg 'ChargeMate3P22'. See DeviceCatalogue for a simplified model name. */
    model?: string;
    /** Raw status as reported from the device, eg Available/CONNECTED/DISCONNECTED/Unknown */
    status?: string;
    /** Consolidated device state */
    simpleDeviceState?: DeviceDtoSimpleDeviceState;
    /** Parent, if connected to a Wave or Core */
    parentInstallationId?: number;
    /** PayMate, if linked to a PayMate */
    payMateDeviceInstallationId?: number;
    /** If present, this is a *virtual charger*, passed through to this third party central system. The real device is at ParentInstallationId. */
    passthroughConfigId?: number;
    /** If present, this is a *readonly passthrough*, read from this third party central system. The real device is connected directly to the third party. */
    readonlyPassthroughConfigId?: number;
    latitude?: number;
    longitude?: number;
    /** Old single field address. Migrate to separate Address fields. */
    address?: string;
    deviceOwnerId?: number;
    /** User-facing non-unique name */
    friendlyName?: string;
    timeZone?: string;
    siteName?: string;
    organisationName?: string;
    internalNotes?: string;
    deviceUptime?: DeviceUptimeResponse;
    /** If this is a Wave or Core, the child chargers and power meters */
    childDevices?: RelatedDeviceDto[];
    /** If this is a PayMate, this is its chargers */
    payMateChargerDevices?: RelatedDeviceDto[];
    /** Only returned for OrgGroupJETCharge. List of Organisations and OrganisationGroups that can manage this device */
    accessTags?: string[];
    deviceGroupTags?: string[];
    configurationItems?: DeviceConfigurationItemDto[];
    configurationExtendedItems?: DeviceConfigurationExtendedItemDto[];
    connectors?: ConnectorDto[];
    chargePointMetadata?: ChargePointMetadataDto;
    linkMetadata?: LinkMetadataDto;
    powerMeterMetadata?: PowerMeterMetadataDto;
    waveMetadata?: WaveMetadataDto;
    coreMetadata?: CoreMetadataDto;
    payMateMetadata?: PayMateMetadataDto;
    deviceAddress?: AddressDto;
    /** Active protocol */
    protocol?: DeviceDtoProtocol;
    /** All reported protocols this device supports */
    reportedProtocols?: string[];
    /** True if the device is decommissioned */
    isDecommissioned?: boolean;
    deviceCatalogue?: DeviceCatalogueDto;
}

export type DeviceFirmwareResponseStatus =
    (typeof DeviceFirmwareResponseStatus)[keyof typeof DeviceFirmwareResponseStatus];

export const DeviceFirmwareResponseStatus = {
    Enabled: "Enabled",
    Disabled: "Disabled",
} as const;

export interface DeviceFirmwareResponse {
    firmwareContainerName?: string;
    filename?: string;
    creationDate?: Date;
    /** Size of firmware in bytes */
    size?: number;
    firmwareNumber?: string;
    projectName?: string;
    configNumber?: string;
    mcuPartNumber?: string;
    firmwareVersion?: string;
    fullFirmwareVersion?: string;
    projectType?: string;
    status?: DeviceFirmwareResponseStatus;
    /** Explanatory note for any change in status */
    notes?: string;
    /** External user Id for the user who made a change in device firmware status */
    externalUserId?: string;
    /** List of PCB versions that this firmware is compatible with */
    compatiblePcbVersions?: string[];
    /** List of PCB variants that this firmware is compatible with */
    compatiblePcbVariants?: string[];
}

export type DeviceGroupDtoDeviceGroupType =
    (typeof DeviceGroupDtoDeviceGroupType)[keyof typeof DeviceGroupDtoDeviceGroupType];

export const DeviceGroupDtoDeviceGroupType = {
    OrganisationGroup: "OrganisationGroup",
    Organisation: "Organisation",
    Site: "Site",
    Logical: "Logical",
    Arbitrary: "Arbitrary",
    EndUserOwner: "EndUserOwner",
    EndUserSecondary: "EndUserSecondary",
    Billing: "Billing",
    ServiceModel: "ServiceModel",
    ScheduledMaintenance: "ScheduledMaintenance",
} as const;

export type DeviceGroupDtoBillingProvider =
    (typeof DeviceGroupDtoBillingProvider)[keyof typeof DeviceGroupDtoBillingProvider];

export const DeviceGroupDtoBillingProvider = {
    Unknown: "Unknown",
    StripeSandbox: "StripeSandbox",
    Stripe: "Stripe",
} as const;

export type DeviceGroupDtoBillingType =
    (typeof DeviceGroupDtoBillingType)[keyof typeof DeviceGroupDtoBillingType];

export const DeviceGroupDtoBillingType = {
    Private: "Private",
    Shared: "Shared",
} as const;

export type DeviceGroupServiceModelConfigDtoAvailability =
    (typeof DeviceGroupServiceModelConfigDtoAvailability)[keyof typeof DeviceGroupServiceModelConfigDtoAvailability];

export const DeviceGroupServiceModelConfigDtoAvailability = {
    Unknown: "Unknown",
    BusinessHours: "BusinessHours",
    Available24x7: "Available24x7",
    Varies: "Varies",
} as const;

export interface ServiceModelDetail {
    /** AKA Priority. Eg "SL1 Critical" */
    name?: string;
    /** eg 1-4, 1=highest */
    serviceLevel?: number;
    /** Free text description of the service level, eg "1 hour" or "Reasonable endeavours" */
    timeToResponse?: string;
    timeToSite?: string;
    timeToResolution?: string;
}

/**
 * Extra details for DeviceGroupType=ServiceModel
 */
export interface DeviceGroupServiceModelConfigDto {
    /** Optional name/ID of the service model in JIRA. If empty, falls back to device group name */
    externalServiceModelName?: string;
    /** Optional description of the service model config for this device group. */
    description?: string;
    availability?: DeviceGroupServiceModelConfigDtoAvailability;
    monitored?: boolean;
    /** SL1-4 Details */
    serviceModelDetails?: ServiceModelDetail[];
}

export type DeviceGroupScheduledMaintenanceConfigDtoServiceInterval =
    (typeof DeviceGroupScheduledMaintenanceConfigDtoServiceInterval)[keyof typeof DeviceGroupScheduledMaintenanceConfigDtoServiceInterval];

export const DeviceGroupScheduledMaintenanceConfigDtoServiceInterval = {
    Unknown: "Unknown",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    SemiAnnually: "SemiAnnually",
    Annually: "Annually",
} as const;

/**
 * Extra details for DeviceGroupType=ScheduledMaintenance
 */
export interface DeviceGroupScheduledMaintenanceConfigDto {
    serviceInterval?: DeviceGroupScheduledMaintenanceConfigDtoServiceInterval;
    /** Number of days before scheduled date to create tickets */
    leadTimeDays?: number;
    startDate?: Date;
    endDate?: Date;
    /** Optional description of the scheduled maintenance config */
    description?: string;
    /** Populated from SiteDeviceGroup.DeviceGroupTag */
    siteDeviceGroupTag?: string;
    /** Populated from SiteDeviceGroup.DeviceGroupName */
    siteName?: string;
    /** The contractor assigned to this scheduled maintenance group */
    contractor?: string;
}

export interface DeviceGroupDto {
    /** Group tag. Unique, read only. Equal to the OrganisationId when DeviceGroupType=Organisation (or OrganisationGroupId when DeviceGroupType=OrganisationGroup). Otherwise, may be auto generated from Type_Organisation_Name field */
    deviceGroupTag?: string;
    deviceGroupType?: DeviceGroupDtoDeviceGroupType;
    /** Free text name, eg 'Head office carpark'. */
    deviceGroupName?: string;
    /** The owner of this group. Not null, unless DeviceGroupType==OrganisationGroup|EndUser* */
    organisationId?: string;
    /** The id of the owning organisation's parent organisation, if any. Only populated for DeviceGroupType=Organisation groups whose organisation has a parent. */
    parentOrganisationId?: string;
    /** The name of the owning organisation's parent organisation, if any. Only populated for DeviceGroupType=Organisation groups whose organisation has a parent. */
    parentOrganisationName?: string;
    /** The owner of this group. Null, unless DeviceGroupType==OrganisationGroup */
    organisationGroupId?: string;
    /** The user that created the group. Usually null for DeviceGroupType==Organisation and OrganisationGroup. */
    createdByUserAccountId?: number;
    createdAt?: Date;
    updatedAt?: Date;
    internalNotes?: string;
    deviceGroupAddress?: AddressDto;
    billingProvider?: DeviceGroupDtoBillingProvider;
    billingCurrencyCode?: string;
    billingDescription?: string;
    billingSiteHostPaymentInfo?: string;
    /** The id of the subscription product in the Provider's system. If not set, defaults to StripeProviderOptions.SubscriptionPriceId */
    billingSubscriptionSku?: string;
    /** The price of the subscription (for display only) */
    billingSubscriptionPrice?: number;
    billingType?: DeviceGroupDtoBillingType;
    serviceModelConfig?: DeviceGroupServiceModelConfigDto;
    scheduledMaintenanceConfig?: DeviceGroupScheduledMaintenanceConfigDto;
    contacts?: ContactDto[];
    isFavourite?: boolean;
    /** Count of non-virtual devices. */
    devicesCount?: number;
}

export interface DeviceReferenceRequest {
    deviceIdentity?: string;
    deviceArchiveId?: number;
    cascadeToChildDevices?: boolean;
}

export interface DeviceGroupMapDevicesRequest {
    /** List of devices to be added to the group. */
    devicesToAdd?: DeviceReferenceRequest[];
    /** List of devices to be removed from the group. */
    devicesToRemove?: DeviceReferenceRequest[];
}

export interface DeviceGroupMapRfidTagsRequest {
    /** List of RfidTagIds to be added to the group */
    rfidTagsToAdd?: number[];
    /** List of RfidTagIds to be removed from the group */
    rfidTagsToRemove?: number[];
}

export interface DeviceGroupMapUserAccountsRequest {
    /** List of UserAccountIds to be added to the group */
    userAccountsToAdd?: number[];
    /** List of UserAccountIds to be removed from the group */
    userAccountsToRemove?: number[];
}

export interface DeviceGroupUptimeResponse {
    /** Average of all connector uptimes. Ignores Offline/Online status. */
    avgConnectorUptimesIncludeOffline?: number;
    /** Average of all connector uptimes. Offline reduces connector uptimes. */
    avgConnectorUptimesExcludeOffline?: number;
    /** Average of all device uptimes. Ignores Offline/Online status. */
    avgDeviceUptimesIncludeOffline?: number;
    /** Average of all device uptimes. Offline reduces device uptimes. */
    avgDeviceUptimesExcludeOffline?: number;
    /** Preferred device uptime based on organisation preference. Defaults to AvgDeviceUptimesIncludeOffline if preference not set. */
    preferredDeviceUptime?: number;
    /** Indicates which calculation was used for PreferredDeviceUptime. true = offline included, false = offline excluded. */
    isOfflineIncludedInDeviceUptime?: boolean;
    /** Preferred connector uptime based on organisation preference. Defaults to AvgConnectorUptimesIncludeOffline if preference not set. */
    preferredConnectorUptime?: number;
    /** Indicates which calculation was used for PreferredConnectorUptime. true = offline included, false = offline excluded. */
    isOfflineIncludedInConnectorUptime?: boolean;
    /** Calculation period start. */
    periodStart?: Date;
    /** Calculation period end. */
    periodEnd?: Date;
}

/**
 * Methods that can be called on the hub
 */
export interface DeviceHubInputMethods {
    /** Invoke it via `signalRHub.("joinGroup", groupName)
  groupName: either device_<deviceId> to subscribe to a device, or TODO... */
    joinGroup?: string;
    /** Invoke it via `signalRHub.("leaveGroup", groupName)
     */
    leaveGroup?: string;
}

/**
 * Objects of type TestMessage are sent to hub method named testMessage Listen to it via `signalRHub.on("testMessage", (message: TestMessage) => {}`
Currently a timer emits a message on this method to all clients once a minute, as a demo.
 */
export interface TestMessage {
    connectionId?: string;
    sender?: string;
    text?: string;
}

export type DeviceStatusSrmDeviceType =
    (typeof DeviceStatusSrmDeviceType)[keyof typeof DeviceStatusSrmDeviceType];

export const DeviceStatusSrmDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

/**
 * Device.SimpleDeviceStatus
 */
export type DeviceStatusSrmSimpleDeviceState =
    (typeof DeviceStatusSrmSimpleDeviceState)[keyof typeof DeviceStatusSrmSimpleDeviceState];

export const DeviceStatusSrmSimpleDeviceState = {
    Unknown: "Unknown",
    Available: "Available",
    InUse: "InUse",
    Faulted: "Faulted",
    Raised: "Raised",
    Lowered: "Lowered",
    NoCurtailment: "NoCurtailment",
    LightCurtailment: "LightCurtailment",
    HeavyCurtailment: "HeavyCurtailment",
} as const;

/**
 * Corresponds to Connector.ConnectorState
 */
export type DeviceStatusSrmConnectorSimpleConnectorState =
    (typeof DeviceStatusSrmConnectorSimpleConnectorState)[keyof typeof DeviceStatusSrmConnectorSimpleConnectorState];

export const DeviceStatusSrmConnectorSimpleConnectorState = {
    Unknown: "Unknown",
    Available: "Available",
    Preparing: "Preparing",
    Charging: "Charging",
    Discharging: "Discharging",
    Suspended: "Suspended",
    Finishing: "Finishing",
    FullyCharged: "FullyCharged",
    Reserved: "Reserved",
    Unavailable: "Unavailable",
    Faulted: "Faulted",
} as const;

export interface DeviceStatusSrmConnector {
    connectorIndex?: number;
    /** Corresponds to Connector.ConnectorState */
    simpleConnectorState?: DeviceStatusSrmConnectorSimpleConnectorState;
    /** Corresponds to Connector.ConnectorStatus */
    state?: string;
    transactionId?: number;
}

/**
 * Any extra key-value info we want to push to frontend
 */
export type DeviceStatusSrmExtras = { [key: string]: string };

/**
 * Objects of type DeviceStatusSrm are sent to hub method named deviceStatusNotification in the device group device_<deviceId>. Srm == SignalR Message. Listen to it via `signalRHub.on('deviceStatusNotification', (message: DeviceStatusSrm) => {}`
 */
export interface DeviceStatusSrm {
    deviceId?: string;
    deviceType?: DeviceStatusSrmDeviceType;
    /** Device.Status */
    status?: string;
    /** Device.SimpleDeviceStatus */
    simpleDeviceState?: DeviceStatusSrmSimpleDeviceState;
    /** The index of the connector (or device if 0) that triggered this message */
    connectorIndex?: number;
    timestamp?: Date;
    /** The source of this event. One of:
  DeviceStatus, ConnectorStatus, StartTransaction, StopTransaction, Online, Offline */
    trigger?: string;
    isOnline?: boolean;
    /** Any extra key-value info we want to push to frontend */
    extras?: DeviceStatusSrmExtras;
    connectors?: DeviceStatusSrmConnector[];
}

export type DeviceLiveLogUpdateSrmDeviceType =
    (typeof DeviceLiveLogUpdateSrmDeviceType)[keyof typeof DeviceLiveLogUpdateSrmDeviceType];

export const DeviceLiveLogUpdateSrmDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

/**
 * Objects of type DeviceLiveLogUpdateSrm are sent to hub method named deviceLiveLogUpdateMessage in the device group device_<deviceId>. Srm == SignalR Message. Listen to it via `signalRHub.on('deviceLiveLogUpdateMessage', (message: DeviceLiveLogUpdateSrm) => {}`
 */
export interface DeviceLiveLogUpdateSrm {
    deviceId?: string;
    deviceType?: DeviceLiveLogUpdateSrmDeviceType;
    timestampUtc?: Date;
    sender?: string;
    messageId?: string;
    type?: string;
    action?: string;
    payload?: string;
}

export type TaskInfoUpdateMessageDeviceType =
    (typeof TaskInfoUpdateMessageDeviceType)[keyof typeof TaskInfoUpdateMessageDeviceType];

export const TaskInfoUpdateMessageDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

export type TaskInfoUpdateMessageTaskType =
    (typeof TaskInfoUpdateMessageTaskType)[keyof typeof TaskInfoUpdateMessageTaskType];

export const TaskInfoUpdateMessageTaskType = {
    HardReset: "HardReset",
    SoftReset: "SoftReset",
    UpdateFirmware: "UpdateFirmware",
    UpdatePayMateFirmware: "UpdatePayMateFirmware",
    StartCharge: "StartCharge",
    StopCharge: "StopCharge",
    UnlockConnector: "UnlockConnector",
    TriggerMessage: "TriggerMessage",
    ClearChargingProfile: "ClearChargingProfile",
    DisableEnableCharging: "DisableEnableCharging",
    ChangeConfiguration: "ChangeConfiguration",
    ChangeExtendedConfiguration: "ChangeExtendedConfiguration",
    SendMessage: "SendMessage",
    DeviceAlert: "DeviceAlert",
    LimitChargeTransaction: "LimitChargeTransaction",
    SetDefaultChargingProfile: "SetDefaultChargingProfile",
    Activate: "Activate",
    SolarOverride: "SolarOverride",
    SetCentralSystemPassThrough: "SetCentralSystemPassThrough",
    PauseResumeChargeTransaction: "PauseResumeChargeTransaction",
    UpdatePayMateConnectorPricing: "UpdatePayMateConnectorPricing",
    SaveDeviceLogFiles: "SaveDeviceLogFiles",
    PowerOutageSchedule: "PowerOutageSchedule",
    GridPowerRestoredNotification: "GridPowerRestoredNotification",
    KickConnection: "KickConnection",
    GetConfiguration: "GetConfiguration",
    SetCoreConfiguration: "SetCoreConfiguration",
    GetDistributionBoardRemoteProfiles: "GetDistributionBoardRemoteProfiles",
    SetDistributionBoardRemoteProfile: "SetDistributionBoardRemoteProfile",
    ClearDistributionBoardRemoteProfile: "ClearDistributionBoardRemoteProfile",
    WatchBalenaDevice: "WatchBalenaDevice",
    UpdateSupervision: "UpdateSupervision",
    SetDisplayedPrice: "SetDisplayedPrice",
    GetDisplayedPrice: "GetDisplayedPrice",
    StartOcppLogUpload: "StartOcppLogUpload",
} as const;

export type TaskInfoUpdateMessageStage =
    (typeof TaskInfoUpdateMessageStage)[keyof typeof TaskInfoUpdateMessageStage];

export const TaskInfoUpdateMessageStage = {
    Requested: "Requested",
    Started: "Started",
    Complete: "Complete",
    Failed: "Failed",
    Cancelled: "Cancelled",
} as const;

/**
 * Objects of type TaskInfoUpdateMessage are sent to hub method named taskInfoUpdateMessage to the task creator user only (no broadcast group). Listen to it via `signalRHub.on('taskInfoUpdateMessage', (message: TaskInfoUpdateMessage) => {}`
Message is forwarded directly from Service Bus - it's currently the same type
 */
export interface TaskInfoUpdateMessage {
    taskInfoId?: string;
    deviceId?: string;
    deviceType?: TaskInfoUpdateMessageDeviceType;
    createdAt?: Date;
    updatedAt?: Date;
    taskType?: TaskInfoUpdateMessageTaskType;
    stage?: TaskInfoUpdateMessageStage;
    userId?: string;
    result?: string;
    resultExtrasJson?: string;
    timeToLive?: string;
}

/**
 * Methods that clients subscribe to, that are invoked by the hub
 */
export interface DeviceHubOutputMethods {
    testMessage?: TestMessage;
    deviceStatus?: DeviceStatusSrm;
    deviceLiveLogUpdate?: DeviceLiveLogUpdateSrm;
    deviceAlertMessage?: DeviceAlertMessage;
    taskInfoUpdateMessage?: TaskInfoUpdateMessage;
    coreSnapshotMessage?: CoreSnapshotMessage;
    balenaDeviceNotificationMessage?: BalenaDeviceNotificationMessage;
}

export interface DeviceHubDocumentationResponse {
    inputMethods?: DeviceHubInputMethods;
    outputMethods?: DeviceHubOutputMethods;
}

export type DeviceInvitationDtoDeviceAccessLevel =
    (typeof DeviceInvitationDtoDeviceAccessLevel)[keyof typeof DeviceInvitationDtoDeviceAccessLevel];

export const DeviceInvitationDtoDeviceAccessLevel = {
    Owner: "Owner",
    SecondaryUser: "SecondaryUser",
} as const;

export type DeviceInvitationDtoType =
    (typeof DeviceInvitationDtoType)[keyof typeof DeviceInvitationDtoType];

export const DeviceInvitationDtoType = {
    DeviceOwnerVerification: "DeviceOwnerVerification",
    InstallerDeviceInvite: "InstallerDeviceInvite",
    SimpleDeviceInvite: "SimpleDeviceInvite",
    BillingDeviceInvite: "BillingDeviceInvite",
} as const;

export interface DeviceInvitationDto {
    deviceInvitationId?: number;
    code?: string;
    message?: string;
    deviceInstallationIds?: number[];
    deviceAccessLevel?: DeviceInvitationDtoDeviceAccessLevel;
    createdAt?: Date;
    updatedAt?: Date;
    expiresAt?: Date;
    acceptedAt?: Date;
    acceptedLimit?: number;
    acceptedCount?: number;
    type?: DeviceInvitationDtoType;
    accessDurationSeconds?: number;
    createdByUserAccountId?: number;
}

/**
 * The access level this invite allows access to
 */
export type DeviceInvitationRequestDeviceAccessLevel =
    (typeof DeviceInvitationRequestDeviceAccessLevel)[keyof typeof DeviceInvitationRequestDeviceAccessLevel];

export const DeviceInvitationRequestDeviceAccessLevel = {
    Owner: "Owner",
    SecondaryUser: "SecondaryUser",
} as const;

/**
 * Allowed values: InstallerDeviceInvite, SimpleDeviceInvite, BillingDeviceInvite.
 */
export type DeviceInvitationRequestType =
    (typeof DeviceInvitationRequestType)[keyof typeof DeviceInvitationRequestType];

export const DeviceInvitationRequestType = {
    DeviceOwnerVerification: "DeviceOwnerVerification",
    InstallerDeviceInvite: "InstallerDeviceInvite",
    SimpleDeviceInvite: "SimpleDeviceInvite",
    BillingDeviceInvite: "BillingDeviceInvite",
} as const;

export interface DeviceInvitationRequest {
    /** Optional message displayed to user when they accept the invite code */
    message?: string;
    /** list of devices this invite allows access to */
    devices?: DeviceReferenceRequest[];
    /** The access level this invite allows access to */
    deviceAccessLevel?: DeviceInvitationRequestDeviceAccessLevel;
    /** Allowed values: InstallerDeviceInvite, SimpleDeviceInvite, BillingDeviceInvite. */
    type?: DeviceInvitationRequestType;
    /** Max number of times this invite can be accepted. 1 for single use invites. If an AccessDurationSeconds is set, this must be 1 */
    acceptedLimit?: number;
    /** The duration this temporary invitiation grants access for. Access is removed after AcceptedAt+AccessDurationSeconds. Null for permanent access. */
    accessDurationSeconds?: number;
    /** Invitation expiration. If not set, a default (eg 1 month) is used. */
    expiresAt?: Date;
    /** IL-3658: Recipient name. Only for BillingDeviceInvite. */
    name?: string;
    /** IL-3658: Recipient mobile number in international format. Only for BillingDeviceInvite. */
    mobileNo?: string;
    /** IL-3658: Recipient email address. Only for BillingDeviceInvite. */
    email?: string;
}

export interface DeviceListReponse {
    errors?: string[];
    devices?: DeviceDto[];
    nextCursor?: number;
}

export type DeviceMaintenanceStatusLogDtoStatus =
    (typeof DeviceMaintenanceStatusLogDtoStatus)[keyof typeof DeviceMaintenanceStatusLogDtoStatus];

export const DeviceMaintenanceStatusLogDtoStatus = {
    NotRectified: "NotRectified",
    Rectified: "Rectified",
    Other: "Other",
    Decommissioned: "Decommissioned",
} as const;

/**
 * Currently set for Rectified status only.
 */
export type DeviceMaintenanceStatusLogDtoSubStatus =
    (typeof DeviceMaintenanceStatusLogDtoSubStatus)[keyof typeof DeviceMaintenanceStatusLogDtoSubStatus];

export const DeviceMaintenanceStatusLogDtoSubStatus = {
    Other: "Other",
    Rectified_Duet: "Rectified_Duet",
    Rectified_Commissions: "Rectified_Commissions",
    Rectified_OnsiteTech: "Rectified_OnsiteTech",
} as const;

export interface UserAccountSummary {
    userAccountId?: number;
    name?: string;
    username?: string;
}

export interface DeviceMaintenanceStatusLogDto {
    deviceMaintenanceStatusLogId?: number;
    deviceInstallationId?: number;
    userAccountId?: number;
    createdAt?: Date;
    status?: DeviceMaintenanceStatusLogDtoStatus;
    notes?: string;
    /** Currently set for Rectified status only. */
    subStatus?: DeviceMaintenanceStatusLogDtoSubStatus;
    /** User-entered date this occurred (as opposed to when it was logged). */
    actionedAt?: Date;
    userAccount?: UserAccountSummary;
}

export type DeviceOwnerDtoAccountStatus =
    (typeof DeviceOwnerDtoAccountStatus)[keyof typeof DeviceOwnerDtoAccountStatus];

export const DeviceOwnerDtoAccountStatus = {
    Invited: "Invited",
    Pending: "Pending",
    Active: "Active",
    Suspended: "Suspended",
    Closed: "Closed",
} as const;

export type DeviceOwnerDtoType =
    (typeof DeviceOwnerDtoType)[keyof typeof DeviceOwnerDtoType];

export const DeviceOwnerDtoType = {
    Private: "Private",
    SiteManager: "SiteManager",
} as const;

export interface DeviceOwnerDto {
    deviceOwnerId?: number;
    accountStatus?: DeviceOwnerDtoAccountStatus;
    type?: DeviceOwnerDtoType;
    ownerUserAccountId?: number;
    /** Old single field Address. */
    address?: string;
    name?: string;
    mobileNo?: string;
    email?: string;
    createdAt?: Date;
    updatedAt?: Date;
    internalNotes?: string;
    devices?: DeviceDto[];
    ownerUserAccount?: UserAccountSummary;
    ownerAddress?: AddressDto;
}

export interface DevicePricingScheduleGroupDto {
    /** The device connector indexes that have a pricing schedule assigned. */
    connectorIndexes?: number[];
    device?: DeviceDto;
}

/**
 * Requested protocol for the device. Must be one of the SupportedProtocol values.
 */
export type DeviceProtocolUpdateDtoProtocol =
    (typeof DeviceProtocolUpdateDtoProtocol)[keyof typeof DeviceProtocolUpdateDtoProtocol];

export const DeviceProtocolUpdateDtoProtocol = {
    Unknown: "Unknown",
    ocpp16: "ocpp1.6",
    jcwp18: "jcwp1.8",
    jclp11: "jclp1.1",
    jccp: "jccp",
    "jcpp-pb": "jcpp-pb",
    ocpp201: "ocpp2.0.1",
} as const;

export interface DeviceProtocolUpdateDto {
    /** Requested protocol for the device. Must be one of the SupportedProtocol values. */
    protocol?: DeviceProtocolUpdateDtoProtocol;
    /** If true, restart the device after updating the protocol. This is required for the new protocol to take effect as we can only choose the protocol for connection when a device initiates a connection. */
    restartDevice?: boolean;
}

/**
 * Currently only Recurring templates are supported
 */
export type DeviceScheduleTemplateDtoScheduleType =
    (typeof DeviceScheduleTemplateDtoScheduleType)[keyof typeof DeviceScheduleTemplateDtoScheduleType];

export const DeviceScheduleTemplateDtoScheduleType = {
    Default: "Default",
    OneShot: "OneShot",
    Recurring: "Recurring",
    DeviceManaged: "DeviceManaged",
} as const;

/**
 * Active: show to enterprise and end usersInactive: show to enterprise onlyDeleted: not shown
 */
export type DeviceScheduleTemplateDtoStatus =
    (typeof DeviceScheduleTemplateDtoStatus)[keyof typeof DeviceScheduleTemplateDtoStatus];

export const DeviceScheduleTemplateDtoStatus = {
    Unknown: "Unknown",
    Active: "Active",
    Inactive: "Inactive",
    Deleted: "Deleted",
} as const;

export type DeviceScheduleTemplateItemBaseOperatingMode =
    (typeof DeviceScheduleTemplateItemBaseOperatingMode)[keyof typeof DeviceScheduleTemplateItemBaseOperatingMode];

export const DeviceScheduleTemplateItemBaseOperatingMode = {
    Unknown: "Unknown",
    ExportSolar: "ExportSolar",
    AllSolar: "AllSolar",
    GridOnly: "GridOnly",
} as const;

export type DeviceScheduleTemplateItemSessionOperatingMode =
    (typeof DeviceScheduleTemplateItemSessionOperatingMode)[keyof typeof DeviceScheduleTemplateItemSessionOperatingMode];

export const DeviceScheduleTemplateItemSessionOperatingMode = {
    None: "None",
    Fast: "Fast",
    Pause: "Pause",
} as const;

export interface DeviceScheduleTemplateItem {
    baseOperatingMode?: DeviceScheduleTemplateItemBaseOperatingMode;
    sessionOperatingMode?: DeviceScheduleTemplateItemSessionOperatingMode;
    setpointA?: number;
    cronExpression?: string;
    durationSeconds?: number;
    /** Optional description. If null, the DeviceScheduleTemplate.Description is used when applying the template. */
    description?: string;
}

export interface DeviceScheduleTemplateDto {
    deviceScheduleTemplateId?: number;
    /** Currently only Recurring templates are supported */
    scheduleType?: DeviceScheduleTemplateDtoScheduleType;
    /** Active: show to enterprise and end usersInactive: show to enterprise onlyDeleted: not shown */
    status?: DeviceScheduleTemplateDtoStatus;
    /** Used to determine if a template may be applied to a charger:True: schedule items are for solar aware chargers only.False: schedule items are for non-solar aware chargers only.Null: don't care (both).Once a Template is created, this value is read-only. */
    solarAware?: boolean;
    /** True if the template's schedules should cover an entire period (entire day or week). False if there are gaps. Once a Template is created, this value is read-only. */
    gapless?: boolean;
    /** The time zone the template is for, eg 'Australia/Melbourne', 'UTC+10' (NEM time).Certain retailers still define peak/off-peak rates in the NEM timezone, which is UTC+10 everywhere. In this case, explicitly set the timezone on the template.If instead, the retailer defines their times based on the customer's location, then leave it null and the user's local time zone will be used when applying this template. */
    timeZone?: string;
    /** Optional user facing name, eg 'MyRetailer SimplePlan Off-Peak' */
    description?: string;
    /** Templates are ordered by Organisation.RowSequence,DeviceScheduleTemplate.RowSequence asc. */
    rowSequence?: number;
    /** Template org, required when creating (unless creating global template) */
    organisationId?: string;
    /** Read-only org name */
    organisationName?: string;
    createdAt?: Date;
    updatedAt?: Date;
    /** Currently only Recurring templates are supported */
    schedules?: DeviceScheduleTemplateItem[];
}

export interface DeviceSessionSummary {
    /** The device identity (e.g., CM001) */
    deviceIdentity?: string;
    /** The device friendly name */
    friendlyName?: string;
    /** Total number of charging sessions */
    sessionCount?: number;
    /** Total energy delivered in Wh */
    energyWh?: number;
    /** Charging success rate as a percentage (0-100) */
    chargingSuccessRate?: number;
    /** The device group tag for the parent site */
    siteGroupTag?: string;
    /** The parent site name */
    siteName?: string;
    /** The device group tag for the parent organisation */
    orgGroupTag?: string;
    /** The parent organisation name */
    orgName?: string;
    /** Service model device group tag */
    serviceModelGroupTag?: string;
    /** Service model name */
    serviceModelName?: string;
    /** Device model (hardware model identifier) */
    deviceModel?: string;
    /** List of all device group tags this device belongs to */
    deviceGroupTags?: string[];
}

export interface DeviceStatusCount {
    /** JETCharge: for all devices in the system.
  DNSPsProject: For all devices in the Jemena project.
  Else one of DnspAccessTags enums */
    group?: string;
    /** offline, or unique values from Device.Status column */
    status?: string;
    /** The count of devices in this group, with this status */
    count?: number;
}

export interface DeviceStatusByDnspResponse {
    items?: DeviceStatusCount[];
}

export interface DeviceUptimeSummary {
    /** Device identity */
    deviceIdentity?: string;
    /** Device friendly name */
    friendlyName?: string;
    /** Number of connectors on this device */
    connectorCount?: number;
    /** Device uptime percentage (0-1). Offline periods are not considered. */
    uptimeOfflineIncluded?: number;
    /** Device uptime percentage (0-1). Offline periods are removed from calculation. */
    uptimeOfflineExcluded?: number;
    /** Preferred uptime based on organisation preference. */
    preferredUptime?: number;
    /** Whether offline is included in preferred calculation. */
    isOfflineIncluded?: boolean;
    /** Parent site device group tag */
    siteGroupTag?: string;
    /** Parent site name */
    siteName?: string;
    /** Parent organisation device group tag */
    orgGroupTag?: string;
    /** Parent organisation name */
    orgName?: string;
    /** Service model device group tag */
    serviceModelGroupTag?: string;
    /** Service model name */
    serviceModelName?: string;
    /** Device model (hardware model identifier) */
    deviceModel?: string;
    /** All device group tags this device belongs to (for OData filtering) */
    deviceGroupTags?: string[];
    /** Calculation period start */
    periodStart?: Date;
    /** Calculation period end */
    periodEnd?: Date;
}

export interface DisableEnableChargingTask {
    connectorIndex?: number;
    enable?: boolean;
}

export interface DistributionBoardSnapshotDto {
    uniqueId?: string;
    date?: Date;
    externalLoadL1Amps?: number;
    externalLoadL2Amps?: number;
    externalLoadL3Amps?: number;
    connectorsAssignedL1Amps?: number;
    connectorsAssignedL2Amps?: number;
    connectorsAssignedL3Amps?: number;
    feedbackConnectorsLoadL1Amps?: number;
    feedbackConnectorsLoadL2Amps?: number;
    feedbackConnectorsLoadL3Amps?: number;
    feedbackExternalLoadL1Amps?: number;
    feedbackExternalLoadL2Amps?: number;
    feedbackExternalLoadL3Amps?: number;
    operatingCapacityL1Amps?: number;
    operatingCapacityL2Amps?: number;
    operatingCapacityL3Amps?: number;
    activeProfileSnapshots?: ActiveProfileSnapshotDto[];
}

export interface DnspControlInterval {
    dnspEnvelopeId?: string;
    /** True if this was interpolated from the default operating envelope */
    isDefault?: boolean;
    /** Date and time of the start of the interval. This interval ends at the StartUtc of the next interval */
    startUtc?: Date;
    /** Charge limit in kW */
    maxChargeKw?: number;
    /** Discharge limit in kW (for V2G). Null if not set. */
    maxDischargeKw?: number;
}

export interface DnspDeviceControlIntervals {
    deviceId?: string;
    deviceType?: string;
    /** Continuous intervals for the whole time range, for this device. The `response.to` field is the end time of the last interval. */
    controlIntervals?: DnspControlInterval[];
}

export interface DnspControlIntervalsByDeviceResponse {
    /** List of all devices the DNSP controls. If no envelopes were specified for the date range, this will be 2 items, reflecting the default interval(s) by device type. If a single deviceId param was passed, then this will be that item only, or empty if the device does not exist. */
    devices?: DnspDeviceControlIntervals[];
    /** The query `from` param. Equal to the start of the first intervals */
    from?: Date;
    /** The query `to` param. Used as the end time of the last interval */
    to?: Date;
}

export interface DnspDerEventDevice {
    deviceId?: string;
    /** Eg ChargePoint, Wave */
    deviceType?: string;
    /** Date the device owner opted out of this event, or null if they have not */
    optedOutAt?: Date;
    /** If user opted out via SMS, contains their reply eg 'SMS: NO'. If an error occured eg device offline, contains 'Error: <msg>' */
    optOutReason?: string;
    /** TODO NYI. If there was an EV plugged in at any time during the event */
    didPlugIn?: boolean;
    /** TODO NYI. If there was an EV plugged in and actually charged during the event */
    didCharge?: boolean;
    /** TODO NYI. The estimated amount of power saved (load shed) by this device during the event. See https://jetcharge.atlassian.net/browse/ILLUM-765 for a discussion of how this is calculated. */
    powerSavedWh?: number;
}

export interface DnspDeviceOptOutStatusResponse {
    deviceId?: string;
    /** Eg ChargePoint, Wave */
    deviceType?: string;
    /** List of DerEventIds the device has opted out of (limited to most recent 100 descending) */
    optedOutOfDerEventIds?: string[];
    /** True if this device is online and connected to the Illuminate system */
    isOnline?: boolean;
    /** Device status, eg Available/Preparing/Charging/SuspendedEV/Faulted/Unavailable */
    status?: string;
}

/**
 * Event type, eg Solar Soak or Demand Response. Event type is included in the SMS templates, and determines the icon shown on the ChargeMate display during the event.
 */
export type DnspGetDerEventResponseDerEventType =
    (typeof DnspGetDerEventResponseDerEventType)[keyof typeof DnspGetDerEventResponseDerEventType];

export const DnspGetDerEventResponseDerEventType = {
    Default: "Default",
    DemandResponse: "DemandResponse",
    SolarSoak: "SolarSoak",
} as const;

export interface DnspGetDerEventResponse {
    derEventId?: string;
    /** Short info about the event. May be sent in the opt-out sms. Up to 100 chars. */
    shortInfo?: string;
    /** Longer description, not shown to users */
    description?: string;
    /** All devices involved in this Der Event (including opted-out) */
    devices?: DnspDerEventDevice[];
    /** Event start time (used to schedule the opt out sms reminder). All Envelopes for this event must start after this time. */
    startUtc?: Date;
    /** Event end time. All Envelopes for this event must end before this time. */
    endUtc?: Date;
    /** Event type, eg Solar Soak or Demand Response. Event type is included in the SMS templates, and determines the icon shown on the ChargeMate display during the event. */
    derEventType?: DnspGetDerEventResponseDerEventType;
    /** Name of the organisation that created this event. */
    dnspName?: string;
    /** Event status (scheduled / active / ended / cancelled) */
    status?: string;
    /** Date the first opt-out message was sent to the device owner */
    optOutsSentAt?: Date;
    /** Date any reminder message was sent to the device owner */
    remindersSentAt?: Date;
    /** Date the event was cancelled by the DNSP */
    cancelledAt?: Date;
    updatedAt?: Date;
    /** Count of all devices involved in this Der Event (including opted-out) */
    deviceCount?: number;
    /** Count of all devices involved in this Der Event that opted-out */
    optOutCount?: number;
    /** Count of all devices that did not opt out */
    participantCount?: number;
    /** TODO NYI. The number of participants that had an EV plugged in at any time during the event */
    participantPluggedInCount?: number;
    /** TODO NYI. The number of participants plugged in that actually charged their EV during the event */
    participantChargingCount?: number;
    /** TODO NYI. The estimated total amount of power saved (load shed). See https://jetcharge.atlassian.net/browse/ILLUM-765 for a discussion of how this is calculated. */
    powerSavedWh?: number;
    /** The template used for the initial SMS */
    initialTemplate?: string;
    /** The template used for the reminder SMS */
    reminderTemplate?: string;
    /** The template used for the start SMS */
    startTemplate?: string;
    /** The template used for the end SMS */
    endTemplate?: string;
    /** The template used for the cancellation SMS */
    cancelledTemplate?: string;
}

export interface EnergyConsumption {
    /** for debugging */
    cursor?: Date;
    /** for debugging. The raw db row timestamp. */
    rowValueUtc?: Date;
    /** The truncated time in UTC for the beginning of the interval (eg 'January' 2022 would be `2021-12-31T16:00:00` */
    timestamp?: Date;
    /** Date label, to avoid timezone conversions in frontend. eg:
  Hour: yyyy-MM-ddTHH:00:00
  Day: yyyy-MM-dd
  Week: 2022W01 (week-of-year, new weeks start on Sunday)
  Month: 2022M01 */
    label?: string;
    /** Energy in Wh */
    energy?: number;
}

export interface EnergyConsumptionResponse {
    items?: EnergyConsumption[];
    /** Currently always 'Australia/NEM_Time'. NEM Time is always UTC+10, with no daylight savings */
    siteTimeZone?: string;
}

export interface ETag {
    [key: string]: unknown;
}

/**
 * Report period
 */
export type FaultedDeviceReportMetadataPeriod =
    (typeof FaultedDeviceReportMetadataPeriod)[keyof typeof FaultedDeviceReportMetadataPeriod];

export const FaultedDeviceReportMetadataPeriod = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Annually: "Annually",
} as const;

/**
 * Only provided for WebhookType==FaultedDeviceReport
 */
export interface FaultedDeviceReportMetadata {
    /** Report period */
    period?: FaultedDeviceReportMetadataPeriod;
}

export interface FaultGuruRecommendationResponse {
    description?: string;
    recommendation?: string;
}

export type GetCoreConfigResponseType =
    (typeof GetCoreConfigResponseType)[keyof typeof GetCoreConfigResponseType];

export const GetCoreConfigResponseType = {
    Shadow: "Shadow",
    Draft: "Draft",
    Published: "Published",
} as const;

export interface GetCoreConfigResponse {
    uniqueId?: string;
    schemaVersion?: number;
    createdAt?: Date;
    type?: GetCoreConfigResponseType;
    coreConfig?: string;
}

export interface GetDisplayedPriceTask {
    forceRefresh?: boolean;
}

export interface GlobalDeviceStatusResponse {
    items?: DeviceStatusCount[];
}

export interface GlobalUptimeResponse {
    deviceGroupTag?: string;
    /** Uptime as a fraction between 0 and 1, where 1 = 100% uptime. Note: despite the name this is not a percentage. */
    uptimePercentage?: number;
    /** Percentage difference in uptime (based on UptimePercentage) from the previous period, can be null if previous period does not have data. */
    diffPercentage?: number;
    periodStart?: Date;
    periodEnd?: Date;
}

export interface GroupedTrendItem {
    /** The unique identifier for this group (e.g., device identity or device group tag) */
    groupId?: string;
    /** The display name for this group */
    groupName?: string;
    /** Array of daily charging success rate data points for this group */
    dailyTrends?: DailyChargingSuccessRateDto[];
}

export interface GroupedChargingSuccessRateTrendResponse {
    /** Array of trend data grouped by the requested grouping (device, device group, org, etc.) */
    groups?: GroupedTrendItem[];
}

export type IlluminateUserUserType =
    (typeof IlluminateUserUserType)[keyof typeof IlluminateUserUserType];

export const IlluminateUserUserType = {
    Unknown: "Unknown",
    EnterpriseUser: "EnterpriseUser",
    EndUser: "EndUser",
    ApiUser: "ApiUser",
    Driver: "Driver",
} as const;

export type IlluminateUserPermissionsItem =
    (typeof IlluminateUserPermissionsItem)[keyof typeof IlluminateUserPermissionsItem];

export const IlluminateUserPermissionsItem = {
    none: "none",
    device_location_read: "device_location_read",
    device_location_update: "device_location_update",
    device_config_read: "device_config_read",
    device_config_update: "device_config_update",
    device_reset: "device_reset",
    device_logs_read: "device_logs_read",
    device_tasks_read: "device_tasks_read",
    device_tasks_create: "device_tasks_create",
    device_energy_usage_read: "device_energy_usage_read",
    device_operational_update: "device_operational_update",
    device_firmware_update: "device_firmware_update",
    charge_transactions_read: "charge_transactions_read",
    power_meter_values_read: "power_meter_values_read",
    user_tasks_read: "user_tasks_read",
    enterprise_user_account_read: "enterprise_user_account_read",
    enterprise_user_account_update: "enterprise_user_account_update",
    enterprise_user_account_role_update: "enterprise_user_account_role_update",
    device_group_manage: "device_group_manage",
    device_group_create: "device_group_create",
    device_provisioning: "device_provisioning",
    device_passthrough_manage: "device_passthrough_manage",
    rfid_tags_read: "rfid_tags_read",
    rfid_tags_manage: "rfid_tags_manage",
    rfid_tags_delete: "rfid_tags_delete",
    role_create: "role_create",
    ticketing_read: "ticketing_read",
    ticketing_create: "ticketing_create",
    ppm_read: "ppm_read",
    ppm_manage: "ppm_manage",
    webhook_create: "webhook_create",
    notification_preferences_read: "notification_preferences_read",
    notification_preferences_manage: "notification_preferences_manage",
    notification_preferences_manage_others:
        "notification_preferences_manage_others",
    organisation_preferences_manage: "organisation_preferences_manage",
    media_manage: "media_manage",
    dnsp_dashboard: "dnsp_dashboard",
    project_dashboard: "project_dashboard",
    global_dashboard: "global_dashboard",
    system_device_provisioning: "system_device_provisioning",
    system_device_deprovisioning: "system_device_deprovisioning",
    system_device_access_tags_update: "system_device_access_tags_update",
    system_device_service_manage: "system_device_service_manage",
    system_device_catalogue_update: "system_device_catalogue_update",
    system_organisation: "system_organisation",
    system_user_account_manage: "system_user_account_manage",
    system_rfid_tags_manage: "system_rfid_tags_manage",
    system_passthrough_manage: "system_passthrough_manage",
    system_service_model_manage: "system_service_model_manage",
    system_vehicle_model_manage: "system_vehicle_model_manage",
    device_pricing_read: "device_pricing_read",
    device_pricing_manage: "device_pricing_manage",
    device_display_price_read: "device_display_price_read",
    device_display_price_manage: "device_display_price_manage",
    partner_device_provisioning: "partner_device_provisioning",
    partner_organisation_manage: "partner_organisation_manage",
    system_e2e_test_runner: "system_e2e_test_runner",
} as const;

export interface IlluminateUser {
    platformSource?: string;
    userType?: IlluminateUserUserType;
    /** email address */
    username?: string;
    name?: string;
    externalUserId?: string;
    externalIdentityKey?: string;
    userAccountId?: number;
    identityProvider?: string;
    permissions?: IlluminateUserPermissionsItem[];
    roles?: string[];
    organisationId?: string;
    organisationGroups?: string[];
    deviceGroupTags?: string[];
    /** Timestamp when user last accepted the terms and conditions */
    termsAcceptedAt?: Date;
}

export type InsertDeviceMaintenanceStatusRequestStatus =
    (typeof InsertDeviceMaintenanceStatusRequestStatus)[keyof typeof InsertDeviceMaintenanceStatusRequestStatus];

export const InsertDeviceMaintenanceStatusRequestStatus = {
    NotRectified: "NotRectified",
    Rectified: "Rectified",
    Other: "Other",
    Decommissioned: "Decommissioned",
} as const;

/**
 * Currently set for Rectified status only.
 */
export type InsertDeviceMaintenanceStatusRequestSubStatus =
    (typeof InsertDeviceMaintenanceStatusRequestSubStatus)[keyof typeof InsertDeviceMaintenanceStatusRequestSubStatus];

export const InsertDeviceMaintenanceStatusRequestSubStatus = {
    Other: "Other",
    Rectified_Duet: "Rectified_Duet",
    Rectified_Commissions: "Rectified_Commissions",
    Rectified_OnsiteTech: "Rectified_OnsiteTech",
} as const;

export interface InsertDeviceMaintenanceStatusRequest {
    status?: InsertDeviceMaintenanceStatusRequestStatus;
    notes?: string;
    /** Currently set for Rectified status only. */
    subStatus?: InsertDeviceMaintenanceStatusRequestSubStatus;
    /** User-entered date this occurred (as opposed to when it was logged). */
    actionedAt?: Date;
}

export interface InsertOrganisationRequest {
    organisationId?: string;
    fullName?: string;
    rowSequence?: number;
    externalMaintenanceTicketingName?: string;
    /** The max number of devices that users in this org can create. */
    deviceProvisioningLimit?: number;
    /** The group ids the new organisation is part of */
    organisationGroupIds?: string[];
}

/**
 * Admin users can set any assignment rule (but changing a role containing system_ permissions to anything other than InternalToInternal is not allowed). Non-admin users should supply null (or the existing value).
 */
export type InsertUpdateRoleRequestAssignmentRule =
    (typeof InsertUpdateRoleRequestAssignmentRule)[keyof typeof InsertUpdateRoleRequestAssignmentRule];

export const InsertUpdateRoleRequestAssignmentRule = {
    Unknown: "Unknown",
    Any: "Any",
    InternalToInternal: "InternalToInternal",
    InternalToAny: "InternalToAny",
} as const;

export type InsertUpdateRoleRequestPermissionsItem =
    (typeof InsertUpdateRoleRequestPermissionsItem)[keyof typeof InsertUpdateRoleRequestPermissionsItem];

export const InsertUpdateRoleRequestPermissionsItem = {
    none: "none",
    device_location_read: "device_location_read",
    device_location_update: "device_location_update",
    device_config_read: "device_config_read",
    device_config_update: "device_config_update",
    device_reset: "device_reset",
    device_logs_read: "device_logs_read",
    device_tasks_read: "device_tasks_read",
    device_tasks_create: "device_tasks_create",
    device_energy_usage_read: "device_energy_usage_read",
    device_operational_update: "device_operational_update",
    device_firmware_update: "device_firmware_update",
    charge_transactions_read: "charge_transactions_read",
    power_meter_values_read: "power_meter_values_read",
    user_tasks_read: "user_tasks_read",
    enterprise_user_account_read: "enterprise_user_account_read",
    enterprise_user_account_update: "enterprise_user_account_update",
    enterprise_user_account_role_update: "enterprise_user_account_role_update",
    device_group_manage: "device_group_manage",
    device_group_create: "device_group_create",
    device_provisioning: "device_provisioning",
    device_passthrough_manage: "device_passthrough_manage",
    rfid_tags_read: "rfid_tags_read",
    rfid_tags_manage: "rfid_tags_manage",
    rfid_tags_delete: "rfid_tags_delete",
    role_create: "role_create",
    ticketing_read: "ticketing_read",
    ticketing_create: "ticketing_create",
    ppm_read: "ppm_read",
    ppm_manage: "ppm_manage",
    webhook_create: "webhook_create",
    notification_preferences_read: "notification_preferences_read",
    notification_preferences_manage: "notification_preferences_manage",
    notification_preferences_manage_others:
        "notification_preferences_manage_others",
    organisation_preferences_manage: "organisation_preferences_manage",
    media_manage: "media_manage",
    dnsp_dashboard: "dnsp_dashboard",
    project_dashboard: "project_dashboard",
    global_dashboard: "global_dashboard",
    system_device_provisioning: "system_device_provisioning",
    system_device_deprovisioning: "system_device_deprovisioning",
    system_device_access_tags_update: "system_device_access_tags_update",
    system_device_service_manage: "system_device_service_manage",
    system_device_catalogue_update: "system_device_catalogue_update",
    system_organisation: "system_organisation",
    system_user_account_manage: "system_user_account_manage",
    system_rfid_tags_manage: "system_rfid_tags_manage",
    system_passthrough_manage: "system_passthrough_manage",
    system_service_model_manage: "system_service_model_manage",
    system_vehicle_model_manage: "system_vehicle_model_manage",
    device_pricing_read: "device_pricing_read",
    device_pricing_manage: "device_pricing_manage",
    device_display_price_read: "device_display_price_read",
    device_display_price_manage: "device_display_price_manage",
    partner_device_provisioning: "partner_device_provisioning",
    partner_organisation_manage: "partner_organisation_manage",
    system_e2e_test_runner: "system_e2e_test_runner",
} as const;

export interface InsertUpdateRoleRequest {
    roleId?: string;
    /** Admin users can provide null to create a role available to all organisations, or any specific one. Other users must provide their organisation here. */
    organisationId?: string;
    isInsert?: boolean;
    description?: string;
    /** Admin users can set any assignment rule (but changing a role containing system_ permissions to anything other than InternalToInternal is not allowed). Non-admin users should supply null (or the existing value). */
    assignmentRule?: InsertUpdateRoleRequestAssignmentRule;
    permissions?: InsertUpdateRoleRequestPermissionsItem[];
}

export interface LimitChargeTransactionTask {
    connectorIndex?: number;
    transactionId?: number;
    maxChargeKw?: number;
    maxDischargeKw?: number;
    endTime?: Date;
}

export interface LinkRfidTagsRequest {
    /** @minItems 1 */
    rfidTagIds?: number[];
}

export type LoadReductionDtoStatus =
    (typeof LoadReductionDtoStatus)[keyof typeof LoadReductionDtoStatus];

export const LoadReductionDtoStatus = {
    NoLoadReduction: "NoLoadReduction",
    LightLoadReduction: "LightLoadReduction",
    HeavyLoadReduction: "HeavyLoadReduction",
} as const;

export interface LoadReductionDto {
    date?: Date;
    status?: LoadReductionDtoStatus;
}

export interface LogMessageOutputModel {
    deviceIdentity?: string;
    timestampUtc?: Date;
    loggedAt?: Date;
    sender?: string;
    messageId?: string;
    type?: string;
    payload?: string;
    action?: string;
    partitionKey?: string;
    rowKey?: string;
    timestamp?: Date;
    eTag?: ETag;
}

/**
 * Category may be used to distinguish site maps from charger photos, etc. Required.
 */
export type MediaItemDtoCategory =
    (typeof MediaItemDtoCategory)[keyof typeof MediaItemDtoCategory];

export const MediaItemDtoCategory = {
    Unknown: "Unknown",
    SiteMap: "SiteMap",
    DevicePhoto: "DevicePhoto",
} as const;

export interface MediaItemDto {
    mediaItemId?: number;
    /** The org this media belongs to. */
    organisationId?: string;
    /** Full url to the file, including access token. */
    url?: string;
    /** filename excluding path. Required. */
    filename?: string;
    /** File size. Required. */
    sizeBytes?: number;
    /** Standard content type eg image/jpeg. Currently images, text, and pdfs are allowed. Required. */
    contentType?: string;
    /** Category may be used to distinguish site maps from charger photos, etc. Required. */
    category?: MediaItemDtoCategory;
    /** optional user supplied name. */
    name?: string;
    /** optional user supplied description. */
    description?: string;
    /** The user that uploaded the media */
    createdByUserAccountId?: number;
    createdAt?: Date;
}

/**
 * Report period
 */
export type Nem12ReportMetadataPeriod =
    (typeof Nem12ReportMetadataPeriod)[keyof typeof Nem12ReportMetadataPeriod];

export const Nem12ReportMetadataPeriod = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Annually: "Annually",
} as const;

/**
 * Report units, default Wh
 */
export type Nem12ReportMetadataUnitOfMeasure =
    (typeof Nem12ReportMetadataUnitOfMeasure)[keyof typeof Nem12ReportMetadataUnitOfMeasure];

export const Nem12ReportMetadataUnitOfMeasure = {
    Wh: "Wh",
    kWh: "kWh",
} as const;

/**
 * Only provided for WebhookType==Nem12Report
 */
export interface Nem12ReportMetadata {
    /** List of deviceIds, or null for all devices. Prefer using DeviceGroupTag instead, for new webhooks. */
    deviceQuery?: string[];
    /** Report period */
    period?: Nem12ReportMetadataPeriod;
    /** Time in minutes of desired NEM Interval period (eg 5, 15, 30) */
    intervalMinutes?: number;
    /** Report units, default Wh */
    unitOfMeasure?: Nem12ReportMetadataUnitOfMeasure;
}

/**
 * Report units, default Wh
 */
export type Nem12ReportRequestUnitOfMeasure =
    (typeof Nem12ReportRequestUnitOfMeasure)[keyof typeof Nem12ReportRequestUnitOfMeasure];

export const Nem12ReportRequestUnitOfMeasure = {
    Wh: "Wh",
    kWh: "kWh",
} as const;

export interface Nem12ReportRequest {
    /** Time in minutes of desired NEM Interval period (eg 5, 15, 30) */
    intervalMinutes?: number;
    /** Report units, default Wh */
    unitOfMeasure?: Nem12ReportRequestUnitOfMeasure;
    /** Date from, inclusive. Date only, eg '2023-10-04'. Reports are run using AEST only (UTC+10, no daylight savings) */
    dateFrom?: string;
    /** Date to, inclusive. Date only, eg '2023-10-04'. Reports are run using AEST only (UTC+10, no daylight savings) */
    dateTo?: string;
    /** Report is run for all operational devices in this group. Prefer using DeviceGroupTags instead. */
    deviceGroupTag?: string;
    /** Report is run for all operational devices in the intersection of all of these groups. Clients must provide at least one group they are directly assigned to, eg their org or a site. They may also provide groups they are not directly assigned to, eg ServiceModels */
    deviceGroupTags?: string[];
}

export interface NewDeviceFaultTicketPreview {
    summary?: string;
    description?: string;
    userAccountFound?: boolean;
    createUserAccountUrl?: string;
    error?: string;
    apiResult?: ApiResult;
}

export type NotificationMethodDtoMethod =
    (typeof NotificationMethodDtoMethod)[keyof typeof NotificationMethodDtoMethod];

export const NotificationMethodDtoMethod = {
    Unknown: "Unknown",
    Email: "Email",
    SMS: "SMS",
    PushNotification: "PushNotification",
} as const;

export interface NotificationMethodDto {
    method?: NotificationMethodDtoMethod;
    description?: string;
    isEnabled?: boolean;
}

export type NotificationPreferenceDtoNotificationTypesItem =
    (typeof NotificationPreferenceDtoNotificationTypesItem)[keyof typeof NotificationPreferenceDtoNotificationTypesItem];

export const NotificationPreferenceDtoNotificationTypesItem = {
    Unknown: "Unknown",
    FaultedStateDevice: "FaultedStateDevice",
    OfflineStateDevice: "OfflineStateDevice",
    UnknownStateDevice: "UnknownStateDevice",
    NonOperationalDevice: "NonOperationalDevice",
    EnergyPriceChargingSuspended: "EnergyPriceChargingSuspended",
    EnergyPriceChargingResumed: "EnergyPriceChargingResumed",
    Warning: "Warning",
    FrequentFaultsWarning: "FrequentFaultsWarning",
    ShortDurationWarning: "ShortDurationWarning",
    NoActivityWarning: "NoActivityWarning",
    ZerokWhWarning: "ZerokWhWarning",
    PowerLossWarning: "PowerLossWarning",
    LowEnergyMidSessionWarning: "LowEnergyMidSessionWarning",
    IdleStateDevice: "IdleStateDevice",
} as const;

export type NotificationPreferenceDtoNotificationMethodsItem =
    (typeof NotificationPreferenceDtoNotificationMethodsItem)[keyof typeof NotificationPreferenceDtoNotificationMethodsItem];

export const NotificationPreferenceDtoNotificationMethodsItem = {
    Unknown: "Unknown",
    Email: "Email",
    SMS: "SMS",
    PushNotification: "PushNotification",
} as const;

export type NotificationPreferenceDtoNotificationFrequency =
    (typeof NotificationPreferenceDtoNotificationFrequency)[keyof typeof NotificationPreferenceDtoNotificationFrequency];

export const NotificationPreferenceDtoNotificationFrequency = {
    Unknown: "Unknown",
    RealTime: "RealTime",
    Scheduled: "Scheduled",
} as const;

export type NotificationScheduleDtoScheduleType =
    (typeof NotificationScheduleDtoScheduleType)[keyof typeof NotificationScheduleDtoScheduleType];

export const NotificationScheduleDtoScheduleType = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Interval: "Interval",
} as const;

export type NotificationScheduleDtoIntervalUnit =
    (typeof NotificationScheduleDtoIntervalUnit)[keyof typeof NotificationScheduleDtoIntervalUnit];

export const NotificationScheduleDtoIntervalUnit = {
    Minutes: "Minutes",
    Hours: "Hours",
    Days: "Days",
    Weeks: "Weeks",
    Months: "Months",
} as const;

export interface NotificationScheduleDto {
    notificationScheduleId?: number;
    scheduleType?: NotificationScheduleDtoScheduleType;
    scheduledTime?: string;
    daysOfWeek?: number;
    dayOfMonth?: number;
    intervalValue?: number;
    intervalUnit?: NotificationScheduleDtoIntervalUnit;
    timeZone?: string;
    nextScheduledRun?: Date;
}

export interface NotificationPreferenceDto {
    notificationPreferenceId?: number;
    userAccountId?: number;
    userName?: string;
    userEmail?: string;
    deviceGroupTags?: string[];
    deviceIdentities?: string[];
    notificationTypes?: NotificationPreferenceDtoNotificationTypesItem[];
    notificationMethods?: NotificationPreferenceDtoNotificationMethodsItem[];
    notificationFrequency?: NotificationPreferenceDtoNotificationFrequency;
    schedule?: NotificationScheduleDto;
    createdAt?: Date;
    updatedAt?: Date;
}

export type NotificationTypeDtoType =
    (typeof NotificationTypeDtoType)[keyof typeof NotificationTypeDtoType];

export const NotificationTypeDtoType = {
    Unknown: "Unknown",
    FaultedStateDevice: "FaultedStateDevice",
    OfflineStateDevice: "OfflineStateDevice",
    UnknownStateDevice: "UnknownStateDevice",
    NonOperationalDevice: "NonOperationalDevice",
    EnergyPriceChargingSuspended: "EnergyPriceChargingSuspended",
    EnergyPriceChargingResumed: "EnergyPriceChargingResumed",
    Warning: "Warning",
    FrequentFaultsWarning: "FrequentFaultsWarning",
    ShortDurationWarning: "ShortDurationWarning",
    NoActivityWarning: "NoActivityWarning",
    ZerokWhWarning: "ZerokWhWarning",
    PowerLossWarning: "PowerLossWarning",
    LowEnergyMidSessionWarning: "LowEnergyMidSessionWarning",
    IdleStateDevice: "IdleStateDevice",
} as const;

export interface NotificationTypeDto {
    type?: NotificationTypeDtoType;
    description?: string;
    isEnabled?: boolean;
}

export type OccpLogEntryStatus =
    (typeof OccpLogEntryStatus)[keyof typeof OccpLogEntryStatus];

export const OccpLogEntryStatus = {
    Pending: "Pending",
    Uploading: "Uploading",
    Complete: "Complete",
    Failed: "Failed",
    Unknown: "Unknown",
} as const;

export interface OccpLogEntry {
    deviceIdentity?: string;
    fileName?: string;
    fileUrl?: string;
    fileSizeBytes?: number;
    created?: Date;
    status?: OccpLogEntryStatus;
    progressPercentage?: number;
}

export type OfferDtoStatus =
    (typeof OfferDtoStatus)[keyof typeof OfferDtoStatus];

export const OfferDtoStatus = {
    Unknown: "Unknown",
    Active: "Active",
    Disabled: "Disabled",
    Archived: "Archived",
} as const;

export interface OfferDto {
    offerId?: number;
    organisationId?: string;
    name?: string;
    description?: string;
    discountPercent?: number;
    status?: OfferDtoStatus;
    startsAt?: Date;
    expiresAt?: Date;
    createdAt?: Date;
    updatedAt?: Date;
    createdByUserAccountId?: number;
    deviceGroupTags?: string[];
}

export interface OfferRedemptionDto {
    offerRedemptionId?: number;
    offerId?: number;
    code?: string;
    redeemedAt?: Date;
    user?: UserAccountSummary;
}

export type OfferRequestStatus =
    (typeof OfferRequestStatus)[keyof typeof OfferRequestStatus];

export const OfferRequestStatus = {
    Unknown: "Unknown",
    Active: "Active",
    Disabled: "Disabled",
    Archived: "Archived",
} as const;

export interface OfferRequest {
    organisationId?: string;
    name?: string;
    description?: string;
    discountPercent?: number;
    status?: OfferRequestStatus;
    startsAt?: Date;
    expiresAt?: Date;
}

/**
 * Report period
 */
export type OfflineDeviceReportMetadataPeriod =
    (typeof OfflineDeviceReportMetadataPeriod)[keyof typeof OfflineDeviceReportMetadataPeriod];

export const OfflineDeviceReportMetadataPeriod = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Annually: "Annually",
} as const;

/**
 * Only provided for WebhookType==OfflineDeviceReport
 */
export interface OfflineDeviceReportMetadata {
    /** Report period */
    period?: OfflineDeviceReportMetadataPeriod;
}

export interface OnlineStatusItem {
    onlineStatusItemId?: number;
    deviceIdentity?: string;
    createdAt?: Date;
    updatedAt?: Date;
    online?: boolean;
    reason?: string;
    centralSystem?: string;
}

export interface OnlineStatusPercentageDto {
    date?: Date;
    onlinePercentage?: number;
    offlinePercentage?: number;
    remainingPercentage?: number;
}

export interface OrganisationGroupResponse {
    organisationGroupId?: string;
    fullName?: string;
    /** The organisation ids in this group (separated to avoid circular references). */
    organisationIds?: string[];
}

export type OrganisationPreferenceDtoPreferenceType =
    (typeof OrganisationPreferenceDtoPreferenceType)[keyof typeof OrganisationPreferenceDtoPreferenceType];

export const OrganisationPreferenceDtoPreferenceType = {
    Unknown: "Unknown",
    IncludeOfflineInUptimeCalculation: "IncludeOfflineInUptimeCalculation",
    LowEnergyDeliveryAcKwhThreshold: "LowEnergyDeliveryAcKwhThreshold",
    LowEnergyDeliveryDcKwhThreshold: "LowEnergyDeliveryDcKwhThreshold",
    LowEnergyDeliveryAcMinutesThreshold: "LowEnergyDeliveryAcMinutesThreshold",
    LowEnergyDeliveryDcMinutesThreshold: "LowEnergyDeliveryDcMinutesThreshold",
} as const;

export interface OrganisationPreferenceDto {
    organisationId?: string;
    preferenceType?: OrganisationPreferenceDtoPreferenceType;
    /** The value of the preference for the organisation (or a default value if not set on the org, or null if no default) */
    value?: string;
    /** Timestamp of when the preference was last updated. Null if never updated (ie using default value or no value) */
    updatedAt?: Date;
}

export type OrganisationPreferenceSchemaDtoPreferenceType =
    (typeof OrganisationPreferenceSchemaDtoPreferenceType)[keyof typeof OrganisationPreferenceSchemaDtoPreferenceType];

export const OrganisationPreferenceSchemaDtoPreferenceType = {
    Unknown: "Unknown",
    IncludeOfflineInUptimeCalculation: "IncludeOfflineInUptimeCalculation",
    LowEnergyDeliveryAcKwhThreshold: "LowEnergyDeliveryAcKwhThreshold",
    LowEnergyDeliveryDcKwhThreshold: "LowEnergyDeliveryDcKwhThreshold",
    LowEnergyDeliveryAcMinutesThreshold: "LowEnergyDeliveryAcMinutesThreshold",
    LowEnergyDeliveryDcMinutesThreshold: "LowEnergyDeliveryDcMinutesThreshold",
} as const;

export interface OrganisationPreferenceSchemaDto {
    preferenceType?: OrganisationPreferenceSchemaDtoPreferenceType;
    /** One of Int32, Decimal, Boolean, String */
    dataType?: string;
    /** Optional. The range (inclusive) of allowed values for a number, the character length for a string, or the list of allowed enums. eg: Int32: [0,100], Decimal: [0,99.9], String: [10,20], Boolean: null */
    values?: string;
    name?: string;
    description?: string;
    category?: string;
}

export interface OrganisationPreferenceResponseItem {
    schema?: OrganisationPreferenceSchemaDto;
    preferenceValue?: OrganisationPreferenceDto;
}

export interface OrganisationResponse {
    organisationId?: string;
    fullName?: string;
    /** Name of this org in JIRA service desk. If null, users in this org can't create maintenance tickets even if they hold ticketing_create. */
    externalMaintenanceTicketingName?: string;
    /** The max number of devices that users in this org can create. */
    deviceProvisioningLimit?: number;
    /** The parent (partner) organisation managing this org, if any. */
    parentOrganisationId?: string;
}

export interface OrganisationsResponse {
    /** True if this is the complete list of tags. This is the case if you are allowed to see all tags in the system (ie you are admin, or mineOnly=false) */
    isComplete?: boolean;
    organisationGroups?: OrganisationGroupResponse[];
    organisations?: OrganisationResponse[];
}

export interface OrgSessionSummary {
    /** The device group tag for this organisation */
    deviceGroupTag?: string;
    /** The organisation name */
    orgName?: string;
    /** Number of chargers in this organisation */
    chargerCount?: number;
    /** Total number of charging sessions */
    sessionCount?: number;
    /** Total energy delivered in Wh */
    energyWh?: number;
    /** Charging success rate as a percentage (0-100) */
    chargingSuccessRate?: number;
}

export interface OrgUptimeSummary {
    /** Organisation device group tag */
    deviceGroupTag?: string;
    /** Organisation name */
    orgName?: string;
    /** Number of chargers in this organisation */
    chargerCount?: number;
    /** Average device uptime percentage (0-1). Offline periods are not considered. */
    avgDeviceUptimeOfflineIncluded?: number;
    /** Average device uptime percentage (0-1). Offline periods are removed from calculation. */
    avgDeviceUptimeOfflineExcluded?: number;
    /** Preferred device uptime based on organisation preference. */
    preferredDeviceUptime?: number;
    /** Whether offline is included in device uptime calculation. */
    isOfflineIncludedInDeviceUptime?: boolean;
    /** Calculation period start */
    periodStart?: Date;
    /** Calculation period end */
    periodEnd?: Date;
}

/**
 * Protocol used between illuminate and the third party Central System
 */
export type PassthroughConfigDtoProtocol =
    (typeof PassthroughConfigDtoProtocol)[keyof typeof PassthroughConfigDtoProtocol];

export const PassthroughConfigDtoProtocol = {
    Unknown: "Unknown",
    ocpp16: "ocpp1.6",
    jcwp18: "jcwp1.8",
    jclp11: "jclp1.1",
    jccp: "jccp",
    "jcpp-pb": "jcpp-pb",
    ocpp201: "ocpp2.0.1",
} as const;

/**
 * Defines which connection logic to use
 */
export type PassthroughConfigDtoPassthroughType =
    (typeof PassthroughConfigDtoPassthroughType)[keyof typeof PassthroughConfigDtoPassthroughType];

export const PassthroughConfigDtoPassthroughType = {
    Default: "Default",
    Readonly: "Readonly",
} as const;

/**
 * Default auth mode, which is preselected when adding a virtual device.
 */
export type PassthroughConfigDtoPreferredAuthorizationMode =
    (typeof PassthroughConfigDtoPreferredAuthorizationMode)[keyof typeof PassthroughConfigDtoPreferredAuthorizationMode];

export const PassthroughConfigDtoPreferredAuthorizationMode = {
    LegacyBasicAuth: "LegacyBasicAuth",
    AutomaticBasicAuth: "AutomaticBasicAuth",
    ManualBasicAuth: "ManualBasicAuth",
    None: "None",
    Reject: "Reject",
} as const;

export interface PassthroughConfigDto {
    passthroughConfigId?: number;
    /** Optional when creating a passthrough */
    passthroughConfigSlug?: string;
    /** The central system this config will pass through to */
    centralSystemId?: string;
    /** Free text internal name */
    name?: string;
    /** Free text user-facing name. Usually just the Central System name */
    publicName?: string;
    /** Protocol used between illuminate and the third party Central System */
    protocol?: PassthroughConfigDtoProtocol;
    /** Defines which connection logic to use */
    passthroughType?: PassthroughConfigDtoPassthroughType;
    /** When false, no passthrough will occur, and it will be unavailable in the provisioning UI */
    enabled?: boolean;
    /** Default auth mode, which is preselected when adding a virtual device. */
    preferredAuthorizationMode?: PassthroughConfigDtoPreferredAuthorizationMode;
    /** The ordering of available passthroughs in the UI. Optional when creating a passthrough. */
    rowSequence?: number;
    createdAt?: Date;
    updatedAt?: Date;
    /** Url with scheme and optional port, eg 'wss://app.dev.somecpo.com:1234/ocpp/1.6/{deviceIdentity}'. No trailing slash. */
    url?: string;
}

export interface PauseResumeChargeTransactionTask {
    connectorIndex?: number;
    transactionId?: number;
    pause?: boolean;
}

/**
 * Response only: connector type
 */
export type PayMateConnectorAssignmentDtoConnectorType =
    (typeof PayMateConnectorAssignmentDtoConnectorType)[keyof typeof PayMateConnectorAssignmentDtoConnectorType];

export const PayMateConnectorAssignmentDtoConnectorType = {
    Unknown: "Unknown",
    CHAdeMO: "CHAdeMO",
    CCS: "CCS",
    CCS2: "CCS2",
    Type1: "Type1",
    Type2: "Type2",
    MCS: "MCS",
    Pantograph: "Pantograph",
    Domestic: "Domestic",
} as const;

export interface PayMateConnectorAssignmentDto {
    /** 1-based connector index, matching Connector.ConnectorIndex */
    connectorIndex?: number;
    /** The PayMate that sells this connector. In PUT requests, required and must be a child of the charger's linked PayMate. In GET responses: null if not sold by any terminal; otherwise either a child PayMate (split mode) or the charger's single linked PayMate (non-split mode) — see PayMateConnectorAssignmentsResponseDto.IsSplitAcrossPayMates. */
    payMateDeviceIdentity?: string;
    /** Response only: connector type */
    connectorType?: PayMateConnectorAssignmentDtoConnectorType;
    /** Response only: customer-facing connector label, eg 'Port A' */
    connectorLabel?: string;
    /** Response only: friendly name of the assigned PayMate */
    payMateFriendlyName?: string;
}

export interface PayMateConnectorAssignmentsResponseDto {
    /** The charger's linked PayMate device identity: the virtual parent if split across multiple terminals, or the single PayMate otherwise. Null if the charger has no linked PayMate at all. */
    payMateDeviceIdentity?: string;
    /** Friendly name of the linked PayMate. */
    payMateFriendlyName?: string;
    /** True if the linked PayMate has child PayMate terminals, meaning connectors are individually assigned via PayMateConnectorAssignment rows (some may be unsold). False if a single PayMate with no children sells every connector of this charger — the normal, non-split case. */
    hasChildPayMates?: boolean;
    /** One entry per connector on the charger. */
    connectors?: PayMateConnectorAssignmentDto[];
}

export type PayMateTransactionDtoStatus =
    (typeof PayMateTransactionDtoStatus)[keyof typeof PayMateTransactionDtoStatus];

export const PayMateTransactionDtoStatus = {
    Pending: "Pending",
    Active: "Active",
    Completed: "Completed",
    Aborted: "Aborted",
    Finishing: "Finishing",
} as const;

export interface PayMateTransactionDto {
    payMateSessionId?: number;
    chargerDeviceIdentity?: string;
    connectorIndex?: number;
    externalSession?: boolean;
    status?: PayMateTransactionDtoStatus;
    transactionId?: number;
    paymentId?: string;
    currencyCode?: string;
    preAuthAmountCharged?: number;
    finalAmountCharged?: number;
    sessionStart?: Date;
    sessionEnd?: Date;
    sessionTrackingUrl?: string;
    message?: string;
}

export type PaymentLogDtoProvider =
    (typeof PaymentLogDtoProvider)[keyof typeof PaymentLogDtoProvider];

export const PaymentLogDtoProvider = {
    Unknown: "Unknown",
    StripeSandbox: "StripeSandbox",
    Stripe: "Stripe",
} as const;

export type PaymentLogDtoOperation =
    (typeof PaymentLogDtoOperation)[keyof typeof PaymentLogDtoOperation];

export const PaymentLogDtoOperation = {
    Unknown: "Unknown",
    Subscription: "Subscription",
    StripeInvoice: "StripeInvoice",
    StripeMeterEvent: "StripeMeterEvent",
} as const;

export interface PaymentLogDto {
    paymentLogId?: number;
    createdAt?: Date;
    provider?: PaymentLogDtoProvider;
    providerUserId?: string;
    operation?: PaymentLogDtoOperation;
    currencyCode?: string;
    amount?: number;
    userBillingAccountId?: number;
    ledgerId?: string;
    deviceIdentity?: string;
    transactionId?: number;
    description?: string;
    providerOperation?: string;
    providerRef?: string;
    errorNo?: number;
    logDetails?: string;
}

export type PermissionResponsePermissionId =
    (typeof PermissionResponsePermissionId)[keyof typeof PermissionResponsePermissionId];

export const PermissionResponsePermissionId = {
    none: "none",
    device_location_read: "device_location_read",
    device_location_update: "device_location_update",
    device_config_read: "device_config_read",
    device_config_update: "device_config_update",
    device_reset: "device_reset",
    device_logs_read: "device_logs_read",
    device_tasks_read: "device_tasks_read",
    device_tasks_create: "device_tasks_create",
    device_energy_usage_read: "device_energy_usage_read",
    device_operational_update: "device_operational_update",
    device_firmware_update: "device_firmware_update",
    charge_transactions_read: "charge_transactions_read",
    power_meter_values_read: "power_meter_values_read",
    user_tasks_read: "user_tasks_read",
    enterprise_user_account_read: "enterprise_user_account_read",
    enterprise_user_account_update: "enterprise_user_account_update",
    enterprise_user_account_role_update: "enterprise_user_account_role_update",
    device_group_manage: "device_group_manage",
    device_group_create: "device_group_create",
    device_provisioning: "device_provisioning",
    device_passthrough_manage: "device_passthrough_manage",
    rfid_tags_read: "rfid_tags_read",
    rfid_tags_manage: "rfid_tags_manage",
    rfid_tags_delete: "rfid_tags_delete",
    role_create: "role_create",
    ticketing_read: "ticketing_read",
    ticketing_create: "ticketing_create",
    ppm_read: "ppm_read",
    ppm_manage: "ppm_manage",
    webhook_create: "webhook_create",
    notification_preferences_read: "notification_preferences_read",
    notification_preferences_manage: "notification_preferences_manage",
    notification_preferences_manage_others:
        "notification_preferences_manage_others",
    organisation_preferences_manage: "organisation_preferences_manage",
    media_manage: "media_manage",
    dnsp_dashboard: "dnsp_dashboard",
    project_dashboard: "project_dashboard",
    global_dashboard: "global_dashboard",
    system_device_provisioning: "system_device_provisioning",
    system_device_deprovisioning: "system_device_deprovisioning",
    system_device_access_tags_update: "system_device_access_tags_update",
    system_device_service_manage: "system_device_service_manage",
    system_device_catalogue_update: "system_device_catalogue_update",
    system_organisation: "system_organisation",
    system_user_account_manage: "system_user_account_manage",
    system_rfid_tags_manage: "system_rfid_tags_manage",
    system_passthrough_manage: "system_passthrough_manage",
    system_service_model_manage: "system_service_model_manage",
    system_vehicle_model_manage: "system_vehicle_model_manage",
    device_pricing_read: "device_pricing_read",
    device_pricing_manage: "device_pricing_manage",
    device_display_price_read: "device_display_price_read",
    device_display_price_manage: "device_display_price_manage",
    partner_device_provisioning: "partner_device_provisioning",
    partner_organisation_manage: "partner_organisation_manage",
    system_e2e_test_runner: "system_e2e_test_runner",
} as const;

export interface PermissionResponse {
    permissionId?: PermissionResponsePermissionId;
    category?: string;
    description?: string;
    /** Used to mark Permissions that should not be shown in custom Role creation (eg internal API permissions), unless you have system_administrator role */
    blockForExternalUsers?: boolean;
}

export interface PinReleaseToDeviceRequest {
    releaseId?: number;
}

export interface PowerConsumption {
    /** for debugging */
    cursor?: Date;
    /** for debugging. The raw db row timestamp. */
    rowValueUtc?: Date;
    /** The truncated time in UTC for the beginning of the interval (eg 'January' 2022 would be `2021-12-31T16:00:00` */
    timestamp?: Date;
    /** Date label, to avoid timezone conversions in frontend. eg:
  Hour: yyyy-MM-ddTHH:00:00
  Day: yyyy-MM-dd
  Week: 2022W01 (week-of-year, new weeks start on Sunday)
  Month: 2022M01 */
    label?: string;
    frequencyHz?: number;
    l1VoltageRmsV?: number;
    l2VoltageRmsV?: number;
    l3VoltageRmsV?: number;
    l1CurrentRmsA?: number;
    l2CurrentRmsA?: number;
    l3CurrentRmsA?: number;
    l1ActivePowerRmsW?: number;
    l2ActivePowerRmsW?: number;
    l3ActivePowerRmsW?: number;
    l1ReactivePowerRmsVar?: number;
    l2ReactivePowerRmsVar?: number;
    l3ReactivePowerRmsVar?: number;
    totalActiveEnergyImportWh?: number;
    totalReactiveEnergyImportWh?: number;
    totalActiveEnergyExportWh?: number;
    totalReactiveEnergyExportWh?: number;
}

export interface PowerConsumptionResponse {
    /** PowerMeterValues averaged over the requested interval */
    items?: PowerConsumption[];
    /** Currently always 'Australia/NEM_Time'. NEM Time is always UTC+10, with no daylight savings */
    siteTimeZone?: string;
    /** The PowerMeter id */
    deviceIdentity?: string;
    /** The switchboard this powermeter is associated with. */
    switchboardId?: string;
    /** The max capacity of this switchboard on L1. */
    switchboardMaxCapacityL1Amps?: number;
    /** The max capacity of this switchboard on L2. */
    switchboardMaxCapacityL2Amps?: number;
    /** The max capacity of this switchboard on L3. */
    switchboardMaxCapacityL3Amps?: number;
    /** The capacity buffer of this switchboard on L1. */
    switchboardBufferL1?: number;
    /** The capacity buffer of this switchboard on L2. */
    switchboardBufferL2?: number;
    /** The capacity buffer of this switchboard on L3. */
    switchboardBufferL3?: number;
    /** The current rating of this switchboard, to graph EVDB capacity */
    switchboardLoadLimitA?: number;
    /** The physical capacity of this switchboard. */
    switchboardCapacityA?: number;
}

export type PreviewRoleRequestPermissionsItem =
    (typeof PreviewRoleRequestPermissionsItem)[keyof typeof PreviewRoleRequestPermissionsItem];

export const PreviewRoleRequestPermissionsItem = {
    none: "none",
    device_location_read: "device_location_read",
    device_location_update: "device_location_update",
    device_config_read: "device_config_read",
    device_config_update: "device_config_update",
    device_reset: "device_reset",
    device_logs_read: "device_logs_read",
    device_tasks_read: "device_tasks_read",
    device_tasks_create: "device_tasks_create",
    device_energy_usage_read: "device_energy_usage_read",
    device_operational_update: "device_operational_update",
    device_firmware_update: "device_firmware_update",
    charge_transactions_read: "charge_transactions_read",
    power_meter_values_read: "power_meter_values_read",
    user_tasks_read: "user_tasks_read",
    enterprise_user_account_read: "enterprise_user_account_read",
    enterprise_user_account_update: "enterprise_user_account_update",
    enterprise_user_account_role_update: "enterprise_user_account_role_update",
    device_group_manage: "device_group_manage",
    device_group_create: "device_group_create",
    device_provisioning: "device_provisioning",
    device_passthrough_manage: "device_passthrough_manage",
    rfid_tags_read: "rfid_tags_read",
    rfid_tags_manage: "rfid_tags_manage",
    rfid_tags_delete: "rfid_tags_delete",
    role_create: "role_create",
    ticketing_read: "ticketing_read",
    ticketing_create: "ticketing_create",
    ppm_read: "ppm_read",
    ppm_manage: "ppm_manage",
    webhook_create: "webhook_create",
    notification_preferences_read: "notification_preferences_read",
    notification_preferences_manage: "notification_preferences_manage",
    notification_preferences_manage_others:
        "notification_preferences_manage_others",
    organisation_preferences_manage: "organisation_preferences_manage",
    media_manage: "media_manage",
    dnsp_dashboard: "dnsp_dashboard",
    project_dashboard: "project_dashboard",
    global_dashboard: "global_dashboard",
    system_device_provisioning: "system_device_provisioning",
    system_device_deprovisioning: "system_device_deprovisioning",
    system_device_access_tags_update: "system_device_access_tags_update",
    system_device_service_manage: "system_device_service_manage",
    system_device_catalogue_update: "system_device_catalogue_update",
    system_organisation: "system_organisation",
    system_user_account_manage: "system_user_account_manage",
    system_rfid_tags_manage: "system_rfid_tags_manage",
    system_passthrough_manage: "system_passthrough_manage",
    system_service_model_manage: "system_service_model_manage",
    system_vehicle_model_manage: "system_vehicle_model_manage",
    device_pricing_read: "device_pricing_read",
    device_pricing_manage: "device_pricing_manage",
    device_display_price_read: "device_display_price_read",
    device_display_price_manage: "device_display_price_manage",
    partner_device_provisioning: "partner_device_provisioning",
    partner_organisation_manage: "partner_organisation_manage",
    system_e2e_test_runner: "system_e2e_test_runner",
} as const;

export interface PreviewRoleRequest {
    /** The organisation the admin user wants to preview the role as */
    organisationId?: string;
    permissions?: PreviewRoleRequestPermissionsItem[];
}

export interface PricingSchedulesResponse {
    items?: PricingScheduleDto[];
}

export type ProvisionDeviceLookupValuesDeviceTypesItem =
    (typeof ProvisionDeviceLookupValuesDeviceTypesItem)[keyof typeof ProvisionDeviceLookupValuesDeviceTypesItem];

export const ProvisionDeviceLookupValuesDeviceTypesItem = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

/**
 * Mapping of DeviceType to a list of Model values to use in the Model drop-down
 */
export type ProvisionDeviceLookupValuesDeviceTypeModelValues = {
    [key: string]: ListString;
};

export interface ProvisionDeviceLookupValues {
    /** List of DeviceTypes to use in the drop-down */
    deviceTypes?: ProvisionDeviceLookupValuesDeviceTypesItem[];
    /** Mapping of DeviceType to a list of Model values to use in the Model drop-down */
    deviceTypeModelValues?: ProvisionDeviceLookupValuesDeviceTypeModelValues;
}

/**
 * DeviceIdentity and DeviceType are the only mandatory fields
 */
export type ProvisionDeviceRequestDeviceType =
    (typeof ProvisionDeviceRequestDeviceType)[keyof typeof ProvisionDeviceRequestDeviceType];

export const ProvisionDeviceRequestDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

/**
 * Optional, ChargePoint devices only. Temporary parameter only to fix #1661, will eventually be replaced by separate ThirdPartyPassthrough API in #1489
 */
export type ProvisionDeviceRequestManagedBy =
    (typeof ProvisionDeviceRequestManagedBy)[keyof typeof ProvisionDeviceRequestManagedBy];

export const ProvisionDeviceRequestManagedBy = {
    ChargefoxDev: "ChargefoxDev",
    ChargefoxStaging: "ChargefoxStaging",
    ChargefoxProd: "ChargefoxProd",
    Illuminate: "Illuminate",
    Exploren: "Exploren",
    Fortum: "Fortum",
    ChargeHq: "ChargeHq",
    DynamicPassthroughParent: "DynamicPassthroughParent",
    DynamicPassthroughChild: "DynamicPassthroughChild",
    GatewayDynamicPassthroughChild: "GatewayDynamicPassthroughChild",
    ServerlessFunctionApp: "ServerlessFunctionApp",
} as const;

export interface ProvisionDeviceRequest {
    /** DeviceIdentity and DeviceType are the only mandatory fields */
    deviceIdentity?: string;
    /** DeviceIdentity and DeviceType are the only mandatory fields */
    deviceType?: ProvisionDeviceRequestDeviceType;
    /** Deprecated, prefer DeviceCatalogueId. Define a provisional Vendor. This will be overwritten by the device during first BootNotification. */
    vendor?: string;
    /** Deprecated, prefer DeviceCatalogueId. Define a provisional Model. Useful for fetching model specific configuration schema (via GET lookup/device-configuration-schema?model=parameter). This will be overwritten by the device during first BootNotification. */
    model?: string;
    friendlyName?: string;
    /** Optional, IANA time zone id */
    timeZone?: string;
    /** Optional, ChargePoint devices only. Temporary parameter only to fix #1661, will eventually be replaced by separate ThirdPartyPassthrough API in #1489 */
    managedBy?: ProvisionDeviceRequestManagedBy;
    /** Required, unless staff with system_provisioning permission. Users with only device_provisioning permission must specify their own org. Partners with partner_device_provisioning may specify a child org. */
    organisationId?: string;
    /** Optional, link device to an existing DeviceCatalogue entry. Replaces providing Vendor/Model fields. */
    deviceCatalogueId?: number;
    deviceAddress?: AddressDto;
}

export interface ReportFaultRequest {
    deviceGroupTag?: string;
    deviceIdentities?: string[];
    userFaultDescription?: string;
    contactDetails?: ContactDetails[];
}

/**
 * DeviceIdentity and DeviceType are the only mandatory fields
 */
export type ReprovisionDeviceRequestDeviceType =
    (typeof ReprovisionDeviceRequestDeviceType)[keyof typeof ReprovisionDeviceRequestDeviceType];

export const ReprovisionDeviceRequestDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

/**
 * Optional, ChargePoint devices only. Temporary parameter only to fix #1661, will eventually be replaced by separate ThirdPartyPassthrough API in #1489
 */
export type ReprovisionDeviceRequestManagedBy =
    (typeof ReprovisionDeviceRequestManagedBy)[keyof typeof ReprovisionDeviceRequestManagedBy];

export const ReprovisionDeviceRequestManagedBy = {
    ChargefoxDev: "ChargefoxDev",
    ChargefoxStaging: "ChargefoxStaging",
    ChargefoxProd: "ChargefoxProd",
    Illuminate: "Illuminate",
    Exploren: "Exploren",
    Fortum: "Fortum",
    ChargeHq: "ChargeHq",
    DynamicPassthroughParent: "DynamicPassthroughParent",
    DynamicPassthroughChild: "DynamicPassthroughChild",
    GatewayDynamicPassthroughChild: "GatewayDynamicPassthroughChild",
    ServerlessFunctionApp: "ServerlessFunctionApp",
} as const;

export interface ReprovisionDeviceRequest {
    /** The identity of the existing decommissioned device */
    existingDeviceIdentity?: string;
    /** DeviceIdentity and DeviceType are the only mandatory fields */
    deviceIdentity?: string;
    /** DeviceIdentity and DeviceType are the only mandatory fields */
    deviceType?: ReprovisionDeviceRequestDeviceType;
    /** Deprecated, prefer DeviceCatalogueId. Define a provisional Vendor. This will be overwritten by the device during first BootNotification. */
    vendor?: string;
    /** Deprecated, prefer DeviceCatalogueId. Define a provisional Model. Useful for fetching model specific configuration schema (via GET lookup/device-configuration-schema?model=parameter). This will be overwritten by the device during first BootNotification. */
    model?: string;
    friendlyName?: string;
    /** Optional, IANA time zone id */
    timeZone?: string;
    /** Optional, ChargePoint devices only. Temporary parameter only to fix #1661, will eventually be replaced by separate ThirdPartyPassthrough API in #1489 */
    managedBy?: ReprovisionDeviceRequestManagedBy;
    /** Required, unless staff with system_provisioning permission. Users with only device_provisioning permission must specify their own org. Partners with partner_device_provisioning may specify a child org. */
    organisationId?: string;
    /** Optional, link device to an existing DeviceCatalogue entry. Replaces providing Vendor/Model fields. */
    deviceCatalogueId?: number;
    deviceAddress?: AddressDto;
}

export type RfidUploadEntityOperation =
    (typeof RfidUploadEntityOperation)[keyof typeof RfidUploadEntityOperation];

export const RfidUploadEntityOperation = {
    Unknown: "Unknown",
    Insert: "Insert",
    Update: "Update",
} as const;

export type RfidUploadEntityStatus =
    (typeof RfidUploadEntityStatus)[keyof typeof RfidUploadEntityStatus];

export const RfidUploadEntityStatus = {
    Active: "Active",
    Suspended: "Suspended",
    Archived: "Archived",
} as const;

export type RfidUploadEntityRule =
    (typeof RfidUploadEntityRule)[keyof typeof RfidUploadEntityRule];

export const RfidUploadEntityRule = {
    Unknown: "Unknown",
    DeviceOwner: "DeviceOwner",
    DeviceGroups: "DeviceGroups",
    UserAccount: "UserAccount",
} as const;

export interface RfidUploadEntity {
    rfid?: string;
    operation?: RfidUploadEntityOperation;
    status?: RfidUploadEntityStatus;
    rule?: RfidUploadEntityRule;
    /** Organisation id */
    organisation?: string;
    label?: string;
    /** User account email address, or UserAccountId prefixed with # */
    userAccount?: string;
    /** Device owner email address, or DeviceOwnerId prefixed with # */
    deviceOwner?: string;
    deviceGroupTags?: string[];
}

export interface RfidBulkUploadRequest {
    /** True to perform validation only, false to perfrom db operations */
    validateOnly?: boolean;
    /** List of rfid items of the same type as the CSV structure (similar, but not the same, as RfidTagDto) */
    rfidUploadEntities?: RfidUploadEntity[];
}

export type RfidTagDtoStatus =
    (typeof RfidTagDtoStatus)[keyof typeof RfidTagDtoStatus];

export const RfidTagDtoStatus = {
    Active: "Active",
    Suspended: "Suspended",
    Archived: "Archived",
} as const;

export type RfidTagDtoRule =
    (typeof RfidTagDtoRule)[keyof typeof RfidTagDtoRule];

export const RfidTagDtoRule = {
    Unknown: "Unknown",
    DeviceOwner: "DeviceOwner",
    DeviceGroups: "DeviceGroups",
    UserAccount: "UserAccount",
} as const;

/**
 * The vehicle linked to this RFID tag, if any. Do not set when calling InsertUpdateRfidTag
 */
export interface VehicleSummary {
    vehicleId?: number;
    registrationPlate?: string;
    friendlyName?: string;
}

export interface RfidTagDto {
    /** The primary key */
    rfidTagId?: number;
    /** The tag id. Unique. */
    id?: string;
    status?: RfidTagDtoStatus;
    label?: string;
    /** Set for Rule=UserAccount */
    userAccountId?: number;
    /** Set for Rule=DeviceOwner */
    deviceOwnerId?: number;
    createdAt?: Date;
    updatedAt?: Date;
    rule?: RfidTagDtoRule;
    /** The owner of this RfidTag. */
    organisationId?: string;
    userAccount?: UserAccountSummary;
    deviceOwner?: DeviceOwnerDto;
    /** Do not set when calling InsertUpdateRfidTag */
    deviceGroupTags?: string[];
    vehicle?: VehicleSummary;
}

export type RoleResponseAssignmentRule =
    (typeof RoleResponseAssignmentRule)[keyof typeof RoleResponseAssignmentRule];

export const RoleResponseAssignmentRule = {
    Unknown: "Unknown",
    Any: "Any",
    InternalToInternal: "InternalToInternal",
    InternalToAny: "InternalToAny",
} as const;

export type RoleResponsePermissionsItem =
    (typeof RoleResponsePermissionsItem)[keyof typeof RoleResponsePermissionsItem];

export const RoleResponsePermissionsItem = {
    none: "none",
    device_location_read: "device_location_read",
    device_location_update: "device_location_update",
    device_config_read: "device_config_read",
    device_config_update: "device_config_update",
    device_reset: "device_reset",
    device_logs_read: "device_logs_read",
    device_tasks_read: "device_tasks_read",
    device_tasks_create: "device_tasks_create",
    device_energy_usage_read: "device_energy_usage_read",
    device_operational_update: "device_operational_update",
    device_firmware_update: "device_firmware_update",
    charge_transactions_read: "charge_transactions_read",
    power_meter_values_read: "power_meter_values_read",
    user_tasks_read: "user_tasks_read",
    enterprise_user_account_read: "enterprise_user_account_read",
    enterprise_user_account_update: "enterprise_user_account_update",
    enterprise_user_account_role_update: "enterprise_user_account_role_update",
    device_group_manage: "device_group_manage",
    device_group_create: "device_group_create",
    device_provisioning: "device_provisioning",
    device_passthrough_manage: "device_passthrough_manage",
    rfid_tags_read: "rfid_tags_read",
    rfid_tags_manage: "rfid_tags_manage",
    rfid_tags_delete: "rfid_tags_delete",
    role_create: "role_create",
    ticketing_read: "ticketing_read",
    ticketing_create: "ticketing_create",
    ppm_read: "ppm_read",
    ppm_manage: "ppm_manage",
    webhook_create: "webhook_create",
    notification_preferences_read: "notification_preferences_read",
    notification_preferences_manage: "notification_preferences_manage",
    notification_preferences_manage_others:
        "notification_preferences_manage_others",
    organisation_preferences_manage: "organisation_preferences_manage",
    media_manage: "media_manage",
    dnsp_dashboard: "dnsp_dashboard",
    project_dashboard: "project_dashboard",
    global_dashboard: "global_dashboard",
    system_device_provisioning: "system_device_provisioning",
    system_device_deprovisioning: "system_device_deprovisioning",
    system_device_access_tags_update: "system_device_access_tags_update",
    system_device_service_manage: "system_device_service_manage",
    system_device_catalogue_update: "system_device_catalogue_update",
    system_organisation: "system_organisation",
    system_user_account_manage: "system_user_account_manage",
    system_rfid_tags_manage: "system_rfid_tags_manage",
    system_passthrough_manage: "system_passthrough_manage",
    system_service_model_manage: "system_service_model_manage",
    system_vehicle_model_manage: "system_vehicle_model_manage",
    device_pricing_read: "device_pricing_read",
    device_pricing_manage: "device_pricing_manage",
    device_display_price_read: "device_display_price_read",
    device_display_price_manage: "device_display_price_manage",
    partner_device_provisioning: "partner_device_provisioning",
    partner_organisation_manage: "partner_organisation_manage",
    system_e2e_test_runner: "system_e2e_test_runner",
} as const;

export interface RoleResponse {
    roleId?: string;
    description?: string;
    /** used to prevent certain Roles from being assigned to external (non JC staff) users (eg system permissions) */
    blockForExternalUsers?: boolean;
    /** True if the current user can edit this role. False for some built-in roles, and roles that don't belong to this user's org */
    canEdit?: boolean;
    assignmentRule?: RoleResponseAssignmentRule;
    organisationId?: string;
    /** The group ids this organisation belongs to (separated to avoid circular references). */
    permissions?: RoleResponsePermissionsItem[];
}

export interface RolesResponse {
    /** True if this is the complete list of roles & permissions. This is the case if you are allowed to see all tags in the system (ie you are admin AND mineOnly=false) */
    isComplete?: boolean;
    roles?: RoleResponse[];
    permissions?: PermissionResponse[];
}

export interface SendMessageTask {
    action?: string;
    payload?: string;
}

export interface ServiceEventCreateDto {
    /** DeviceGroupTag of the ScheduledMaintenance DeviceGroup */
    scheduledMaintenanceDeviceGroupTag?: string;
    scheduledDate?: Date;
}

export type ServiceEventDtoStatus =
    (typeof ServiceEventDtoStatus)[keyof typeof ServiceEventDtoStatus];

export const ServiceEventDtoStatus = {
    Scheduled: "Scheduled",
    TicketCreated: "TicketCreated",
    Complete: "Complete",
} as const;

export interface ServiceEventTicketDto {
    serviceEventTicketId?: number;
    serviceEventId?: number;
    ticketId?: string;
}

export interface ServiceEventDto {
    serviceEventId?: number;
    /** Cross-DB link to ScheduledMaintenance DeviceGroup */
    scheduledMaintenanceDeviceGroupTag?: string;
    /** Denormalized from device group */
    scheduleName?: string;
    status?: ServiceEventDtoStatus;
    /** Denormalized site name */
    siteName?: string;
    siteDeviceGroupTag?: string;
    /** Denormalized organisation name */
    organisationName?: string;
    organisationId?: string;
    scheduledDate?: Date;
    /** Linked ticket IDs */
    tickets?: ServiceEventTicketDto[];
    createdAt?: Date;
    updatedAt?: Date;
}

export interface ServiceEventUpdateDto {
    scheduledDate?: Date;
    /** Array of ticket IDs */
    ticketIds?: string[];
}

export interface SessionCount {
    /** for debugging. The raw db row timestamp. */
    rowValueUtc?: Date;
    /** The truncated time in UTC for the beginning of the interval (eg 'January' 2022 would be `2021-12-31T16:00:00` */
    timestamp?: Date;
    /** Date label, to avoid timezone conversions in frontend. eg:
  Hour: yyyy-MM-ddTHH:00:00
  Day: yyyy-MM-dd
  Week: 2022W01 (week-of-year, new weeks start on Sunday)
  Month: 2022M01 */
    label?: string;
    /** The number of sessions that started in this interval */
    count?: number;
}

export interface SessionCountResponse {
    items?: SessionCount[];
    /** Currently always 'Australia/NEM_Time'. NEM Time is always UTC+10, with no daylight savings */
    siteTimeZone?: string;
}

export interface SetCentralSystemPassThroughTask {
    thirdPartyCsIdList?: number[];
}

export interface SetCoreConfigurationTask {
    [key: string]: unknown;
}

export interface SetDefaultChargingProfileTask {
    maxChargeKw?: number;
}

export interface SetDisplayedPriceTask {
    priceMessageToDisplay?: string;
}

export interface SimpleDeviceStatusPercentageDto {
    date?: Date;
    unknownPercentage?: number;
    availablePercentage?: number;
    inUsePercentage?: number;
    faultedPercentage?: number;
    noCurtailmentPercentage?: number;
    lightCurtailmentPercentage?: number;
    heavyCurtailmentPercentage?: number;
    remainingPercentage?: number;
}

export interface SiteSessionSummary {
    /** The device group tag for this site */
    deviceGroupTag?: string;
    /** The site name */
    siteName?: string;
    /** Number of chargers at this site */
    chargerCount?: number;
    /** Total number of charging sessions */
    sessionCount?: number;
    /** Total energy delivered in Wh */
    energyWh?: number;
    /** Charging success rate as a percentage (0-100) */
    chargingSuccessRate?: number;
    /** The device group tag for the parent organisation */
    orgGroupTag?: string;
    /** The parent organisation name */
    orgName?: string;
}

export interface SiteUptimeSummary {
    /** Site device group tag */
    deviceGroupTag?: string;
    /** Site name */
    siteName?: string;
    /** Number of chargers at this site */
    chargerCount?: number;
    /** Average device uptime percentage (0-1). Offline periods are not considered. */
    avgDeviceUptimeOfflineIncluded?: number;
    /** Average device uptime percentage (0-1). Offline periods are removed from calculation. */
    avgDeviceUptimeOfflineExcluded?: number;
    /** Preferred device uptime based on organisation preference. */
    preferredDeviceUptime?: number;
    /** Whether offline is included in device uptime calculation. */
    isOfflineIncludedInDeviceUptime?: boolean;
    /** Parent organisation device group tag */
    orgGroupTag?: string;
    /** Parent organisation name */
    orgName?: string;
    /** Calculation period start */
    periodStart?: Date;
    /** Calculation period end */
    periodEnd?: Date;
}

export interface SolarOverrideTask {
    connectorIndex?: number;
    transactionId?: number;
    maxImportKw?: number;
}

export interface StartChargeTask {
    connectorIndex?: number;
    idTag?: string;
}

export interface StartOcppLogUploadTask {
    chargerIds?: string[];
    outputFormat?: string;
    startTime?: Date;
    endTime?: Date;
}

export interface StatusItem {
    statusItemId?: number;
    deviceIdentity?: string;
    connectorIndex?: number;
    createdAt?: Date;
    updatedAt?: Date;
    status?: string;
    reason?: string;
}

export interface StatusItemDto {
    statusItemId?: number;
    deviceIdentity?: string;
    connectorIndex?: number;
    createdAt?: Date;
    updatedAt?: Date;
    status?: string;
}

export interface StopChargeTask {
    connectorIndex?: number;
    transactionId?: number;
    forceStop?: boolean;
}

export type SubscriptionPriceOptionInterval =
    (typeof SubscriptionPriceOptionInterval)[keyof typeof SubscriptionPriceOptionInterval];

export const SubscriptionPriceOptionInterval = {
    Unknown: "Unknown",
    Day: "Day",
    Week: "Week",
    Month: "Month",
    Year: "Year",
} as const;

export interface SubscriptionPriceOption {
    priceId?: string;
    name?: string;
    interval?: SubscriptionPriceOptionInterval;
    amount?: number;
    currencyCode?: string;
    isDefault?: boolean;
    createdAt?: Date;
}

export type TaskInfoAddRequestTaskType =
    (typeof TaskInfoAddRequestTaskType)[keyof typeof TaskInfoAddRequestTaskType];

export const TaskInfoAddRequestTaskType = {
    HardReset: "HardReset",
    SoftReset: "SoftReset",
    UpdateFirmware: "UpdateFirmware",
    UpdatePayMateFirmware: "UpdatePayMateFirmware",
    StartCharge: "StartCharge",
    StopCharge: "StopCharge",
    UnlockConnector: "UnlockConnector",
    TriggerMessage: "TriggerMessage",
    ClearChargingProfile: "ClearChargingProfile",
    DisableEnableCharging: "DisableEnableCharging",
    ChangeConfiguration: "ChangeConfiguration",
    ChangeExtendedConfiguration: "ChangeExtendedConfiguration",
    SendMessage: "SendMessage",
    DeviceAlert: "DeviceAlert",
    LimitChargeTransaction: "LimitChargeTransaction",
    SetDefaultChargingProfile: "SetDefaultChargingProfile",
    Activate: "Activate",
    SolarOverride: "SolarOverride",
    SetCentralSystemPassThrough: "SetCentralSystemPassThrough",
    PauseResumeChargeTransaction: "PauseResumeChargeTransaction",
    UpdatePayMateConnectorPricing: "UpdatePayMateConnectorPricing",
    SaveDeviceLogFiles: "SaveDeviceLogFiles",
    PowerOutageSchedule: "PowerOutageSchedule",
    GridPowerRestoredNotification: "GridPowerRestoredNotification",
    KickConnection: "KickConnection",
    GetConfiguration: "GetConfiguration",
    SetCoreConfiguration: "SetCoreConfiguration",
    GetDistributionBoardRemoteProfiles: "GetDistributionBoardRemoteProfiles",
    SetDistributionBoardRemoteProfile: "SetDistributionBoardRemoteProfile",
    ClearDistributionBoardRemoteProfile: "ClearDistributionBoardRemoteProfile",
    WatchBalenaDevice: "WatchBalenaDevice",
    UpdateSupervision: "UpdateSupervision",
    SetDisplayedPrice: "SetDisplayedPrice",
    GetDisplayedPrice: "GetDisplayedPrice",
    StartOcppLogUpload: "StartOcppLogUpload",
} as const;

export interface UpdateFirmwareTask {
    location?: string;
}

export interface UpdatePayMateFirmwareTask {
    filename?: string;
    firmwareContainer?: string;
}

export interface UnlockConnectorTask {
    connectorIndex?: number;
}

export interface TriggerMessageTask {
    connectorIndex?: number;
    requestedMessage?: string;
}

export interface UpdateSupervisionTask {
    supervisionUrl?: string;
}

/**
 * Populate the relevant '{TaskType}Task' field only, or null if this is a parameterless task type
 */
export interface TaskInfoRequestParametersObject {
    updateFirmwareTask?: UpdateFirmwareTask;
    updatePayMateFirmwareTask?: UpdatePayMateFirmwareTask;
    startChargeTask?: StartChargeTask;
    stopChargeTask?: StopChargeTask;
    unlockConnectorTask?: UnlockConnectorTask;
    clearChargingProfileTask?: ClearChargingProfileTask;
    changeConfigurationTask?: ChangeConfigurationTask;
    changeExtendedConfigurationTask?: ChangeExtendedConfigurationTask;
    sendMessageTask?: SendMessageTask;
    deviceAlertTask?: DeviceAlertTask;
    limitChargeTransactionTask?: LimitChargeTransactionTask;
    setDefaultChargingProfileTask?: SetDefaultChargingProfileTask;
    activateTask?: ActivateTask;
    solarOverrideTask?: SolarOverrideTask;
    setCentralSystemPassThroughTask?: SetCentralSystemPassThroughTask;
    pauseResumeChargeTransactionTask?: PauseResumeChargeTransactionTask;
    setCoreConfigurationTask?: SetCoreConfigurationTask;
    disableEnableChargingTask?: DisableEnableChargingTask;
    triggerMessageTask?: TriggerMessageTask;
    updateSupervisionTask?: UpdateSupervisionTask;
    setDisplayedPriceTask?: SetDisplayedPriceTask;
    getDisplayedPriceTask?: GetDisplayedPriceTask;
    startOcppLogUploadTask?: StartOcppLogUploadTask;
}

export interface TaskInfoAddRequest {
    deviceIdentity?: string;
    /** Optional, use to delay the processing of the message */
    scheduledTime?: Date;
    /** Optional, used to set a custom TTL for the command message */
    expiresAt?: Date;
    taskType?: TaskInfoAddRequestTaskType;
    requestParametersObject?: TaskInfoRequestParametersObject;
}

export type TaskInfoDtoDeviceType =
    (typeof TaskInfoDtoDeviceType)[keyof typeof TaskInfoDtoDeviceType];

export const TaskInfoDtoDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

export type TaskInfoDtoTaskType =
    (typeof TaskInfoDtoTaskType)[keyof typeof TaskInfoDtoTaskType];

export const TaskInfoDtoTaskType = {
    HardReset: "HardReset",
    SoftReset: "SoftReset",
    UpdateFirmware: "UpdateFirmware",
    UpdatePayMateFirmware: "UpdatePayMateFirmware",
    StartCharge: "StartCharge",
    StopCharge: "StopCharge",
    UnlockConnector: "UnlockConnector",
    TriggerMessage: "TriggerMessage",
    ClearChargingProfile: "ClearChargingProfile",
    DisableEnableCharging: "DisableEnableCharging",
    ChangeConfiguration: "ChangeConfiguration",
    ChangeExtendedConfiguration: "ChangeExtendedConfiguration",
    SendMessage: "SendMessage",
    DeviceAlert: "DeviceAlert",
    LimitChargeTransaction: "LimitChargeTransaction",
    SetDefaultChargingProfile: "SetDefaultChargingProfile",
    Activate: "Activate",
    SolarOverride: "SolarOverride",
    SetCentralSystemPassThrough: "SetCentralSystemPassThrough",
    PauseResumeChargeTransaction: "PauseResumeChargeTransaction",
    UpdatePayMateConnectorPricing: "UpdatePayMateConnectorPricing",
    SaveDeviceLogFiles: "SaveDeviceLogFiles",
    PowerOutageSchedule: "PowerOutageSchedule",
    GridPowerRestoredNotification: "GridPowerRestoredNotification",
    KickConnection: "KickConnection",
    GetConfiguration: "GetConfiguration",
    SetCoreConfiguration: "SetCoreConfiguration",
    GetDistributionBoardRemoteProfiles: "GetDistributionBoardRemoteProfiles",
    SetDistributionBoardRemoteProfile: "SetDistributionBoardRemoteProfile",
    ClearDistributionBoardRemoteProfile: "ClearDistributionBoardRemoteProfile",
    WatchBalenaDevice: "WatchBalenaDevice",
    UpdateSupervision: "UpdateSupervision",
    SetDisplayedPrice: "SetDisplayedPrice",
    GetDisplayedPrice: "GetDisplayedPrice",
    StartOcppLogUpload: "StartOcppLogUpload",
} as const;

export type TaskInfoDtoStage =
    (typeof TaskInfoDtoStage)[keyof typeof TaskInfoDtoStage];

export const TaskInfoDtoStage = {
    Requested: "Requested",
    Started: "Started",
    Complete: "Complete",
    Failed: "Failed",
    Cancelled: "Cancelled",
} as const;

export type TaskInfoDtoRequestParameters = { [key: string]: unknown };

export type TaskInfoDtoResultExtras = { [key: string]: unknown };

export interface TaskInfoDto {
    taskInfoId?: string;
    deviceArchiveId?: number;
    deviceIdentity?: string;
    deviceType?: TaskInfoDtoDeviceType;
    scheduledTime?: Date;
    createdAt?: Date;
    updatedAt?: Date;
    expiresAt?: Date;
    taskType?: TaskInfoDtoTaskType;
    stage?: TaskInfoDtoStage;
    result?: string;
    userId?: string;
    userAccountId?: number;
    requestParameters?: TaskInfoDtoRequestParameters;
    resultExtras?: TaskInfoDtoResultExtras;
}

export type TicketCommentExtraMetadata = { [key: string]: string };

export interface UserInfo {
    displayName?: string;
    emailAddress?: string;
    avatarUrl?: string;
}

export interface TicketComment {
    ticketId?: string;
    commentId?: string;
    author?: UserInfo;
    comment?: string;
    createdAt?: Date;
    updatedAt?: Date;
    extraMetadata?: TicketCommentExtraMetadata;
}

export type TicketStatusCountStatus =
    (typeof TicketStatusCountStatus)[keyof typeof TicketStatusCountStatus];

export const TicketStatusCountStatus = {
    Unknown: "Unknown",
    Open: "Open",
    InProgress: "InProgress",
    Escalated: "Escalated",
    Resolved: "Resolved",
} as const;

export interface TicketStatusCount {
    status?: TicketStatusCountStatus;
    count?: number;
}

export type TicketSummaryStatus =
    (typeof TicketSummaryStatus)[keyof typeof TicketSummaryStatus];

export const TicketSummaryStatus = {
    Unknown: "Unknown",
    Open: "Open",
    InProgress: "InProgress",
    Escalated: "Escalated",
    Resolved: "Resolved",
} as const;

export type TicketSummaryExtraMetadata = { [key: string]: string };

export interface TicketSummary {
    ticketId?: string;
    url?: string;
    title?: string;
    organisationId?: string;
    serviceModelTag?: string;
    scheduledMaintenanceTag?: string;
    siteTag?: string;
    deviceIdentity?: string;
    description?: string;
    author?: UserInfo;
    status?: TicketSummaryStatus;
    statusText?: string;
    createdAt?: Date;
    updatedAt?: Date;
    extraMetadata?: TicketSummaryExtraMetadata;
    comments?: TicketComment[];
}

export interface TotalEmissionEstimate {
    deviceGroupTag?: string;
    stateCode?: string;
    countryCode?: string;
    cO2PerWh?: number;
    consumptionWh?: number;
    /** Total estimated CO₂ emissions (kg), aggregated across all emission scopes. */
    emissionKg?: number;
    /** Percentage difference in emissions (based on EmissionKg) from the previous period, can be null if previous period does not have data. */
    diffPercentage?: number;
    scope1EmissionKg?: number;
    scope2EmissionKg?: number;
    scope3EmissionKg?: number;
}

export interface TotalEmissionEstimateResponse {
    dayCount?: number;
    deviceCount?: number;
    totalEmissionKg?: number;
    /** Percentage difference in total emissions (based on TotalEmissionKg) from the previous period, can be null if previous period does not have data. */
    totalDiffPercentage?: number;
    items?: TotalEmissionEstimate[];
}

export interface TotalEnergyConsumption {
    deviceIdentity?: string;
    consumptionWh?: number;
    /** Percentage difference in energy consumption (based on ConsumptionWh) from the previous period, can be null if previous period does not have data. */
    diffPercentage?: number;
}

export interface TotalEnergyConsumptionResponse {
    dayCount?: number;
    deviceCount?: number;
    totalConsumptionWh?: number;
    /** Percentage difference in total energy consumption (based on TotalConsumptionWh) from the previous period, can be null if previous period does not have data. */
    totalDiffPercentage?: number;
    items?: TotalEnergyConsumption[];
}

export type TransactionDeviceType =
    (typeof TransactionDeviceType)[keyof typeof TransactionDeviceType];

export const TransactionDeviceType = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;

export type TransactionBillingStatus =
    (typeof TransactionBillingStatus)[keyof typeof TransactionBillingStatus];

export const TransactionBillingStatus = {
    Unknown: "Unknown",
    NotRequired: "NotRequired",
    Pending: "Pending",
    Raised: "Raised",
    Paid: "Paid",
    Failed: "Failed",
} as const;

export interface Transaction {
    transactionId?: number;
    transactionLocalId?: string;
    deviceIdentity?: string;
    deviceType?: TransactionDeviceType;
    connectorIndex?: number;
    connectorIdentity?: string;
    passthroughDeviceIdentity?: string;
    managedBy?: string;
    centralSystemTransactionId?: string;
    meterStart?: number;
    meterStop?: number;
    soCStart?: number;
    soCEnd?: number;
    idTagStart?: string;
    idTagStop?: string;
    reservationId?: number;
    odometer?: string;
    vehicleId?: number;
    vehicleRegistrationPlate?: string;
    start?: Date;
    end?: Date;
    stopTransactionReason?: string;
    createdAt?: Date;
    updatedAt?: Date;
    totalCost?: number;
    currencyCode?: string;
    billingStatus?: TransactionBillingStatus;
    chargerMeterValues?: ChargerMeterValue[];
}

export interface TransactionMeterValuesResponse {
    meterValues?: ChargerMeterValueDto[];
    nextCursor?: string;
}

/**
 * Report period
 */
export type TransactionReportMetadataPeriod =
    (typeof TransactionReportMetadataPeriod)[keyof typeof TransactionReportMetadataPeriod];

export const TransactionReportMetadataPeriod = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Annually: "Annually",
} as const;

/**
 * Only provided for WebhookType==TransactionReport
 */
export interface TransactionReportMetadata {
    /** Report period */
    period?: TransactionReportMetadataPeriod;
    /** true to return completed transactions only, that ended between dateFrom-dateTo. False to include ongoing transactions */
    transactionsEndedWithinRangeOnly?: boolean;
}

export interface TransactionReportRequest {
    /** true to return completed transactions only, that ended between dateFrom-dateTo. False to include ongoing transactions */
    transactionsEndedWithinRangeOnly?: boolean;
    /** Date from, inclusive. Date only, eg '2023-10-04'. Reports are run using AEST only (UTC+10, no daylight savings) */
    dateFrom?: string;
    /** Date to, inclusive. Date only, eg '2023-10-04'. Reports are run using AEST only (UTC+10, no daylight savings) */
    dateTo?: string;
    /** Report is run for all operational devices in this group. Prefer using DeviceGroupTags instead. */
    deviceGroupTag?: string;
    /** Report is run for all operational devices in the intersection of all of these groups. Clients must provide at least one group they are directly assigned to, eg their org or a site. They may also provide groups they are not directly assigned to, eg ServiceModels */
    deviceGroupTags?: string[];
}

export interface UnlinkRfidTagsRequest {
    /** @minItems 1 */
    rfidTagIds?: number[];
}

export type UpdateBillingAccountStatusRequestStatus =
    (typeof UpdateBillingAccountStatusRequestStatus)[keyof typeof UpdateBillingAccountStatusRequestStatus];

export const UpdateBillingAccountStatusRequestStatus = {
    Unknown: "Unknown",
    Required: "Required",
    Active: "Active",
    Suspended: "Suspended",
    Closed: "Closed",
} as const;

export interface UpdateBillingAccountStatusRequest {
    status?: UpdateBillingAccountStatusRequestStatus;
    statusMessage?: string;
}

export interface UpdateDefaultRfidTagRequest {
    value?: string;
}

export type UpdateDeviceAuthorizationRequestMode =
    (typeof UpdateDeviceAuthorizationRequestMode)[keyof typeof UpdateDeviceAuthorizationRequestMode];

export const UpdateDeviceAuthorizationRequestMode = {
    LegacyBasicAuth: "LegacyBasicAuth",
    AutomaticBasicAuth: "AutomaticBasicAuth",
    ManualBasicAuth: "ManualBasicAuth",
    None: "None",
    Reject: "Reject",
} as const;

export interface UpdateDeviceAuthorizationRequest {
    mode?: UpdateDeviceAuthorizationRequestMode;
    /** If Mode=AutomaticBasicAuth, True to have device service regenerate new key, false if you do not intend to replace the key if it is already set. */
    regenerate?: boolean;
    /** If Mode=ManualBasicAuth, 20 character unique secret key that will be sent to the charger. When IsAuthKeyHexString is true, the expected key is 40 character hex representation instead. May be null. */
    authorizationKey?: string;
    /** Set to true if AuthorizationKey is a 40 character hex representation of the secret key */
    isAuthKeyHexString?: boolean;
}

export interface UpdateDeviceGroupContactsRequest {
    contacts?: ContactDto[];
}

export type UpdateNotificationPreferenceRequestNotificationMethodsItem =
    (typeof UpdateNotificationPreferenceRequestNotificationMethodsItem)[keyof typeof UpdateNotificationPreferenceRequestNotificationMethodsItem];

export const UpdateNotificationPreferenceRequestNotificationMethodsItem = {
    Unknown: "Unknown",
    Email: "Email",
    SMS: "SMS",
    PushNotification: "PushNotification",
} as const;

export type UpdateNotificationPreferenceRequestNotificationTypesItem =
    (typeof UpdateNotificationPreferenceRequestNotificationTypesItem)[keyof typeof UpdateNotificationPreferenceRequestNotificationTypesItem];

export const UpdateNotificationPreferenceRequestNotificationTypesItem = {
    Unknown: "Unknown",
    FaultedStateDevice: "FaultedStateDevice",
    OfflineStateDevice: "OfflineStateDevice",
    UnknownStateDevice: "UnknownStateDevice",
    NonOperationalDevice: "NonOperationalDevice",
    EnergyPriceChargingSuspended: "EnergyPriceChargingSuspended",
    EnergyPriceChargingResumed: "EnergyPriceChargingResumed",
    Warning: "Warning",
    FrequentFaultsWarning: "FrequentFaultsWarning",
    ShortDurationWarning: "ShortDurationWarning",
    NoActivityWarning: "NoActivityWarning",
    ZerokWhWarning: "ZerokWhWarning",
    PowerLossWarning: "PowerLossWarning",
    LowEnergyMidSessionWarning: "LowEnergyMidSessionWarning",
} as const;

export type UpdateNotificationPreferenceRequestNotificationFrequency =
    (typeof UpdateNotificationPreferenceRequestNotificationFrequency)[keyof typeof UpdateNotificationPreferenceRequestNotificationFrequency];

export const UpdateNotificationPreferenceRequestNotificationFrequency = {
    Unknown: "Unknown",
    RealTime: "RealTime",
    Scheduled: "Scheduled",
} as const;

export interface UpdateNotificationPreferenceRequest {
    notificationMethods?: UpdateNotificationPreferenceRequestNotificationMethodsItem[];
    notificationTypes?: UpdateNotificationPreferenceRequestNotificationTypesItem[];
    notificationFrequency?: UpdateNotificationPreferenceRequestNotificationFrequency;
    deviceGroupTags?: string[];
    deviceIdentities?: string[];
    schedule?: CreateNotificationScheduleRequest;
    removeSchedule?: boolean;
}

export interface UpdateOrganisationRequest {
    organisationId?: string;
    fullName?: string;
    rowSequence?: number;
    externalMaintenanceTicketingName?: string;
    /** The max number of devices that users in this org can create. */
    deviceProvisioningLimit?: number;
    /** Updated group ids for the org */
    organisationGroupIds?: string[];
}

export type UpdateVehicleRequestJurisdiction =
    (typeof UpdateVehicleRequestJurisdiction)[keyof typeof UpdateVehicleRequestJurisdiction];

export const UpdateVehicleRequestJurisdiction = {
    Unknown: "Unknown",
    ACT: "ACT",
    NSW: "NSW",
    NT: "NT",
    QLD: "QLD",
    SA: "SA",
    TAS: "TAS",
    VIC: "VIC",
    WA: "WA",
    National: "National",
} as const;

export type UpdateVehicleRequestVehicleType =
    (typeof UpdateVehicleRequestVehicleType)[keyof typeof UpdateVehicleRequestVehicleType];

export const UpdateVehicleRequestVehicleType = {
    Unknown: "Unknown",
    BEV: "BEV",
    PHEV: "PHEV",
    FCEV: "FCEV",
} as const;

export type UpdateVehicleRequestConnectorTypesItem =
    (typeof UpdateVehicleRequestConnectorTypesItem)[keyof typeof UpdateVehicleRequestConnectorTypesItem];

export const UpdateVehicleRequestConnectorTypesItem = {
    Unknown: "Unknown",
    CHAdeMO: "CHAdeMO",
    CCS: "CCS",
    CCS2: "CCS2",
    Type1: "Type1",
    Type2: "Type2",
    MCS: "MCS",
    Pantograph: "Pantograph",
    Domestic: "Domestic",
} as const;

export type UpdateVehicleRequestStatus =
    (typeof UpdateVehicleRequestStatus)[keyof typeof UpdateVehicleRequestStatus];

export const UpdateVehicleRequestStatus = {
    Inactive: "Inactive",
    Active: "Active",
    Archived: "Archived",
} as const;

export interface UpdateVehicleRequest {
    registrationPlate?: string;
    jurisdiction?: UpdateVehicleRequestJurisdiction;
    friendlyName?: string;
    make?: string;
    model?: string;
    year?: number;
    colour?: string;
    vehicleType?: UpdateVehicleRequestVehicleType;
    vin?: string;
    batteryCapacityKwh?: number;
    macAddress?: string;
    connectorTypes?: UpdateVehicleRequestConnectorTypesItem[];
    notes?: string;
    status?: UpdateVehicleRequestStatus;
}

export interface UptimePreferenceRequest {
    value?: boolean;
}

export interface UptimePreferenceResponse {
    value?: boolean;
    updatedAt?: Date;
    updatedByUserAccountId?: number;
}

/**
 * Report period
 */
export type UptimeReportMetadataPeriod =
    (typeof UptimeReportMetadataPeriod)[keyof typeof UptimeReportMetadataPeriod];

export const UptimeReportMetadataPeriod = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Annually: "Annually",
} as const;

/**
 * Only provided for WebhookType==UptimeReport
 */
export interface UptimeReportMetadata {
    /** Report period */
    period?: UptimeReportMetadataPeriod;
}

/**
 * Non Active users will have any webhooks/scheduled reports removed. Closed accounts cannot be reopened.
 */
export type UserAccountDetailsRequestAccountStatus =
    (typeof UserAccountDetailsRequestAccountStatus)[keyof typeof UserAccountDetailsRequestAccountStatus];

export const UserAccountDetailsRequestAccountStatus = {
    Invited: "Invited",
    Pending: "Pending",
    Active: "Active",
    Suspended: "Suspended",
    Closed: "Closed",
} as const;

export interface UserAccountDetailsRequest {
    /** Non Active users will have any webhooks/scheduled reports removed. Closed accounts cannot be reopened. */
    accountStatus?: UserAccountDetailsRequestAccountStatus;
    /** Only for Drivers. Enterprise and End users get their name from AD/ADB2C. */
    name?: string;
    /** Only for Drivers. Enterprise and End users get their email from AD/ADB2C. Username is not changed. */
    email?: string;
    /** Only for Drivers. Not required or used for other user types. */
    mobileNo?: string;
}

export type UserAccountDtoUserType =
    (typeof UserAccountDtoUserType)[keyof typeof UserAccountDtoUserType];

export const UserAccountDtoUserType = {
    Unknown: "Unknown",
    EnterpriseUser: "EnterpriseUser",
    EndUser: "EndUser",
    ApiUser: "ApiUser",
    Driver: "Driver",
} as const;

export type UserAccountDtoAccountStatus =
    (typeof UserAccountDtoAccountStatus)[keyof typeof UserAccountDtoAccountStatus];

export const UserAccountDtoAccountStatus = {
    Invited: "Invited",
    Pending: "Pending",
    Active: "Active",
    Suspended: "Suspended",
    Closed: "Closed",
} as const;

export interface UserAccountDto {
    userAccountId?: number;
    userType?: UserAccountDtoUserType;
    accountStatus?: UserAccountDtoAccountStatus;
    identityProvider?: string;
    name?: string;
    username?: string;
    email?: string;
    mobileNo?: string;
    createdAt?: Date;
    updatedAt?: Date;
    deviceOwner?: DeviceOwnerDto;
    roles?: string[];
    deviceGroupTags?: string[];
    organisationId?: string;
    parentUserAccountId?: number;
}

export interface UserAccountInvitationRequest {
    userAccount?: UserAccountDto;
    invitationMessage?: string;
}

export interface UserAccountResendInvitationRequest {
    userAccountId?: number;
    invitationMessage?: string;
}

export interface UserActionLogDto {
    userActionLogId?: number;
    organisationId?: string;
    userAccountId?: number;
    username?: string;
    platformSource?: string;
    ipAddress?: string;
    endpoint?: string;
    paramsJson?: string;
    targetDeviceIdentity?: string;
    targetUserAccountId?: number;
    logMessage?: string;
    resultErrorNo?: number;
    resultMessage?: string;
    resultIdentity?: number;
    resultIdentityStr?: string;
    createdAt?: Date;
    userAgent?: string;
}

export type UserBillingAccountDtoProvider =
    (typeof UserBillingAccountDtoProvider)[keyof typeof UserBillingAccountDtoProvider];

export const UserBillingAccountDtoProvider = {
    Unknown: "Unknown",
    StripeSandbox: "StripeSandbox",
    Stripe: "Stripe",
} as const;

export type UserBillingAccountDtoStatus =
    (typeof UserBillingAccountDtoStatus)[keyof typeof UserBillingAccountDtoStatus];

export const UserBillingAccountDtoStatus = {
    Unknown: "Unknown",
    Required: "Required",
    Active: "Active",
    Suspended: "Suspended",
    Closed: "Closed",
} as const;

export interface UserBillingAccountDto {
    userBillingAccountId?: number;
    userAccountId?: number;
    providerUserId?: string;
    provider?: UserBillingAccountDtoProvider;
    currencyCode?: string;
    status?: UserBillingAccountDtoStatus;
    statusMessage?: string;
    termsAcceptedAt?: Date;
    updatedAt?: Date;
}

export type VehicleDtoJurisdiction =
    (typeof VehicleDtoJurisdiction)[keyof typeof VehicleDtoJurisdiction];

export const VehicleDtoJurisdiction = {
    Unknown: "Unknown",
    ACT: "ACT",
    NSW: "NSW",
    NT: "NT",
    QLD: "QLD",
    SA: "SA",
    TAS: "TAS",
    VIC: "VIC",
    WA: "WA",
    National: "National",
} as const;

export type VehicleDtoVehicleType =
    (typeof VehicleDtoVehicleType)[keyof typeof VehicleDtoVehicleType];

export const VehicleDtoVehicleType = {
    Unknown: "Unknown",
    BEV: "BEV",
    PHEV: "PHEV",
    FCEV: "FCEV",
} as const;

export type VehicleDtoConnectorTypesItem =
    (typeof VehicleDtoConnectorTypesItem)[keyof typeof VehicleDtoConnectorTypesItem];

export const VehicleDtoConnectorTypesItem = {
    Unknown: "Unknown",
    CHAdeMO: "CHAdeMO",
    CCS: "CCS",
    CCS2: "CCS2",
    Type1: "Type1",
    Type2: "Type2",
    MCS: "MCS",
    Pantograph: "Pantograph",
    Domestic: "Domestic",
} as const;

export type VehicleDtoStatus =
    (typeof VehicleDtoStatus)[keyof typeof VehicleDtoStatus];

export const VehicleDtoStatus = {
    Inactive: "Inactive",
    Active: "Active",
    Archived: "Archived",
} as const;

export interface VehicleDto {
    vehicleId?: number;
    registrationPlate?: string;
    jurisdiction?: VehicleDtoJurisdiction;
    friendlyName?: string;
    make?: string;
    model?: string;
    year?: number;
    colour?: string;
    vehicleType?: VehicleDtoVehicleType;
    vin?: string;
    batteryCapacityKwh?: number;
    macAddress?: string;
    connectorTypes?: VehicleDtoConnectorTypesItem[];
    notes?: string;
    organisationId?: string;
    status?: VehicleDtoStatus;
    createdAt?: Date;
    updatedAt?: Date;
}

export type VehicleModelOptionDtoVehicleType =
    (typeof VehicleModelOptionDtoVehicleType)[keyof typeof VehicleModelOptionDtoVehicleType];

export const VehicleModelOptionDtoVehicleType = {
    Unknown: "Unknown",
    BEV: "BEV",
    PHEV: "PHEV",
    FCEV: "FCEV",
} as const;

export interface VehicleModelOptionDto {
    model?: string;
    vehicleType?: VehicleModelOptionDtoVehicleType;
    batteryCapacityKwh?: number;
}

export type VehicleModelReferenceDtoVehicleType =
    (typeof VehicleModelReferenceDtoVehicleType)[keyof typeof VehicleModelReferenceDtoVehicleType];

export const VehicleModelReferenceDtoVehicleType = {
    Unknown: "Unknown",
    BEV: "BEV",
    PHEV: "PHEV",
    FCEV: "FCEV",
} as const;

export interface VehicleModelReferenceDto {
    vehicleModelReferenceId?: number;
    make?: string;
    model?: string;
    vehicleType?: VehicleModelReferenceDtoVehicleType;
    batteryCapacityKwh?: number;
    createdAt?: Date;
    updatedAt?: Date;
}

/**
 * Report period
 */
export type VehicleReportMetadataPeriod =
    (typeof VehicleReportMetadataPeriod)[keyof typeof VehicleReportMetadataPeriod];

export const VehicleReportMetadataPeriod = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Annually: "Annually",
} as const;

/**
 * Only provided for WebhookType==VehicleReport
 */
export interface VehicleReportMetadata {
    /** Report period */
    period?: VehicleReportMetadataPeriod;
}

/**
 * DeviceStatus: Payload of type DeviceStatusWebhook will be pushed
 */
export type WebhookDtoWebhookType =
    (typeof WebhookDtoWebhookType)[keyof typeof WebhookDtoWebhookType];

export const WebhookDtoWebhookType = {
    DeviceStatus: "DeviceStatus",
    Nem12Report: "Nem12Report",
    TransactionReport: "TransactionReport",
    PayMateStartTransaction: "PayMateStartTransaction",
    PayMateStopTransaction: "PayMateStopTransaction",
    PayMatePaymentConfirmation: "PayMatePaymentConfirmation",
    DeviceConfigurationChange: "DeviceConfigurationChange",
    ChargepointCurtailmentAction: "ChargepointCurtailmentAction",
    UptimeReport: "UptimeReport",
    OfflineDeviceReport: "OfflineDeviceReport",
    FaultedDeviceReport: "FaultedDeviceReport",
    CarbonEmissionReport: "CarbonEmissionReport",
    VehicleReport: "VehicleReport",
} as const;

/**
 * Outgoing http headers to be added to the request
 */
export type WebhookDtoHeaders = { [key: string]: string };

export interface WebhookMetadata {
    nem12ReportMetadata?: Nem12ReportMetadata;
    transactionReportMetadata?: TransactionReportMetadata;
    uptimeReportMetadata?: UptimeReportMetadata;
    offlineDeviceReportMetadata?: OfflineDeviceReportMetadata;
    faultedDeviceReportMetadata?: FaultedDeviceReportMetadata;
    vehicleReportMetadata?: VehicleReportMetadata;
}

export interface WebhookDto {
    webhookId?: number;
    /** DeviceStatus: Payload of type DeviceStatusWebhook will be pushed */
    webhookType?: WebhookDtoWebhookType;
    accessTag?: string;
    /** By default, the webhook is sent by any device in your organisation. Use this to restrict to a subset of devices (eg a Site) */
    deviceGroupTag?: string;
    /** Outgoing uri, either a http(s) or mailto link. When using mailto, additional email addresses can be supplied as a semicolon-sparated list to the 'cc' query param. 'subject' and 'body' params are also supported. Eg: `mailto:first@test.com?cc=second@test.com;third@test.com&subject=My%20NEM12%20data&body=test` */
    url?: string;
    /** Max number of times to retry the same payload if a non HTTP-2XX status code is returned, before the payload is dead-lettered. Limit: 9. Use 0 for only one attempt with no retry. */
    maxRetries?: number;
    /** Outgoing http headers to be added to the request */
    headers?: WebhookDtoHeaders;
    metadata?: WebhookMetadata;
    createdAt?: Date;
    updatedAt?: Date;
    /** True if this webhook is disabled. Disabled webhooks are retained and listed but not invoked. Settable via update-webhook to disable or re-enable. */
    isDisabled?: boolean;
}

export type ChargerMeterValuesParams = {
    limit?: number;
    cursor?: string;
    /**
     * Direction
     */
    oldestFirst?: boolean;
};

export type TransactionsParams = {
    limit?: number;
    cursor?: string;
};

export type TransactionSearchParams = {
    limit?: number;
    cursor?: string;
    /**
     * if set, the other params are not needed
     */
    transactionId?: number;
    /**
     * if set, the other params are not needed
     */
    transactionLocalId?: string;
    /**
     * if set, the other params are not needed. Only applicable for transactions managed by Chargefox.
     */
    centralSystemTransactionId?: string;
    /**
     * rfid tag
     */
    idTag?: string;
};

export type DeviceActiveTransactionsParams = {
    /**
     * Optionally filter to single connector
     */
    connectorIndex?: number;
};

export type SetRfidTagDeviceGroupsParams = {
    /**
     * Set the user's deviceGroups to this comma separated list of DeviceGroupTags. Omit to remove all deice groups.
     */
    deviceGroupTags?: string[];
};

export type RfidBulkUploadCsvParams = {
    /**
     * True to perform validation only, false to perfrom db operations
     */
    validateOnly?: boolean;
};

export type GetGlobalChargingSuccessRateParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
};

export type GetDeviceGroupChargingSuccessRateParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
};

export type GetDeviceChargingSuccessRateParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
};

export type GetConnectorChargingSuccessRateParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
};

export type GetGlobalChargingSuccessRateTrendParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
};

export type GetDeviceGroupChargingSuccessRateTrendParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
};

export type GetDeviceChargingSuccessRateTrendParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
};

export type GetConnectorChargingSuccessRateTrendParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
};

export type GetGroupedChargingSuccessRateTrendByDeviceGroupParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
    /**
     * A list of device group tags (max 10)
     */
    deviceGroupTags: string[];
};

export type GetGroupedChargingSuccessRateTrendByDeviceParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
    /**
     * A list of device identities (max 10)
     */
    deviceIdentities: string[];
};

export type GetGroupedSessionsByOrgParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
};

export type GetGroupedSessionsBySiteParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
    /**
     * Optional filter by organisation ID
     */
    organisationId?: string;
};

export type GetGroupedSessionsByDeviceParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
    /**
     * Optional filter to devices in a specific device group (org, site, service model)
     */
    deviceGroupTag?: string;
};

export type GetCumulativeEnergyConsumptionParams = {
    /**
     * Date range from. Should be a date only, without time component, for intervals above Hour. (eg `from=2022-01-01&to=2022-01-02&inLocalTime=true&interval=Day`
     */
    from: string;
    /**
     * Date range to.
     */
    to: string;
    /**
     * Results are aggregated by the requested interval
     */
    interval?: GetCumulativeEnergyConsumptionInterval;
    /**
     * A charger id, or a Core id for all chargers on that core
     */
    deviceId: string;
    /**
     * True if the supplied from and to params refer to the dates in site's local timezone. False if the parms are datetimes in UTC. All returned date objects are serialized to UTC.
     */
    inLocalTime?: boolean;
};

export type GetCumulativeEnergyConsumptionInterval =
    (typeof GetCumulativeEnergyConsumptionInterval)[keyof typeof GetCumulativeEnergyConsumptionInterval];

export const GetCumulativeEnergyConsumptionInterval = {
    minute: "minute",
    hour: "hour",
    day: "day",
    week: "week",
    month: "month",
} as const;

export type GetTotalEnergyConsumptionHistoryParams = {
    /**
     * Date range from. Should be a date only, without time component (eg `from=2022-01-01&to=2022-01-02&inLocalTime=true&interval=Day`
     */
    from: string;
    /**
     * Date range to.
     */
    to: string;
    /**
     * Results are aggregated by the requested interval. Currently only Hour is supported.
     */
    interval?: GetTotalEnergyConsumptionHistoryInterval;
    /**
     * DeviceGroupTag (eg site).
     */
    deviceGroupTag: string;
    /**
     * True if the supplied from and to params refer to the dates in site's local timezone. False if the parms are datetimes in UTC. All returned date objects are serialized to UTC.
     */
    inLocalTime?: boolean;
};

export type GetTotalEnergyConsumptionHistoryInterval =
    (typeof GetTotalEnergyConsumptionHistoryInterval)[keyof typeof GetTotalEnergyConsumptionHistoryInterval];

export const GetTotalEnergyConsumptionHistoryInterval = {
    minute: "minute",
    hour: "hour",
    day: "day",
    week: "week",
    month: "month",
} as const;

export type GetTotalEnergyConsumptionValueParams = {
    /**
     * Date range from. Should be a date only, without time component (eg `from=2022-01-01&to=2022-01-02&inLocalTime=true&interval=Day`
     */
    from: string;
    /**
     * Date range to.
     */
    to: string;
    /**
     * Restrict results to devices in any/all (based on isIntersection) of these comma-separated list of DeviceGroupTags (eg sites). Omit for all devices in the system (or all devices in the org, for org users). Devices in multiple matching Groups will only be counted once.
     */
    deviceGroupTags?: string[];
    /**
     * True if the supplied from and to params refer to the dates in site's local timezone. False if the parms are datetimes in UTC. All returned date objects are serialized to UTC.
     */
    inLocalTime?: boolean;
    /**
     * True to query devices in intersection of all provided tags. False for devices in any of the tags.
     */
    isIntersection?: boolean;
};

export type GetPowerConsumptionParams = {
    /**
     * Date range from. Should be a date only, without time component, for intervals above Hour. (eg `from=2022-01-01&to=2022-01-02&inLocalTime=true&interval=Day`
     */
    from: string;
    /**
     * Date range to.
     */
    to: string;
    /**
     * Optional. Results are aggregated by the requested interval (avg for power, voltage, current, max for energy), raw data if parameter not present
     */
    interval?: GetPowerConsumptionInterval;
    /**
     * A power meter id, or a Core id for all chargers on that core
     */
    deviceId: string;
    /**
     * True if the supplied from and to params refer to the dates in site's local timezone. False if the parms are datetimes in UTC. All returned date objects are serialized to UTC.
     */
    inLocalTime?: boolean;
};

export type GetPowerConsumptionInterval =
    (typeof GetPowerConsumptionInterval)[keyof typeof GetPowerConsumptionInterval];

export const GetPowerConsumptionInterval = {
    minute: "minute",
    hour: "hour",
    day: "day",
    week: "week",
    month: "month",
} as const;

export type GetChargeSessionCountParams = {
    /**
     * Date range from. Should be a date only, without time component, for intervals above Hour. (eg `from=2022-01-01&to=2022-01-02&inLocalTime=true&interval=Day`
     */
    from: string;
    /**
     * Date range to.
     */
    to: string;
    /**
     * Results are aggregated by the requested interval
     */
    interval?: GetChargeSessionCountInterval;
    /**
     * Restrict results to devices in all (intersection) of these comma-separated list of DeviceGroupTags (eg sites). Omit for all devices in the system (or all devices in the org, for org users).
     */
    deviceGroupTags?: string[];
    /**
     * A charger id, or a Core id for all chargers assigned to that core.
     */
    deviceId?: string;
    /**
     * True if the supplied from and to params refer to the dates in site's local timezone. False if the parms are datetimes in UTC. All returned date objects are serialized to UTC.
     */
    inLocalTime?: boolean;
    /**
     * True to average the data over the next highest interval. Eg if Interval=Hour, average the results into 'hour of day' buckets. If Interval=Day, average into 'day of week' buckets.
     */
    asTrend?: boolean;
};

export type GetChargeSessionCountInterval =
    (typeof GetChargeSessionCountInterval)[keyof typeof GetChargeSessionCountInterval];

export const GetChargeSessionCountInterval = {
    minute: "minute",
    hour: "hour",
    day: "day",
    week: "week",
    month: "month",
} as const;

export type GetCoreConfigParams = {
    /**
     * Ignore draft configs when false
     */
    includeDraft?: boolean;
};

export type GetDistributionBoardSnapshotsParams = {
    /**
     * Determines how far back the snapshots to return
     */
    timeRange?: GetDistributionBoardSnapshotsTimeRange;
};

export type GetDistributionBoardSnapshotsTimeRange =
    (typeof GetDistributionBoardSnapshotsTimeRange)[keyof typeof GetDistributionBoardSnapshotsTimeRange];

export const GetDistributionBoardSnapshotsTimeRange = {
    previous24Hours: "previous24Hours",
    previous7Days: "previous7Days",
    previous30Days: "previous30Days",
} as const;

export type GetStatusesParams = {
    /**
     * Determines how far back the statuses to return
     */
    timeRange?: GetStatusesTimeRange;
};

export type GetStatusesTimeRange =
    (typeof GetStatusesTimeRange)[keyof typeof GetStatusesTimeRange];

export const GetStatusesTimeRange = {
    previous24Hours: "previous24Hours",
    previous7Days: "previous7Days",
    previous30Days: "previous30Days",
} as const;

export type GetDeviceStatusesParams = {
    /**
     * Determines how far back the device statuses to return
     */
    timeRange?: GetDeviceStatusesTimeRange;
    /**
     * The maximum number of data points to return after downsampling.
     */
    threshold: number;
};

export type GetDeviceStatusesTimeRange =
    (typeof GetDeviceStatusesTimeRange)[keyof typeof GetDeviceStatusesTimeRange];

export const GetDeviceStatusesTimeRange = {
    previous24Hours: "previous24Hours",
    previous7Days: "previous7Days",
    previous30Days: "previous30Days",
} as const;

export type GetLoadReductionStatusesParams = {
    /**
     * Determines how far back the load reduction statuses to return
     */
    timeRange?: GetLoadReductionStatusesTimeRange;
    /**
     * The maximum number of data points to return after downsampling.
     */
    threshold: number;
};

export type GetLoadReductionStatusesTimeRange =
    (typeof GetLoadReductionStatusesTimeRange)[keyof typeof GetLoadReductionStatusesTimeRange];

export const GetLoadReductionStatusesTimeRange = {
    previous24Hours: "previous24Hours",
    previous7Days: "previous7Days",
    previous30Days: "previous30Days",
} as const;

export type GetConnectivityStatusesParams = {
    /**
     * Determines how far back the connectivity statuses to return
     */
    timeRange?: GetConnectivityStatusesTimeRange;
    /**
     * The maximum number of data points to return after downsampling.
     */
    threshold: number;
};

export type GetConnectivityStatusesTimeRange =
    (typeof GetConnectivityStatusesTimeRange)[keyof typeof GetConnectivityStatusesTimeRange];

export const GetConnectivityStatusesTimeRange = {
    previous24Hours: "previous24Hours",
    previous7Days: "previous7Days",
    previous30Days: "previous30Days",
} as const;

export type DeviceCatalogueLinkParams = {
    /**
     * The DeviceCatalogueId to link the device to. Omit or pass null to unlink.
     */
    deviceCatalogueId?: number;
};

export type DeviceConnectorPricingScheduleParams = {
    /**
     * connector index. Omit to retrieve all pricing schedules for all connectors of device
     */
    connectorIndex?: number;
};

export type ListFirmwareForModelParams = {
    include_disabled?: boolean;
};

export type ListFirmwareForDeviceParams = {
    include_disabled?: boolean;
};

export type FirmwareStatusSetParams = {
    /**
     * firmware container name
     */
    container_name: string;
    /**
     * filename
     */
    filename: string;
    /**
     * enable/disable
     */
    status?: FirmwareStatusSetStatus;
    /**
     * Notes
     */
    notes?: string;
};

export type FirmwareStatusSetStatus =
    (typeof FirmwareStatusSetStatus)[keyof typeof FirmwareStatusSetStatus];

export const FirmwareStatusSetStatus = {
    enabled: "enabled",
    disabled: "disabled",
} as const;

export type DeviceGroupDeleteParams = {
    /**
     * True to perform validation only, false (default) to perfrom db operations
     */
    validateOnly?: boolean;
};

export type DeviceGroupUptimeParams = {
    /**
     * Restrict results to devices in both the deviceGroupTag and this ServiceModel.
     */
    serviceModelDeviceGroupTag?: string;
    /**
     * Start date to calculate the uptime from. Defaults to 30 days ago. ISO-8601 format.
     */
    from?: string;
    /**
     * End date to calculate the uptime to. Defaults to now. ISO-8601 format.
     */
    to?: string;
};

export type DeviceGroupDailyUptimesParams = {
    /**
     * Restrict results to devices in both the deviceGroupTag and this ServiceModel.
     */
    serviceModelDeviceGroupTag?: string;
    /**
     * Start date to calculate the uptime from. Defaults to 30 days ago. ISO-8601 format.
     */
    from?: string;
    /**
     * End date to calculate the uptime to. Defaults to now. ISO-8601 format.
     */
    to?: string;
};

export type ToggleFavouriteDeviceGroupParams = {
    /**
     * True to set as favorite, false to unset
     */
    isFavourite: boolean;
};

export type DeviceListParams = {
    /**
     * optionally filter by registration status
     */
    registrationStatus?: DeviceListRegistrationStatus;
    /**
     * optionally filter by device type
     */
    deviceType?: DeviceListDeviceType;
    /**
     * optionally filter by device owner
     */
    deviceOwnerId?: number;
    /**
     * optionally filter by device access tag
     */
    accessTag?: string;
    /**
     * optionally nest child devices and PayMate chargers in their parents, rather than returning in a flat list. Recommended when deviceType==Wave or PayMate
     */
    nestChildDevices?: boolean;
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
};

export type DeviceListRegistrationStatus =
    (typeof DeviceListRegistrationStatus)[keyof typeof DeviceListRegistrationStatus];

export const DeviceListRegistrationStatus = {
    unverified: "unverified",
    inactive: "inactive",
    active: "active",
} as const;

export type DeviceListDeviceType =
    (typeof DeviceListDeviceType)[keyof typeof DeviceListDeviceType];

export const DeviceListDeviceType = {
    chargePoint: "chargePoint",
    illuminate: "illuminate",
    thirdPartyPassthrough: "thirdPartyPassthrough",
    payMate: "payMate",
    wave: "wave",
    powerMeter: "powerMeter",
    core: "core",
    barrier: "barrier",
} as const;

export type DeviceDetailParams = {
    /**
     * optionally lookup an archived device with the same deviceIdentity
     */
    deviceArchiveId?: number;
};

export type DeviceParentGetParams = {
    /**
     * optionally lookup an archived device with the same deviceIdentity (default 0)
     */
    deviceArchiveId?: number;
};

export type DeviceParentSetParams = {
    /**
     * optionally lookup an archived device with the same deviceIdentity (default 0)
     */
    deviceArchiveId?: number;
    /**
     * the new parent identity. Omit parameter to clear the parent
     */
    parentDeviceIdentity?: string;
    /**
     * the new parent device archive (default 0)
     */
    parentDeviceArchiveId?: number;
};

export type ChargerPayMateGetParams = {
    /**
     * optionally lookup an archived charger with the same deviceIdentity (default 0)
     */
    deviceArchiveId?: number;
};

export type ChargerPayMateLinkParams = {
    /**
     * optionally lookup an archived device with the same deviceIdentity (default 0)
     */
    deviceArchiveId?: number;
    /**
     * the new PayMate identity. Omit parameter to clear
     */
    payMateDeviceIdentity?: string;
    /**
     * the new PayMate device archive id (default 0)
     */
    payMateDeviceArchiveId?: number;
};

export type DeviceLiveLogEnableParams = {
    /**
     * optionally provide log expiry time (default 60). Use -1 if you wish to stop live logging - but it is ok to simply await expiry.
     */
    expiryMinutes?: number;
};

export type SetDeviceOperationalStatusParams = {
    /**
     * Date to mark the device as operational from. ISO-8601 format. Omit to set device as non-operational.
     */
    operationalAt?: string;
};

export type DeviceUptimeParams = {
    /**
     * Start date to calculate the uptime from. Defaults to 30 days ago. ISO-8601 format.
     */
    from?: string;
    /**
     * End date to calculate the uptime to. Defaults to now. ISO-8601 format.
     */
    to?: string;
};

export type DeviceConnectorUptimeParams = {
    /**
     * Start date to calculate the uptime from. Defaults to 30 days ago. ISO-8601 format.
     */
    from?: string;
    /**
     * End date to calculate the uptime to. Defaults to now. ISO-8601 format.
     */
    to?: string;
};

export type DeviceDailyUptimesParams = {
    /**
     * Start date to calculate the uptime from. Defaults to 30 days ago. ISO-8601 format.
     */
    from?: string;
    /**
     * End date to calculate the uptime to. Defaults to now. ISO-8601 format.
     */
    to?: string;
};

export type DeviceManagedByUpdateParams = {
    /**
     * central system id
     */
    managedBy?: DeviceManagedByUpdateManagedBy;
};

export type DeviceManagedByUpdateManagedBy =
    (typeof DeviceManagedByUpdateManagedBy)[keyof typeof DeviceManagedByUpdateManagedBy];

export const DeviceManagedByUpdateManagedBy = {
    chargefoxDev: "chargefoxDev",
    chargefoxStaging: "chargefoxStaging",
    chargefoxProd: "chargefoxProd",
    illuminate: "illuminate",
    exploren: "exploren",
    fortum: "fortum",
    chargeHq: "chargeHq",
    dynamicPassthroughParent: "dynamicPassthroughParent",
    dynamicPassthroughChild: "dynamicPassthroughChild",
    gatewayDynamicPassthroughChild: "gatewayDynamicPassthroughChild",
    serverlessFunctionApp: "serverlessFunctionApp",
} as const;

export type UpdateChargerOcppConnectionParams = {
    /**
     * New ocpp connection uri template
     */
    ocppConnectionUriTemplate: string;
    /**
     * New device identity
     */
    newDeviceIdentity?: string;
    /**
     * Reboot the device on success
     */
    reboot?: boolean;
    /**
     * Update ocpp connection only if set directly on Illuminate
     */
    allowOnlyIfOnIlluminate?: boolean;
    /**
     * Refresh config before updating
     */
    refreshConfig?: boolean;
    /**
     * Validate Ocpp endpoint only.
     */
    validateOnly?: boolean;
};

export type DeviceConnectionStatusesParams = {
    /**
     * A list of device identities to get the connection status
     */
    deviceIdentities: string[];
};

export type PrepareDeviceForReprovisioningParams = {
    /**
     * Duration for temporary access (default 30 minutes)
     */
    timeoutMinutes?: number;
};

export type ValidateNewDeviceParams = {
    /**
     * new device identity. Optional
     */
    newDeviceIdentity?: string;
};

export type DeviceOwnerDetailByDeviceIdParams = {
    /**
     * optionally lookup an archived device with the same deviceIdentity
     */
    deviceArchiveId?: number;
};

export type SetDeviceOwnerParams = {
    /**
     * optionally lookup an archived device with the same deviceIdentity
     */
    deviceArchiveId?: number;
    /**
     * The new device owner, or omit to remove the owner
     */
    deviceOwnerId?: number;
    /**
     * True to apply the same ownership to all child devices of this Wave device
     */
    cascadeToChildDevices?: boolean;
};

export type DeviceOwnerUserAccountVerificationParams = {
    /**
     * user account id to link, or omit to remove
     */
    userAccountId?: number;
};

export type DeviceScheduleTemplateListParams = {
    /**
     * Optional filter to schedules that may be applied to this device
     */
    deviceIdentity?: string;
};

export type DeviceScheduleTemplateSetParams = {
    /**
     * On success, also update any chargers using this existing template with the latest changes.
     */
    updateDevices?: boolean;
};

export type DnspGetDerEventsParams = {
    /**
     * limit
     */
    limit?: number;
    /**
     * optionally include DER statistics
     */
    includeStatistics?: boolean;
    /**
     * Filter to events with StartUtc before this date. Can be used as a paging cursor
     */
    startingBefore?: Date;
    /**
     * Filter to one specific DNSP (currently, you must be admin or have this DNSP accessTag)
     */
    dnspTag?: string;
};

export type DnspGetControlIntervalsByDeviceParams = {
    /**
     * Date range from
     */
    from: Date;
    /**
     * Date range to. Max range is 24 hours.
     */
    to: Date;
    /**
     * Optional, to limit response to a single device id
     */
    deviceId?: string;
};

export type FaultedSitesParams = {
    /**
     * Organisation ID
     */
    organisationId?: string;
};

export type FaultedSitesCountParams = {
    /**
     * Restrict results to devices in all (intersection) of these comma-separated list of DeviceGroupTags (eg sites). Omit for all devices in the system (or all devices in the org, for org users).
     */
    deviceGroupTags?: string[];
};

export type GlobalDeviceStatusParams = {
    /**
     * Restrict results to devices in any/all (based on isIntersection) of these comma-separated list of DeviceGroupTags (eg sites). Omit for all devices in the system (or all devices in the org, for org users). Devices in multiple matching Groups will only be counted once.
     */
    deviceGroupTags?: string[];
    /**
     * Include non-operational chargers in counts.  Default is false.
     */
    includeNonOpChargers?: boolean;
    /**
     * True to query devices in intersection of all provided tags. False for devices in any of the tags.
     */
    isIntersection?: boolean;
};

export type GlobalDeviceConnectorStatusParams = {
    /**
     * Restrict results to devices in any/all (based on isIntersection) of these comma-separated list of DeviceGroupTags (eg sites). Omit for all devices in the system (or all devices in the org, for org users). Devices in multiple matching Groups will only be counted once.
     */
    deviceGroupTags?: string[];
    /**
     * Include non-operational chargers in counts. Default is false.
     */
    includeNonOpChargers?: boolean;
    /**
     * True to query devices in intersection of all provided tags. False for devices in any of the tags.
     */
    isIntersection?: boolean;
};

export type GlobalDeviceGroupUpTimeParams = {
    /**
     * Restrict results to devices in any of these comma-separated list of DeviceGroupTags (eg sites). Omit for all devices in the system (or all devices in the org, for org users).
     */
    deviceGroupTags?: string[];
};

export type GetOnlineStatusPercentageParams = {
    /**
     * Date range from. Should be a date only, without time component (eg `from=2022-01-01&to=2022-01-02&inLocalTime=true&interval=Day`
     */
    from: string;
    /**
     * Date range to.
     */
    to: string;
    /**
     * Results are aggregated by the requested interval
     */
    interval?: GetOnlineStatusPercentageInterval;
};

export type GetOnlineStatusPercentageInterval =
    (typeof GetOnlineStatusPercentageInterval)[keyof typeof GetOnlineStatusPercentageInterval];

export const GetOnlineStatusPercentageInterval = {
    tenMinutes: "tenMinutes",
    thirtyMinutes: "thirtyMinutes",
    hour: "hour",
    twelveHours: "twelveHours",
    day: "day",
} as const;

export type GetSimpleDeviceStatusPercentageParams = {
    /**
     * Date range from. Should be a date only, without time component (eg `from=yyyy-mm-dd&to=2022-01-02`
     */
    from: string;
    /**
     * Date range to. Defaults to current day
     */
    to: string;
    /**
     * Results are aggregated by the requested interval
     */
    interval?: GetSimpleDeviceStatusPercentageInterval;
    /**
     * Filters the status data to include only entries from the specified connector index.
     */
    connectorIndex?: number;
};

export type GetSimpleDeviceStatusPercentageInterval =
    (typeof GetSimpleDeviceStatusPercentageInterval)[keyof typeof GetSimpleDeviceStatusPercentageInterval];

export const GetSimpleDeviceStatusPercentageInterval = {
    tenMinutes: "tenMinutes",
    thirtyMinutes: "thirtyMinutes",
    hour: "hour",
    twelveHours: "twelveHours",
    day: "day",
} as const;

export type GetAccessTagsParams = {
    /**
     * If true, return the subset of only the tags you have access to. Requires your Authorization header.
     */
    mineOnly?: boolean;
};

export type DeleteOrganisationParams = {
    /**
     * OrganisationId
     */
    organisationId: string;
    /**
     * True to perform validation only, false (default) to perfrom db operations
     */
    validateOnly?: boolean;
};

export type GetDeviceTypesParams = {
    /**
     * If true, return the subset of only the types you have access to. Requires your Authorization header.
     */
    mineOnly?: boolean;
};

export type GetRolesAndPermissionsParams = {
    /**
     * If true, return only your roles and permissions. Otherwise, returns all roles available to your organisation (or all roles if JC staff)
     */
    mineOnly?: boolean;
};

export type GetDeviceConfigurationSchemaParams = {
    /**
     * Optionally filter by device type
     */
    deviceType?: GetDeviceConfigurationSchemaDeviceType;
    /**
     * Optionally filter for schemas for this device model (using startsWith)
     */
    model?: string;
};

export type GetDeviceConfigurationSchemaDeviceType =
    (typeof GetDeviceConfigurationSchemaDeviceType)[keyof typeof GetDeviceConfigurationSchemaDeviceType];

export const GetDeviceConfigurationSchemaDeviceType = {
    chargePoint: "chargePoint",
    illuminate: "illuminate",
    thirdPartyPassthrough: "thirdPartyPassthrough",
    payMate: "payMate",
    wave: "wave",
    powerMeter: "powerMeter",
    core: "core",
    barrier: "barrier",
} as const;

export type GetNotificationTypesParams = {
    /**
     * If true, return only the types that are currently enabled.
     */
    enabledOnly?: boolean;
};

export type GetNotificationMethodsParams = {
    /**
     * If true, return only the methods that are currently enabled.
     */
    enabledOnly?: boolean;
};

export type ServiceModelLookupParams = {
    /**
     * organisation id to return only the service model for this organisation
     */
    organisationId?: string;
    /**
     * device identity to return only the service model for this device
     */
    deviceIdentity?: string;
};

export type AssignPartnerToOrganisationParams = {
    /**
     * The parent (partner) organisation ID to assign. Omit or empty string to clear existing parent.
     */
    parentOrganisationId?: string;
    /**
     * If true, only validate the request, do not make any changes.
     */
    validateOnly?: boolean;
};

export type ReleaseDeviceServiceParams = {
    /**
     * device service instance id.
     */
    deviceServiceInstanceId: string;
    /**
     * Duration (s) over which to progressively disconnect devices
     */
    durationSeconds?: number;
    /**
     * Cancel any pending device service release operation (if any) and start accepting new connections again
     */
    acceptNewConnections?: string;
};

export type MediaItemAddToParams = {
    /**
     * add or remove
     */
    add?: boolean;
    /**
     * device group tag
     */
    deviceGroupTag?: string;
    /**
     * device id
     */
    deviceIdentity?: string;
};

export type AcceptSignupCodeParams = {
    /**
     * signup code
     */
    code: string;
};

export type CheckSignupCodeParams = {
    /**
     * signup code
     */
    code: string;
    /**
     * email
     */
    email: string;
};

export type SetOfferDeviceGroupsParams = {
    /**
     * Set the offer's device groups to this comma separated list of DeviceGroupTags. Omit to remove all device groups.
     */
    deviceGroupTags?: string[];
};

export type GenerateOfferCodesParams = {
    /**
     * number of codes to generate, 1-100. Default 1
     */
    count?: number;
    /**
     * when the codes expire if unredeemed. Must not be after the offer's expiresAt. Default 30 days, clamped to the offer's expiresAt
     */
    expiresAt?: Date;
};

export type GetOrganisationPreferencesParams = {
    /**
     * Optional target organisation id. Defaults to current user's organisation id.
     */
    organisationId?: string;
};

export type PassthroughConfigsListParams = {
    /**
     * optionally filter by enabled state. Omit for both.
     */
    enabled?: boolean;
};

export type PassthroughConfigDetailParams = {
    /**
     * optionally lookup by passthroughConfigSlug instead of id. Use 0 for the id in the route.
     */
    passthroughConfigSlug?: string;
};

export type GetTotalCarbonEmissionsEstimateValueParams = {
    /**
     * Date range from. Should be a date only, without time component (eg `from=2022-01-01&to=2022-01-02&inLocalTime=true&interval=Day`
     */
    from: string;
    /**
     * Date range to.
     */
    to: string;
    /**
     * Restrict results to devices in any of the DeviceGroupTag (eg sites). Omit for all devices in the system (or all devices in the org, for org users). Devices in multiple matching Groups will only be counted once.
     */
    deviceGroupTag?: string[];
    /**
     * True if the supplied from and to params refer to the dates in site's local timezone. False if the parms are datetimes in UTC. All returned date objects are serialized to UTC.
     */
    inLocalTime?: boolean;
    /**
     * The scope factors to use for emission conversions.
     */
    scopeFactorTypes: GetTotalCarbonEmissionsEstimateValueScopeFactorTypesItem[];
};

export type GetTotalCarbonEmissionsEstimateValueScopeFactorTypesItem =
    (typeof GetTotalCarbonEmissionsEstimateValueScopeFactorTypesItem)[keyof typeof GetTotalCarbonEmissionsEstimateValueScopeFactorTypesItem];

export const GetTotalCarbonEmissionsEstimateValueScopeFactorTypesItem = {
    scope1: "scope1",
    scope2: "scope2",
    scope3: "scope3",
} as const;

export type DeviceGroupDailyCarbonEmissionParams = {
    /**
     * Start date to calculate the daily emission from. Defaults to 30 days ago. ISO-8601 format.
     */
    from?: string;
    /**
     * End date to calculate the daily emission to. Defaults to now. ISO-8601 format.
     */
    to?: string;
    /**
     * The scope factors to use for emission conversions.
     */
    scopeFactorTypes: DeviceGroupDailyCarbonEmissionScopeFactorTypesItem[];
};

export type DeviceGroupDailyCarbonEmissionScopeFactorTypesItem =
    (typeof DeviceGroupDailyCarbonEmissionScopeFactorTypesItem)[keyof typeof DeviceGroupDailyCarbonEmissionScopeFactorTypesItem];

export const DeviceGroupDailyCarbonEmissionScopeFactorTypesItem = {
    scope1: "scope1",
    scope2: "scope2",
    scope3: "scope3",
} as const;

export type TaskListParams = {
    /**
     * Filter to tasks created by this userAccountId. Omit if you have Permission.user_tasks_read, to query tasks from all users in your organisation (or ALL users if JC Staff). Otherwise, must be current user's userAccountId
     */
    userAccountId?: number;
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    olderThan?: Date;
};

export type TaskListForDeviceParams = {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    olderThan?: Date;
};

export type TicketListParams = {
    /**
     * JC staff only: view tickets for a specific org, or omit for all orgs. Do not use for non-JC staff.
     */
    organisationId?: string;
    /**
     * Open tickets only
     */
    openOnly?: boolean;
    /**
     * Tickets for this device only
     */
    deviceIdentity?: string;
    /**
     * Tickets reported by this user only
     */
    reportedByMe?: boolean;
    /**
     * Only return tickets updated since this date (ISO 8601).
     */
    updatedSince?: string;
    /**
     * Filter by service model device group tag (e.g. 'Scheduled Service', 'Always There').
     */
    serviceModelDeviceGroupTag?: string;
    /**
     * Filter by scheduled maintenance device group tag.
     */
    scheduledMaintenanceDeviceGroupTag?: string;
};

export type GetNewDeviceFaultTicketPreviewParams = {
    /**
     * The identity of the device.
     */
    deviceIdentity: string;
};

export type TicketStatusCountsParams = {
    /**
     * JC staff only: view counts for a specific org, or omit for all orgs. Do not use for non-JC staff.
     */
    organisationId?: string;
    /**
     * Filter by service model device group tag (e.g. 'Scheduled Service', 'Always There').
     */
    serviceModelDeviceGroupTag?: string;
};

export type TicketCreateRedirectParams = {
    /**
     * Device
     */
    deviceIdentity?: string;
};

export type GetGroupedUptimeTrendByDeviceParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
    /**
     * A list of device identities (max 10, comma-separated)
     */
    deviceIdentities: string[];
};

export type GetGroupedUptimeTrendByDeviceGroupParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
    /**
     * A list of device group tags (max 10, comma-separated)
     */
    deviceGroupTags: string[];
};

export type GetGlobalUptimeTrendParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
    /**
     * Optional list of device group tags to filter by (comma-separated). If not provided, returns global or org-scoped trend based on user permissions.
     */
    deviceGroupTags?: string[];
};

export type GetAggregatedUptimeParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
    /**
     * Optional list of device group tags to filter by (comma-separated). If not provided, returns global or org-scoped uptime based on user permissions.
     */
    deviceGroupTags?: string[];
};

export type GetGroupedUptimeByConnectorParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
    /**
     * Optional filter to devices in a specific device group (org, site, service model)
     */
    deviceGroupTags?: string[];
};

export type GetGroupedUptimeByDeviceParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
};

export type GetGroupedUptimeBySiteParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
};

export type GetGroupedUptimeByOrgParams = {
    /**
     * Start date (UTC). Defaults to 30 days before 'to' date. Format: yyyy-MM-dd
     */
    from?: string;
    /**
     * End date (UTC), inclusive. Defaults to today. Format: yyyy-MM-dd
     */
    to?: string;
};

export type SetUserAccountOrganisationParams = {
    /**
     * Omit to remove the organisation.
     */
    organisationId?: string;
};

export type SetUserAccountRolesParams = {
    /**
     * Set the user's roles to this comma separated list of RoleIds. Omit to remove all roles.
     */
    roles?: string[];
};

export type SetUserAccountDeviceGroupsParams = {
    /**
     * Set the user's deviceGroups to this comma separated list of DeviceGroupTags. Omit to remove all deice groups.
     */
    deviceGroupTags?: string[];
};

export type GetVehicleModelReferenceModelsParams = {
    /**
     * The make to return models for.
     */
    make: string;
};

export type GetVehicleModelsParams = {
    /**
     * Optional comma-separated list of vehicle makes to filter models by (e.g. make=Tesla,BMW). Omit to return models for all makes.
     */
    make?: string[];
};

export type GetVehicleCumulativeEnergyConsumptionParams = {
    /**
     * Date range from (UTC). Should be a date only, without time component, for intervals above Hour. Defaults to 30 days before 'to' date.
     */
    from: string;
    /**
     * Date range to (UTC). Defaults to today.
     */
    to: string;
    /**
     * Results are aggregated by the requested interval
     */
    interval?: GetVehicleCumulativeEnergyConsumptionInterval;
};

export type GetVehicleCumulativeEnergyConsumptionInterval =
    (typeof GetVehicleCumulativeEnergyConsumptionInterval)[keyof typeof GetVehicleCumulativeEnergyConsumptionInterval];

export const GetVehicleCumulativeEnergyConsumptionInterval = {
    minute: "minute",
    hour: "hour",
    day: "day",
    week: "week",
    month: "month",
} as const;

export type GetVehicleChargeSessionCountParams = {
    /**
     * Date range from (UTC). Should be a date only, without time component, for intervals above Hour. Defaults to 30 days before 'to' date.
     */
    from: string;
    /**
     * Date range to (UTC). Defaults to today.
     */
    to: string;
    /**
     * Results are aggregated by the requested interval
     */
    interval?: GetVehicleChargeSessionCountInterval;
};

export type GetVehicleChargeSessionCountInterval =
    (typeof GetVehicleChargeSessionCountInterval)[keyof typeof GetVehicleChargeSessionCountInterval];

export const GetVehicleChargeSessionCountInterval = {
    minute: "minute",
    hour: "hour",
    day: "day",
    week: "week",
    month: "month",
} as const;

export type GetCumulativeSessionCostParams = {
    /**
     * Date range from (UTC). Should be a date only, without time component, for intervals above Hour. Defaults to 30 days before 'to' date.
     */
    from: string;
    /**
     * Date range to (UTC). Defaults to today.
     */
    to: string;
    /**
     * Results are aggregated by the requested interval
     */
    interval?: GetCumulativeSessionCostInterval;
};

export type GetCumulativeSessionCostInterval =
    (typeof GetCumulativeSessionCostInterval)[keyof typeof GetCumulativeSessionCostInterval];

export const GetCumulativeSessionCostInterval = {
    minute: "minute",
    hour: "hour",
    day: "day",
    week: "week",
    month: "month",
} as const;

export type WebhookTriggerParams = {
    /**
     * If this is a Report webhook, the time to use when generating the report. Eg, use a date in this week, to generate a weekly report for last week
     */
    timestamp?: string;
};
